import {
	BaseEntityNames,
	ChangeSet,
	ChangeSetChangeCaptureType,
	ChangeSetEntityChangeType,
	checkHasBaseEntity,
	ConditionState,
	DRAGGABLE_ELEMENT_TYPES,
	DraggableElementTransfer,
	Element,
	ElementGenerationTarget,
	ElementTransfer,
	ENTITY_WITH_NAMES_TYPES,
	ENTITY_WITH_VALUE_TYPES,
	EntityError,
	EntityId,
	EntityType,
	EntityWithLogicScopeState,
	EntityWithValueState,
	ENTRY_POINT_TYPES,
	EntryPointEntityState,
	ExtensionContextType,
	ExtensionsRegistry,
	flattenElementCalls,
	getEventNameFromDefinition,
	getParentEntryPoint,
	getProject,
	getReferencedIds,
	getScopeOwner,
	IActionInputMapTransfer,
	IActiveBranchHeadResult,
	IArgumentDeclarationTransfer,
	IDefinitionEntityTransfer,
	IEditor,
	IEditorContext,
	initBaseProjectEntity,
	IProjectShallowTransfer,
	IProjectTransfer,
	IValueDescriptorTransfer,
	mockClientProject,
	OperationState,
	PASS_THROUGH_CALLABLE_TYPES,
	PersistChangeSetEntityActionRequestPayload,
	resolveEntityName,
	resolvePrimaryKeyProperty,
	TERMINATION_TYPES,
	TerminationEntityState,
	toCamelCase,
	toPascalCase,
	toProjectLogicContext,
	Traverser,
	UserManagedElementShallowTransfer,
	UserManagedEntityState,
	ValueDescriptorState,
	ValueReadingEntityState,
	ValueWritingEntityState,
	VARIABLE_TYPES,
	ArgumentDeclarationState,
	CallerEntityState,
	CanvasEntityState,
	DefinitionEntityState,
	ExecutableEntityState,
	InputMapState,
	OutputMapState,
	ProjectState,
	PropertyState,
	VariableState,
	createStateFromTypeAndSubscribe,
	EntityState,
	flattenRelatedCanvasElementsOnTheRight,
	getParentCanvasEntity,
	translateLogicErrorCodeShort,
	translateLogicErrorCodeWithEntityName,
	IRegisteredExtension,
	ChangeSetEvent,
	toSentenceCase,
	lowercaseFirstLetter,
	TerminationInputMapState,
	IPropertyTransfer,
	DataTypeState,
	FunctionDeclarationState,
	findNextAvailableName,
	IPublicationRunContext,
	VariableInputMapState,
	getDeclaration,
	EntityVersion,
	DefaultProjectLogicContext,
	getTouchedCanvasEntitiesFromChangeSet,
	PersistChangeSetEntityActionPayload,
	orderEntitiesForTraversalAsync,
	filterOutDuplicateErrorsAsync,
	DataTypeParentEntityState,
	ProjectStateEvents,
	mapRecord,
	getReferenceEntityId,
	IProjectReference,
	IDefinitionEntityShallowTransfer,
	flattenNodeAsRecord,
	CallableEntityState,
	PassThroughCallableEntityState,
	IEnvConfig,
	IBranch,
	StateMutationAction,
	READABLE_ENTITY_TYPES,
	toKebabCase,
	cloneProjectAsync,
	flattenElementCallsAsync
} from '@elyx-code/project-logic-tree';
import {
	Canvas as CanvasLib,
	CanvasObject,
	Connection,
	DraggableObject,
	getElementBoundingBoxInCanvasCoordinates
} from '../../lib/canvas';
import {
	CANVAS_CARD_WIDTH,
	getCanvasEntityDOMId,
	getCreateEntityMenuHeaderNodeId,
	getCreateEntityMenuMainValueInputNodeId,
	getCreateEntityMenuMainValueOutputNodeId,
	getCreateEntityMenuSuccessNodeId,
	getCanvasEntityNewOutputButtonDOMId,
	getCanvasEntityNewInputButtonDOMId,
	getInputValueDescriptorIdFromNewDynamicInputButtonDOMId,
	getCanvasEntityDraggableContainerDOMId,
	getEntityIdFromCanvasId,
	getCanvasEntityExecutionNodeId,
	getCanvasEntityEntryCallerNodeDOMId,
	getCanvasEntityErrorCallerNodeDOMId,
	getCanvasEntitySuccessCallerNodeDOMId
} from './ui';
import { toCanvasFlatArray } from './layout';
import { IConnectionOptions, ICoordinates } from '../../lib/canvas/defs';
import { popupNotification } from '../../popup-notification';
import {
	parseSpreadsheetRangeToGridRange,
	resolveSheetMetadata
} from './spreadsheet-range';
import { Test } from '../execution/test-instance';
import { UploadManagerService } from '../cloud-file-system/UploadManagerService';
import { MoveManagerService } from '../cloud-file-system/MoveManagerService';
import { Area } from './area';
import notifications, {
	NotificationActionType,
	NotificationSeverity
} from '../notifications';
import { LocalRelationalDatabasesStore } from '../local-relational-database';
import {
	applyConnectionCompatibilityAutoFixes,
	connectEntitiesBasedOnConenctionType,
	entitiesToUniqueCanvasEntities,
	filterOutNonCanvasEntities,
	getIncompatibleConnectionEntitiesAsync,
	IConnectionCompatibleOptions,
	IConnectionIncompatibleOptions,
	initializeNewInputDeclarationForSearch
} from './utils';
import {
	getAccessToken,
	getCurrentUserOrLogoutRedirect,
	getRefreshToken
} from '../../auth';
import {
	DynamicValueTypes,
	EfimeralValueStore,
	generatePlaceholderValueStore,
	IDynamicValue,
	LocalBrowserValueStore
} from './value-store';
import {
	CanvasEntityElement,
	CanvasMenuElement,
	ICanvasElementOptions
} from './CanvasElement';
import {
	connectEntryCallerToExecutionNode,
	connectSuccessToExecutionNode,
	setupEntityConnectionsInCanvas
} from './connections';
import { CanvasConnectionDeleteButtonElement } from './CanvasElementConnectionDeleteButton';
import axios from 'axios';
import {
	handleLiteralValueDelete,
	IValueResolutionContext,
	resolveValue
} from '../execution/value-resolution';
import CanvasPopup from './CanvasPopup';
import {
	addUndoEventListener,
	increaseIndexValueInInput,
	setUndoableIndexValue,
	removeUndoEventListener
} from '../../lib/canvas/canvas-undo-redo';
import dayjs from 'dayjs';
import { Execution, TestableEntityState } from '../execution';
import {
	DTOAction,
	GenericEventName,
	IDeploymentStepDefinition,
	ILiveMessageDTO,
	ILog,
	InfrastructureResource,
	IPublication,
	IRichProjectRoleDTO,
	IWorkspace,
	IWSSessionChannelSubscription,
	LiveMessageEventType,
	ProjectPublicationEventName,
	PublicationStatus,
	UserProjectRole
} from '@elyx-code/definitions';
import { PublicationRun } from './publication/publication';
import {
	Events,
	IWebsocketsClient,
	Logger,
	LoggerInstance,
	YieldOptions,
	YieldTracker
} from '@elyx-code/common-ts-utils';
import { SearchNodeImplementationModule } from './modules/search-node-implementation';
import {
	BuiltInFunctionImplementationDeletePersistedEntityModule,
	BuiltInFunctionImplementationCreatePersistedEntityModule,
	BuiltInFunctionImplementationUpdatePersistedEntityModule
} from './modules/built-in-function-implementations';
import { ExternalIntegrationsService } from '../integrations/ExternalIntegrationsService';
import { SQLMigrationsGenerationModule } from './modules/sql-migrations-generation';
import { EditorUIContext } from './editor-ui-extensions-context';
import { IDialogProps } from '../../lib/dialog/Dialog';
import { IComponentLifecycleProps } from '../../utils/react';
import { ISmallDialogProps } from '../../lib/dialog/SmallDialog';
import { debounce, download } from '../../utils';
import { envConfig } from '../../config';
import ENTITIES_METADATA_JSON from './entities-metadata.json';

// export class OperationsImplementationsGoogleSheetsAddBandingModule
// 	extends BaseRegisteredExtension
// 	implements IRegisteredExtension<OperationsImplementation>
// {
// 	manifest: ExtensionManifest = {
// 		id:
// 			BUILT_IN_FUNCTION_IMPLEMENTATIONS__PREFIX +
// 			ExternalIntegrationOperations.GoogleSheetsAddBanding,
// 		version: '1.0.0',
// 		description:
// 			'Add Banding Google Sheets operation implementation module',
// 		initPriority: ExtentionPriority.High,
// 		permissions: [ExtensionPermissions.All],
// 		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
// 	};

// 	module = {
// 		init: (
// 			contexts: (DefaultEditorContext | DefaultProjectLogicContext)[]
// 		) => {
// 			const projectState = contexts.find(
// 				(c) => c.contextType === ExtensionContextType.Logic
// 			) as DefaultProjectLogicContext;
// 			if (projectState) {
// 				const operation = projectState.get(
// 					ExternalIntegrationOperations.GoogleSheetsAddBanding
// 				) as ActionDescriptorState;
// 				if (operation) {
// 					operation.implementation = this.module.main;
// 				}
// 			}
// 		},

// 		main: async (
// 			entity: OperationState,
// 			inputs: IDynamicValue[]
// 		): Promise<IPrimitiveExecutionResult> => {
// 			try {
// 				const editorContext = this.extensionsRegistry.requestContexts(
// 					this,
// 					[ExtensionContextType.Editor]
// 				)[0] as IEditorContext;

// 				if (!editorContext || !editorContext.env) {
// 					throw new Error('Editor context or environment missing');
// 				}

// 				const operationCodeName = safeResolveEntityCodeName(
// 					entity,
// 					entity.project,
// 					'addBanding'
// 				);

// 				const operationName = safeResolveEntityName(
// 					entity,
// 					entity.project,
// 					'Add Banding'
// 				);

// 				const errorPrefix =
// 					'[' + operationName + ': `' + operationCodeName + '`] ';

// 				const getErrorInputName = (
// 					dv: any,
// 					defaultName: string,
// 					defaultCodeName: string
// 				) => {
// 					const name = safeResolveEntityName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultName
// 					);
// 					const codeName = safeResolveEntityCodeName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultCodeName
// 					);
// 					return `"${name}" (\`${codeName}\`)`;
// 				};

// 				// --- Connection ---
// 				const connectionDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.connection.id
// 				);
// 				const connectionEntity = connectionDynamicValue?.value
// 					?.valueAsType as DefinitionEntityState;

// 				if (
// 					!connectionEntity ||
// 					!connectionEntity.id ||
// 					!connectionEntity.name ||
// 					connectionEntity.type !== EntityType.DefinitionEntity
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is missing or invalid. Expected a valid connection entity.`
// 					);
// 				}

// 				const connectionId =
// 					getConnectionIdFromDefinitionEntity(connectionEntity);
// 				if (!connectionId) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is invalid, it is missing the underlying Connection ID value.`
// 					);
// 				}

// 				// --- Spreadsheet ID ---
// 				const spreadsheetIdDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.spreadsheetId.id
// 				);
// 				const rawSpreadsheetId =
// 					spreadsheetIdDynamicValue?.value?.value;

// 				const spreadsheetId = parseSpreadsheetId(rawSpreadsheetId, {
// 					errorPrefix: `${errorPrefix}The ${getErrorInputName(spreadsheetIdDynamicValue, 'Spreadsheet ID', 'spreadsheetId')} input `
// 				});

// 				// --- bandedRange ---
// 				const bandedRangeDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.bandedRange.id
// 				);
// 				const bandedRange = bandedRangeDynamicValue?.value?.value;

// 				if (bandedRange === undefined || bandedRange === null) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(bandedRangeDynamicValue, 'bandedRange', 'bandedRange')} input is missing.`
// 					);
// 				}

// 				// --- Banding Orientation ---
// 				const bandingOrientationDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.bandingOrientation?.id
// 				);
// 				const rawBandingOrientation =
// 					bandingOrientationDynamicValue?.value?.value;
// 				const bandingOrientationVal =
// 					typeof rawBandingOrientation === 'string'
// 						? rawBandingOrientation
// 						: 'Rows';

// 				if (
// 					!['Rows', 'Columns', 'Grid'].includes(bandingOrientationVal)
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(bandingOrientationDynamicValue, 'Banding Orientation', 'bandingOrientation')} input must be one of "Rows", "Columns", or "Grid". Received: "${bandingOrientationVal}".`
// 					);
// 				}

// 				// --- Color Inputs ---
// 				const headerColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.headerColor?.id
// 				);
// 				const headerColorVal = headerColorDynamicValue?.value?.value;

// 				const firstBandColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.firstBandColor?.id
// 				);
// 				const firstBandColorVal =
// 					firstBandColorDynamicValue?.value?.value;

// 				const secondBandColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.secondBandColor?.id
// 				);
// 				const secondBandColorVal =
// 					secondBandColorDynamicValue?.value?.value;

// 				const footerColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.footerColor?.id
// 				);
// 				const footerColorVal = footerColorDynamicValue?.value?.value;

// 				const gridBandColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.gridBandColor?.id
// 				);
// 				const gridBandColorVal =
// 					gridBandColorDynamicValue?.value?.value;

// 				const deleteConflictingBandingDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations.GoogleSheetsAddBanding
// 						].inputs.deleteConflictingBanding?.id
// 				);
// 				const deleteConflictingBandingVal =
// 					deleteConflictingBandingDynamicValue?.value?.value ?? true;

// 				const accessToken = await editorContext.getAccessToken();
// 				const authHeaders = { Authorization: `Bearer ${accessToken}` };
// 				const baseUrl = `${editorContext.env?.API_BASE_URL}/editor-runtime/v2/external-integrations/generic-proxy/${editorContext.projectId}/${ExternalIntegrationNames['google-sheet']}/${connectionId}`;

// 				const proxy = async (cfg: any) => {
// 					return axios.post(baseUrl, cfg, { headers: authHeaders });
// 				};

// 				let existingBandedRanges: any[] = [];
// 				let fetchedSheets: any[] = [];
// 				try {
// 					const metaRes = await proxy({
// 						method: 'GET',
// 						endpoint: `/v4/spreadsheets/${spreadsheetId}?fields=sheets(properties(sheetId,title),bandedRanges)`
// 					});
// 					fetchedSheets = metaRes.data.sheets || [];
// 				} catch (e) {}

// 				const resolvedRange = await resolveSheetMetadata(
// 					bandedRange,
// 					'Id',
// 					async () => {
// 						return fetchedSheets.map((s: any) => ({
// 							id: s.properties.sheetId,
// 							name: s.properties.title
// 						}));
// 					}
// 				);
// 				const gridRange = parseSpreadsheetRangeToGridRange(
// 					resolvedRange,
// 					{
// 						errorPrefix: `${errorPrefix}The ${getErrorInputName(bandedRangeDynamicValue, 'bandedRange', 'bandedRange')} input `
// 					}
// 				);
// 				let targetSheet: any = null;
// 				if (
// 					gridRange.sheetId !== undefined &&
// 					gridRange.sheetId !== null
// 				) {
// 					targetSheet = fetchedSheets.find(
// 						(s: any) => s.properties?.sheetId === gridRange.sheetId
// 					);
// 				} else if (
// 					resolvedRange &&
// 					resolvedRange.sheet !== undefined &&
// 					resolvedRange.sheet !== null &&
// 					resolvedRange.sheet !== ''
// 				) {
// 					const sheetStr = String(resolvedRange.sheet)
// 						.trim()
// 						.toLowerCase();
// 					targetSheet = fetchedSheets.find(
// 						(s: any) =>
// 							String(s.properties?.title).trim().toLowerCase() ===
// 								sheetStr ||
// 							String(s.properties?.sheetId) === sheetStr
// 					);
// 					if (!targetSheet) {
// 						throw new Error(
// 							`${errorPrefix}Sheet "${resolvedRange.sheet}" was not found in the spreadsheet.`
// 						);
// 					}
// 					gridRange.sheetId = targetSheet.properties.sheetId;
// 				} else {
// 					targetSheet = fetchedSheets[0];
// 					gridRange.sheetId = targetSheet?.properties?.sheetId ?? 0;
// 				}

// 				if (
// 					gridRange.startRowIndex === undefined &&
// 					gridRange.endRowIndex === undefined &&
// 					gridRange.startColumnIndex === undefined &&
// 					gridRange.endColumnIndex === undefined
// 				) {
// 					gridRange.startRowIndex = 0;
// 					gridRange.endRowIndex = 100;
// 					gridRange.startColumnIndex = 0;
// 					gridRange.endColumnIndex = 26;
// 				}

// 				if (targetSheet?.bandedRanges) {
// 					existingBandedRanges = targetSheet.bandedRanges;
// 				}

// 				const bandedRangeObj: any = {
// 					range: gridRange
// 				};

// 				const parsedHeaderColor = rgbaToGoogleSheetsColor(
// 					headerColorVal as any
// 				);
// 				const parsedFirstBandColor = rgbaToGoogleSheetsColor(
// 					firstBandColorVal as any
// 				);
// 				const parsedSecondBandColor = rgbaToGoogleSheetsColor(
// 					secondBandColorVal as any
// 				);
// 				const parsedFooterColor = rgbaToGoogleSheetsColor(
// 					footerColorVal as any
// 				);
// 				const parsedGridBandColor = rgbaToGoogleSheetsColor(
// 					gridBandColorVal as any
// 				);

// 				const rowProperties: any = {
// 					firstBandColor: parsedFirstBandColor || {
// 						red: 1,
// 						green: 1,
// 						blue: 1,
// 						alpha: 1
// 					},
// 					secondBandColor: parsedSecondBandColor || {
// 						red: 0.95,
// 						green: 0.95,
// 						blue: 0.95,
// 						alpha: 1
// 					}
// 				};
// 				if (parsedHeaderColor)
// 					rowProperties.headerColor = parsedHeaderColor;
// 				if (parsedFooterColor)
// 					rowProperties.footerColor = parsedFooterColor;

// 				const columnProperties: any = {
// 					firstBandColor:
// 						bandingOrientationVal === 'Grid'
// 							? parsedGridBandColor ||
// 								parsedFirstBandColor || {
// 									red: 1,
// 									green: 1,
// 									blue: 1,
// 									alpha: 1
// 								}
// 							: parsedFirstBandColor || {
// 									red: 1,
// 									green: 1,
// 									blue: 1,
// 									alpha: 1
// 								},
// 					secondBandColor:
// 						bandingOrientationVal === 'Grid'
// 							? parsedGridBandColor ||
// 								parsedSecondBandColor || {
// 									red: 0.95,
// 									green: 0.95,
// 									blue: 0.95,
// 									alpha: 1
// 								}
// 							: parsedSecondBandColor || {
// 									red: 0.95,
// 									green: 0.95,
// 									blue: 0.95,
// 									alpha: 1
// 								}
// 				};
// 				if (parsedHeaderColor)
// 					columnProperties.headerColor = parsedHeaderColor;
// 				if (parsedFooterColor)
// 					columnProperties.footerColor = parsedFooterColor;

// 				if (bandingOrientationVal === 'Grid') {
// 					bandedRangeObj.rowProperties = rowProperties;
// 					bandedRangeObj.columnProperties = columnProperties;
// 				} else if (bandingOrientationVal === 'Columns') {
// 					bandedRangeObj.columnProperties = columnProperties;
// 				} else {
// 					bandedRangeObj.rowProperties = rowProperties;
// 				}

// 				const requests: any[] = [];
// 				if (deleteConflictingBandingVal) {
// 					for (const existing of existingBandedRanges) {
// 						if (existing.bandedRangeId !== undefined) {
// 							requests.push({
// 								deleteBanding: {
// 									bandedRangeId: existing.bandedRangeId
// 								}
// 							});
// 						}
// 					}
// 				}
// 				requests.push({
// 					addBanding: {
// 						bandedRange: bandedRangeObj
// 					}
// 				});

// 				const batchRes = await proxy({
// 					method: 'POST',
// 					endpoint: `/v4/spreadsheets/${spreadsheetId}:batchUpdate`,
// 					data: {
// 						requests
// 					}
// 				});

// 				const addBandingReply = batchRes.data?.replies?.find(
// 					(r: any) => r.addBanding
// 				);
// 				const createdBandedRangeId =
// 					addBandingReply?.addBanding?.bandedRange?.bandedRangeId;

// 				return {
// 					value: ExecutionTerminationType.Success,
// 					result: {
// 						bandedRangeId: createdBandedRangeId
// 					},
// 					error: null
// 				};
// 			} catch (e: any) {
// 				const errorData = e.response?.data || e.message || e;
// 				Logger.log('[Google Sheets] error:', errorData);
// 				return {
// 					value:
// 						entity.catchesError || entity.errorCalls.length
// 							? ExecutionTerminationType.CaughtError
// 							: ExecutionTerminationType.UnhandledError,
// 					error: errorData,
// 					result: null
// 				};
// 			}
// 		}
// 	};
// }

// export class OperationsImplementationsGoogleSheetsUpdateBandingModule
// 	extends BaseRegisteredExtension
// 	implements IRegisteredExtension<OperationsImplementation>
// {
// 	manifest: ExtensionManifest = {
// 		id:
// 			BUILT_IN_FUNCTION_IMPLEMENTATIONS__PREFIX +
// 			ExternalIntegrationOperations.GoogleSheetsUpdateBanding,
// 		version: '1.0.0',
// 		description:
// 			'Update Banding Google Sheets operation implementation module',
// 		initPriority: ExtentionPriority.High,
// 		permissions: [ExtensionPermissions.All],
// 		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
// 	};

// 	module = {
// 		init: (
// 			contexts: (DefaultEditorContext | DefaultProjectLogicContext)[]
// 		) => {
// 			const projectState = contexts.find(
// 				(c) => c.contextType === ExtensionContextType.Logic
// 			) as DefaultProjectLogicContext;
// 			if (projectState) {
// 				const operation = projectState.get(
// 					ExternalIntegrationOperations.GoogleSheetsUpdateBanding
// 				) as ActionDescriptorState;
// 				if (operation) {
// 					operation.implementation = this.module.main;
// 				}
// 			}
// 		},

// 		main: async (
// 			entity: OperationState,
// 			inputs: IDynamicValue[]
// 		): Promise<IPrimitiveExecutionResult> => {
// 			try {
// 				const editorContext = this.extensionsRegistry.requestContexts(
// 					this,
// 					[ExtensionContextType.Editor]
// 				)[0] as IEditorContext;

// 				if (!editorContext || !editorContext.env) {
// 					throw new Error('Editor context or environment missing');
// 				}

// 				const operationCodeName = safeResolveEntityCodeName(
// 					entity,
// 					entity.project,
// 					'updateBanding'
// 				);

// 				const operationName = safeResolveEntityName(
// 					entity,
// 					entity.project,
// 					'Update Banding'
// 				);

// 				const errorPrefix =
// 					'[' + operationName + ': `' + operationCodeName + '`] ';

// 				const getErrorInputName = (
// 					dv: any,
// 					defaultName: string,
// 					defaultCodeName: string
// 				) => {
// 					const name = safeResolveEntityName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultName
// 					);
// 					const codeName = safeResolveEntityCodeName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultCodeName
// 					);
// 					return `"${name}" (\`${codeName}\`)`;
// 				};

// 				// --- Connection ---
// 				const connectionDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.connection.id
// 				);
// 				const connectionEntity = connectionDynamicValue?.value
// 					?.valueAsType as DefinitionEntityState;

// 				if (
// 					!connectionEntity ||
// 					!connectionEntity.id ||
// 					!connectionEntity.name ||
// 					connectionEntity.type !== EntityType.DefinitionEntity
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is missing or invalid. Expected a valid connection entity.`
// 					);
// 				}

// 				const connectionId =
// 					getConnectionIdFromDefinitionEntity(connectionEntity);
// 				if (!connectionId) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is invalid, it is missing the underlying Connection ID value.`
// 					);
// 				}

// 				// --- Spreadsheet ID ---
// 				const spreadsheetIdDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.spreadsheetId.id
// 				);
// 				const rawSpreadsheetId =
// 					spreadsheetIdDynamicValue?.value?.value;

// 				const spreadsheetId = parseSpreadsheetId(rawSpreadsheetId, {
// 					errorPrefix: `${errorPrefix}The ${getErrorInputName(spreadsheetIdDynamicValue, 'Spreadsheet ID', 'spreadsheetId')} input `
// 				});

// 				// --- Banded Range ID ---
// 				const bandedRangeIdDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.bandedRangeId.id
// 				);
// 				const rawBandedRangeId =
// 					bandedRangeIdDynamicValue?.value?.value;
// 				if (
// 					rawBandedRangeId === undefined ||
// 					rawBandedRangeId === null ||
// 					rawBandedRangeId === ''
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(bandedRangeIdDynamicValue, 'Banded Range ID', 'bandedRangeId')} input is missing.`
// 					);
// 				}
// 				const bandedRangeId = Number(rawBandedRangeId);

// 				// --- bandedRange (Optional) ---
// 				const bandedRangeDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.bandedRange?.id
// 				);
// 				const bandedRange = bandedRangeDynamicValue?.value?.value;

// 				// --- Banding Orientation ---
// 				const bandingOrientationDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.bandingOrientation?.id
// 				);
// 				const bandingOrientationVal =
// 					bandingOrientationDynamicValue?.value?.value;

// 				// --- Color Inputs ---
// 				const headerColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.headerColor?.id
// 				);
// 				const headerColorVal = headerColorDynamicValue?.value?.value;

// 				const firstBandColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.firstBandColor?.id
// 				);
// 				const firstBandColorVal =
// 					firstBandColorDynamicValue?.value?.value;

// 				const secondBandColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.secondBandColor?.id
// 				);
// 				const secondBandColorVal =
// 					secondBandColorDynamicValue?.value?.value;

// 				const footerColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.footerColor?.id
// 				);
// 				const footerColorVal = footerColorDynamicValue?.value?.value;

// 				const gridBandColorDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsUpdateBanding
// 						].inputs.gridBandColor?.id
// 				);
// 				const gridBandColorVal =
// 					gridBandColorDynamicValue?.value?.value;

// 				const accessToken = await editorContext.getAccessToken();
// 				const authHeaders = { Authorization: `Bearer ${accessToken}` };
// 				const baseUrl = `${editorContext.env?.API_BASE_URL}/editor-runtime/v2/external-integrations/generic-proxy/${editorContext.projectId}/${ExternalIntegrationNames['google-sheet']}/${connectionId}`;

// 				const proxy = async (cfg: any) => {
// 					return axios.post(baseUrl, cfg, { headers: authHeaders });
// 				};

// 				let fetchedSheets: any[] = [];
// 				try {
// 					const metaRes = await proxy({
// 						method: 'GET',
// 						endpoint: `/v4/spreadsheets/${spreadsheetId}?fields=sheets(properties(sheetId,title),bandedRanges)`
// 					});
// 					fetchedSheets = metaRes.data.sheets || [];
// 				} catch (e) {}

// 				const allBandedRanges: Array<{ sheet: any; band: any }> = [];
// 				for (const s of fetchedSheets) {
// 					if (s.bandedRanges) {
// 						for (const b of s.bandedRanges) {
// 							allBandedRanges.push({ sheet: s, band: b });
// 						}
// 					}
// 				}

// 				const existingEntry = allBandedRanges.find(
// 					(e) =>
// 						Number(e.band.bandedRangeId) === Number(bandedRangeId)
// 				);

// 				if (allBandedRanges.length > 0 && !existingEntry) {
// 					throw new Error(
// 						`${errorPrefix}No Banded Range with ID "${bandedRangeId}" was found in the sheet.`
// 					);
// 				}

// 				const existingBand = existingEntry?.band;

// 				const bandedRangeObj: any = {
// 					bandedRangeId
// 				};

// 				if (bandedRange) {
// 					const resolvedRange = await resolveSheetMetadata(
// 						bandedRange,
// 						'Id',
// 						async () => {
// 							return fetchedSheets.map((s: any) => ({
// 								id: s.properties.sheetId,
// 								name: s.properties.title
// 							}));
// 						}
// 					);
// 					const gridRange = parseSpreadsheetRangeToGridRange(
// 						resolvedRange,
// 						{
// 							errorPrefix: `${errorPrefix}The ${getErrorInputName(bandedRangeDynamicValue, 'bandedRange', 'bandedRange')} input `
// 						}
// 					);
// 					if (
// 						gridRange.sheetId === undefined ||
// 						gridRange.sheetId === null
// 					) {
// 						gridRange.sheetId = 0;
// 					}
// 					bandedRangeObj.range = gridRange;
// 				} else if (existingBand?.range) {
// 					bandedRangeObj.range = existingBand.range;
// 				}

// 				const inferredOrientation =
// 					existingBand?.rowProperties &&
// 					existingBand?.columnProperties
// 						? 'Grid'
// 						: existingBand?.columnProperties
// 							? 'Columns'
// 							: 'Rows';

// 				const effectiveOrientation =
// 					bandingOrientationVal || inferredOrientation;

// 				const parsedHeaderColor = rgbaToGoogleSheetsColor(
// 					headerColorVal as any
// 				);
// 				const parsedFirstBandColor = rgbaToGoogleSheetsColor(
// 					firstBandColorVal as any
// 				);
// 				const parsedSecondBandColor = rgbaToGoogleSheetsColor(
// 					secondBandColorVal as any
// 				);
// 				const parsedFooterColor = rgbaToGoogleSheetsColor(
// 					footerColorVal as any
// 				);
// 				const parsedGridBandColor = rgbaToGoogleSheetsColor(
// 					gridBandColorVal as any
// 				);

// 				const existingRow = existingBand?.rowProperties || {};
// 				const existingCol = existingBand?.columnProperties || {};

// 				const rowProperties: any = {
// 					firstBandColor: parsedFirstBandColor ||
// 						existingRow.firstBandColor || {
// 							red: 1,
// 							green: 1,
// 							blue: 1,
// 							alpha: 1
// 						},
// 					secondBandColor: parsedSecondBandColor ||
// 						existingRow.secondBandColor || {
// 							red: 0.95,
// 							green: 0.95,
// 							blue: 0.95,
// 							alpha: 1
// 						}
// 				};
// 				const finalRowHeader =
// 					parsedHeaderColor || existingRow.headerColor;
// 				if (finalRowHeader) rowProperties.headerColor = finalRowHeader;
// 				const finalRowFooter =
// 					parsedFooterColor || existingRow.footerColor;
// 				if (finalRowFooter) rowProperties.footerColor = finalRowFooter;

// 				const columnProperties: any = {
// 					firstBandColor:
// 						effectiveOrientation === 'Grid'
// 							? parsedGridBandColor ||
// 								parsedFirstBandColor ||
// 								existingCol.firstBandColor || {
// 									red: 1,
// 									green: 1,
// 									blue: 1,
// 									alpha: 1
// 								}
// 							: parsedFirstBandColor ||
// 								existingCol.firstBandColor || {
// 									red: 1,
// 									green: 1,
// 									blue: 1,
// 									alpha: 1
// 								},
// 					secondBandColor:
// 						effectiveOrientation === 'Grid'
// 							? parsedGridBandColor ||
// 								parsedSecondBandColor ||
// 								existingCol.secondBandColor || {
// 									red: 0.95,
// 									green: 0.95,
// 									blue: 0.95,
// 									alpha: 1
// 								}
// 							: parsedSecondBandColor ||
// 								existingCol.secondBandColor || {
// 									red: 0.95,
// 									green: 0.95,
// 									blue: 0.95,
// 									alpha: 1
// 								}
// 				};
// 				const finalColHeader =
// 					parsedHeaderColor || existingCol.headerColor;
// 				if (finalColHeader)
// 					columnProperties.headerColor = finalColHeader;
// 				const finalColFooter =
// 					parsedFooterColor || existingCol.footerColor;
// 				if (finalColFooter)
// 					columnProperties.footerColor = finalColFooter;

// 				if (effectiveOrientation === 'Grid') {
// 					bandedRangeObj.rowProperties = rowProperties;
// 					bandedRangeObj.columnProperties = columnProperties;
// 				} else if (effectiveOrientation === 'Columns') {
// 					bandedRangeObj.columnProperties = columnProperties;
// 				} else {
// 					bandedRangeObj.rowProperties = rowProperties;
// 				}

// 				await proxy({
// 					method: 'POST',
// 					endpoint: `/v4/spreadsheets/${spreadsheetId}:batchUpdate`,
// 					data: {
// 						requests: [
// 							{
// 								updateBanding: {
// 									bandedRange: bandedRangeObj,
// 									fields: '*'
// 								}
// 							}
// 						]
// 					}
// 				});

// 				return {
// 					value: ExecutionTerminationType.Success,
// 					result: null,
// 					error: null
// 				};
// 			} catch (e: any) {
// 				const errorData = e.response?.data || e.message || e;
// 				Logger.log('[Google Sheets] error:', errorData);
// 				return {
// 					value:
// 						entity.catchesError || entity.errorCalls.length
// 							? ExecutionTerminationType.CaughtError
// 							: ExecutionTerminationType.UnhandledError,
// 					error: errorData,
// 					result: null
// 				};
// 			}
// 		}
// 	};
// }

// export class OperationsImplementationsGoogleSheetsDeleteBandingModule
// 	extends BaseRegisteredExtension
// 	implements IRegisteredExtension<OperationsImplementation>
// {
// 	manifest: ExtensionManifest = {
// 		id:
// 			BUILT_IN_FUNCTION_IMPLEMENTATIONS__PREFIX +
// 			ExternalIntegrationOperations.GoogleSheetsDeleteBanding,
// 		version: '1.0.0',
// 		description:
// 			'Delete Banding Google Sheets operation implementation module',
// 		initPriority: ExtentionPriority.High,
// 		permissions: [ExtensionPermissions.All],
// 		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
// 	};

// 	module = {
// 		init: (
// 			contexts: (DefaultEditorContext | DefaultProjectLogicContext)[]
// 		) => {
// 			const projectState = contexts.find(
// 				(c) => c.contextType === ExtensionContextType.Logic
// 			) as DefaultProjectLogicContext;
// 			if (projectState) {
// 				const operation = projectState.get(
// 					ExternalIntegrationOperations.GoogleSheetsDeleteBanding
// 				) as ActionDescriptorState;
// 				if (operation) {
// 					operation.implementation = this.module.main;
// 				}
// 			}
// 		},

// 		main: async (
// 			entity: OperationState,
// 			inputs: IDynamicValue[]
// 		): Promise<IPrimitiveExecutionResult> => {
// 			try {
// 				const editorContext = this.extensionsRegistry.requestContexts(
// 					this,
// 					[ExtensionContextType.Editor]
// 				)[0] as IEditorContext;

// 				if (!editorContext || !editorContext.env) {
// 					throw new Error('Editor context or environment missing');
// 				}

// 				const operationCodeName = safeResolveEntityCodeName(
// 					entity,
// 					entity.project,
// 					'deleteBanding'
// 				);

// 				const operationName = safeResolveEntityName(
// 					entity,
// 					entity.project,
// 					'Delete Banding'
// 				);

// 				const errorPrefix =
// 					'[' + operationName + ': `' + operationCodeName + '`] ';

// 				const getErrorInputName = (
// 					dv: any,
// 					defaultName: string,
// 					defaultCodeName: string
// 				) => {
// 					const name = safeResolveEntityName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultName
// 					);
// 					const codeName = safeResolveEntityCodeName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultCodeName
// 					);
// 					return `"${name}" (\`${codeName}\`)`;
// 				};

// 				// --- Connection ---
// 				const connectionDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsDeleteBanding
// 						].inputs.connection.id
// 				);
// 				const connectionEntity = connectionDynamicValue?.value
// 					?.valueAsType as DefinitionEntityState;

// 				if (
// 					!connectionEntity ||
// 					!connectionEntity.id ||
// 					!connectionEntity.name ||
// 					connectionEntity.type !== EntityType.DefinitionEntity
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is missing or invalid. Expected a valid connection entity.`
// 					);
// 				}

// 				const connectionId =
// 					getConnectionIdFromDefinitionEntity(connectionEntity);
// 				if (!connectionId) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is invalid, it is missing the underlying Connection ID value.`
// 					);
// 				}

// 				// --- Spreadsheet ID ---
// 				const spreadsheetIdDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsDeleteBanding
// 						].inputs.spreadsheetId.id
// 				);
// 				const rawSpreadsheetId =
// 					spreadsheetIdDynamicValue?.value?.value;

// 				const spreadsheetId = parseSpreadsheetId(rawSpreadsheetId, {
// 					errorPrefix: `${errorPrefix}The ${getErrorInputName(spreadsheetIdDynamicValue, 'Spreadsheet ID', 'spreadsheetId')} input `
// 				});

// 				// --- Banded Range ID ---
// 				const bandedRangeIdDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsDeleteBanding
// 						].inputs.bandedRangeId.id
// 				);
// 				const rawBandedRangeId =
// 					bandedRangeIdDynamicValue?.value?.value;
// 				if (
// 					rawBandedRangeId === undefined ||
// 					rawBandedRangeId === null ||
// 					rawBandedRangeId === ''
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(bandedRangeIdDynamicValue, 'Banded Range ID', 'bandedRangeId')} input is missing.`
// 					);
// 				}
// 				const bandedRangeId = Number(rawBandedRangeId);

// 				const accessToken = await editorContext.getAccessToken();
// 				const authHeaders = { Authorization: `Bearer ${accessToken}` };
// 				const baseUrl = `${editorContext.env?.API_BASE_URL}/editor-runtime/v2/external-integrations/generic-proxy/${editorContext.projectId}/${ExternalIntegrationNames['google-sheet']}/${connectionId}`;

// 				const proxy = async (cfg: any) => {
// 					return axios.post(baseUrl, cfg, { headers: authHeaders });
// 				};

// 				await proxy({
// 					method: 'POST',
// 					endpoint: `/v4/spreadsheets/${spreadsheetId}:batchUpdate`,
// 					data: {
// 						requests: [
// 							{
// 								deleteBanding: {
// 									bandedRangeId
// 								}
// 							}
// 						]
// 					}
// 				});

// 				return {
// 					value: ExecutionTerminationType.Success,
// 					result: null,
// 					error: null
// 				};
// 			} catch (e: any) {
// 				const errorData = e.response?.data || e.message || e;
// 				Logger.log('[Google Sheets] error:', errorData);
// 				return {
// 					value:
// 						entity.catchesError || entity.errorCalls.length
// 							? ExecutionTerminationType.CaughtError
// 							: ExecutionTerminationType.UnhandledError,
// 					error: errorData,
// 					result: null
// 				};
// 			}
// 		}
// 	};
// }

// export class OperationsImplementationsGoogleSheetsCreatePivotTableModule
// 	extends BaseRegisteredExtension
// 	implements IRegisteredExtension<OperationsImplementation>
// {
// 	manifest: ExtensionManifest = {
// 		id:
// 			BUILT_IN_FUNCTION_IMPLEMENTATIONS__PREFIX +
// 			ExternalIntegrationOperations.GoogleSheetsCreatePivotTable,
// 		version: '1.0.0',
// 		description:
// 			'Create Pivot Table Google Sheets operation implementation module',
// 		initPriority: ExtentionPriority.High,
// 		permissions: [ExtensionPermissions.All],
// 		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
// 	};

// 	module = {
// 		init: (
// 			contexts: (DefaultEditorContext | DefaultProjectLogicContext)[]
// 		) => {
// 			const projectState = contexts.find(
// 				(c) => c.contextType === ExtensionContextType.Logic
// 			) as DefaultProjectLogicContext;
// 			if (projectState) {
// 				const operation = projectState.get(
// 					ExternalIntegrationOperations.GoogleSheetsCreatePivotTable
// 				) as ActionDescriptorState;
// 				if (operation) {
// 					operation.implementation = this.module.main;
// 				}
// 			}
// 		},

// 		main: async (
// 			entity: OperationState,
// 			inputs: IDynamicValue[]
// 		): Promise<IPrimitiveExecutionResult> => {
// 			try {
// 				const editorContext = this.extensionsRegistry.requestContexts(
// 					this,
// 					[ExtensionContextType.Editor]
// 				)[0] as IEditorContext;

// 				if (!editorContext || !editorContext.env) {
// 					throw new Error('Editor context or environment missing');
// 				}

// 				const operationCodeName = safeResolveEntityCodeName(
// 					entity,
// 					entity.project,
// 					'createPivotTable'
// 				);

// 				const operationName = safeResolveEntityName(
// 					entity,
// 					entity.project,
// 					'Create Pivot Table'
// 				);

// 				const errorPrefix =
// 					'[' + operationName + ': `' + operationCodeName + '`] ';

// 				const getErrorInputName = (
// 					dv: any,
// 					defaultName: string,
// 					defaultCodeName: string
// 				) => {
// 					const name = safeResolveEntityName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultName
// 					);
// 					const codeName = safeResolveEntityCodeName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultCodeName
// 					);
// 					return `"${name}" (\`${codeName}\`)`;
// 				};

// 				// --- Connection ---
// 				const connectionDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsCreatePivotTable
// 						].inputs.connection.id
// 				);
// 				const connectionEntity = connectionDynamicValue?.value
// 					?.valueAsType as DefinitionEntityState;

// 				if (
// 					!connectionEntity ||
// 					!connectionEntity.id ||
// 					!connectionEntity.name ||
// 					connectionEntity.type !== EntityType.DefinitionEntity
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is missing or invalid. Expected a valid connection entity.`
// 					);
// 				}

// 				const connectionId =
// 					getConnectionIdFromDefinitionEntity(connectionEntity);
// 				if (!connectionId) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is invalid, it is missing the underlying Connection ID value.`
// 					);
// 				}

// 				// --- Spreadsheet ID ---
// 				const spreadsheetIdDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsCreatePivotTable
// 						].inputs.spreadsheetId.id
// 				);
// 				const rawSpreadsheetId =
// 					spreadsheetIdDynamicValue?.value?.value;

// 				const spreadsheetId = parseSpreadsheetId(rawSpreadsheetId, {
// 					errorPrefix: `${errorPrefix}The ${getErrorInputName(spreadsheetIdDynamicValue, 'Spreadsheet ID', 'spreadsheetId')} input `
// 				});

// 				// --- destination ---
// 				const destinationDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsCreatePivotTable
// 						].inputs.destination.id
// 				);
// 				const destination = destinationDynamicValue?.value?.value;

// 				if (destination === undefined || destination === null) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(destinationDynamicValue, 'destination', 'destination')} input is missing.`
// 					);
// 				}

// 				// --- pivotTable ---
// 				const pivotTableDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsCreatePivotTable
// 						].inputs.pivotTable.id
// 				);
// 				const pivotTable = pivotTableDynamicValue?.value?.value;

// 				if (pivotTable === undefined || pivotTable === null) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(pivotTableDynamicValue, 'pivotTable', 'pivotTable')} input is missing.`
// 					);
// 				}

// 				const accessToken = await editorContext.getAccessToken();
// 				const authHeaders = { Authorization: `Bearer ${accessToken}` };
// 				const baseUrl = `${editorContext.env?.API_BASE_URL}/editor-runtime/v2/external-integrations/generic-proxy/${editorContext.projectId}/${ExternalIntegrationNames['google-sheet']}/${connectionId}`;

// 				const proxy = async (cfg: any) => {
// 					return axios.post(baseUrl, cfg, { headers: authHeaders });
// 				};

// 				let fetchedSheets: any[] = [];
// 				try {
// 					const metaRes = await proxy({
// 						method: 'GET',
// 						endpoint: `/v4/spreadsheets/${spreadsheetId}?fields=sheets(properties(sheetId,title))`
// 					});
// 					fetchedSheets = metaRes.data.sheets || [];
// 				} catch (e) {}

// 				const resolvedDestination = await resolveSheetMetadata(
// 					destination,
// 					'Id',
// 					async () => {
// 						return fetchedSheets.map((s: any) => ({
// 							id: s.properties.sheetId,
// 							name: s.properties.title
// 						}));
// 					}
// 				);
// 				const gridRange = parseSpreadsheetRangeToGridRange(
// 					resolvedDestination,
// 					{
// 						errorPrefix: `${errorPrefix}The ${getErrorInputName(destinationDynamicValue, 'destination', 'destination')} input `
// 					}
// 				);

// 				const start = {
// 					sheetId: gridRange.sheetId ?? 0,
// 					rowIndex: gridRange.startRowIndex ?? 0,
// 					columnIndex: gridRange.startColumnIndex ?? 0
// 				};

// 				let pivotTableObj: any = pivotTable;
// 				if (typeof pivotTable === 'string') {
// 					const trimmed = pivotTable.trim();
// 					if (trimmed.startsWith('{')) {
// 						try {
// 							pivotTableObj = JSON.parse(trimmed);
// 						} catch (e) {
// 							throw new Error(
// 								`${errorPrefix}The ${getErrorInputName(pivotTableDynamicValue, 'pivotTable', 'pivotTable')} input is an invalid JSON string.`
// 							);
// 						}
// 					} else {
// 						throw new Error(
// 							`${errorPrefix}The ${getErrorInputName(pivotTableDynamicValue, 'pivotTable', 'pivotTable')} input must be a PivotTable specification object or JSON string (e.g. {"source": {...}, "rows": [...], "values": [...]}). Received string: "${pivotTable}".`
// 						);
// 					}
// 				}

// 				let requestPayload: any = {
// 					updateCells: {
// 						start,
// 						rows: [
// 							{
// 								values: [
// 									{
// 										pivotTable: pivotTableObj
// 									}
// 								]
// 							}
// 						],
// 						fields: 'pivotTable'
// 					}
// 				};
// 				await proxy({
// 					method: 'POST',
// 					endpoint: `/v4/spreadsheets/${spreadsheetId}:batchUpdate`,
// 					data: {
// 						requests: [requestPayload]
// 					}
// 				});
// 				return {
// 					value: ExecutionTerminationType.Success,
// 					result: null,
// 					error: null
// 				};
// 			} catch (e: any) {
// 				const errorData = e.response?.data || e.message || e;
// 				Logger.log('[Google Sheets] error:', errorData);
// 				return {
// 					value:
// 						entity.catchesError || entity.errorCalls.length
// 							? ExecutionTerminationType.CaughtError
// 							: ExecutionTerminationType.UnhandledError,
// 					error: errorData,
// 					result: null
// 				};
// 			}
// 		}
// 	};
// }

// export class OperationsImplementationsGoogleSheetsDeletePivotTableModule
// 	extends BaseRegisteredExtension
// 	implements IRegisteredExtension<OperationsImplementation>
// {
// 	manifest: ExtensionManifest = {
// 		id:
// 			BUILT_IN_FUNCTION_IMPLEMENTATIONS__PREFIX +
// 			ExternalIntegrationOperations.GoogleSheetsDeletePivotTable,
// 		version: '1.0.0',
// 		description:
// 			'Delete Pivot Table Google Sheets operation implementation module',
// 		initPriority: ExtentionPriority.High,
// 		permissions: [ExtensionPermissions.All],
// 		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
// 	};

// 	module = {
// 		init: (
// 			contexts: (DefaultEditorContext | DefaultProjectLogicContext)[]
// 		) => {
// 			const projectState = contexts.find(
// 				(c) => c.contextType === ExtensionContextType.Logic
// 			) as DefaultProjectLogicContext;
// 			if (projectState) {
// 				const operation = projectState.get(
// 					ExternalIntegrationOperations.GoogleSheetsDeletePivotTable
// 				) as ActionDescriptorState;
// 				if (operation) {
// 					operation.implementation = this.module.main;
// 				}
// 			}
// 		},

// 		main: async (
// 			entity: OperationState,
// 			inputs: IDynamicValue[]
// 		): Promise<IPrimitiveExecutionResult> => {
// 			try {
// 				const editorContext = this.extensionsRegistry.requestContexts(
// 					this,
// 					[ExtensionContextType.Editor]
// 				)[0] as IEditorContext;

// 				if (!editorContext || !editorContext.env) {
// 					throw new Error('Editor context or environment missing');
// 				}

// 				const operationCodeName = safeResolveEntityCodeName(
// 					entity,
// 					entity.project,
// 					'deletePivotTable'
// 				);

// 				const operationName = safeResolveEntityName(
// 					entity,
// 					entity.project,
// 					'Delete Pivot Table'
// 				);

// 				const errorPrefix =
// 					'[' + operationName + ': `' + operationCodeName + '`] ';

// 				const getErrorInputName = (
// 					dv: any,
// 					defaultName: string,
// 					defaultCodeName: string
// 				) => {
// 					const name = safeResolveEntityName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultName
// 					);
// 					const codeName = safeResolveEntityCodeName(
// 						dv?.valueOwner as InputMapState,
// 						editorContext?.logic as ProjectState,
// 						defaultCodeName
// 					);
// 					return `"${name}" (\`${codeName}\`)`;
// 				};

// 				// --- Connection ---
// 				const connectionDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsDeletePivotTable
// 						].inputs.connection.id
// 				);
// 				const connectionEntity = connectionDynamicValue?.value
// 					?.valueAsType as DefinitionEntityState;

// 				if (
// 					!connectionEntity ||
// 					!connectionEntity.id ||
// 					!connectionEntity.name ||
// 					connectionEntity.type !== EntityType.DefinitionEntity
// 				) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is missing or invalid. Expected a valid connection entity.`
// 					);
// 				}

// 				const connectionId =
// 					getConnectionIdFromDefinitionEntity(connectionEntity);
// 				if (!connectionId) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(connectionDynamicValue, 'Connection', 'connection')} input is invalid, it is missing the underlying Connection ID value.`
// 					);
// 				}

// 				// --- Spreadsheet ID ---
// 				const spreadsheetIdDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsDeletePivotTable
// 						].inputs.spreadsheetId.id
// 				);
// 				const rawSpreadsheetId =
// 					spreadsheetIdDynamicValue?.value?.value;

// 				const spreadsheetId = parseSpreadsheetId(rawSpreadsheetId, {
// 					errorPrefix: `${errorPrefix}The ${getErrorInputName(spreadsheetIdDynamicValue, 'Spreadsheet ID', 'spreadsheetId')} input `
// 				});

// 				// --- destination ---
// 				const destinationDynamicValue = inputs.find(
// 					(i) =>
// 						(i.valueOwner as InputMapState).declaration?.id ===
// 						BUILT_IN_BASE_ENTITY_IDS.operation[
// 							ExternalIntegrationOperations
// 								.GoogleSheetsDeletePivotTable
// 						].inputs.destination.id
// 				);
// 				const destination = destinationDynamicValue?.value?.value;

// 				if (destination === undefined || destination === null) {
// 					throw new Error(
// 						`${errorPrefix}The ${getErrorInputName(destinationDynamicValue, 'destination', 'destination')} input is missing.`
// 					);
// 				}

// 				const accessToken = await editorContext.getAccessToken();
// 				const authHeaders = { Authorization: `Bearer ${accessToken}` };
// 				const baseUrl = `${editorContext.env?.API_BASE_URL}/editor-runtime/v2/external-integrations/generic-proxy/${editorContext.projectId}/${ExternalIntegrationNames['google-sheet']}/${connectionId}`;

// 				const proxy = async (cfg: any) => {
// 					return axios.post(baseUrl, cfg, { headers: authHeaders });
// 				};

// 				let fetchedSheets: any[] = [];
// 				try {
// 					const metaRes = await proxy({
// 						method: 'GET',
// 						endpoint: `/v4/spreadsheets/${spreadsheetId}?fields=sheets(properties(sheetId,title))`
// 					});
// 					fetchedSheets = metaRes.data.sheets || [];
// 				} catch (e) {}

// 				const resolvedDestination = await resolveSheetMetadata(
// 					destination,
// 					'Id',
// 					async () => {
// 						return fetchedSheets.map((s: any) => ({
// 							id: s.properties.sheetId,
// 							name: s.properties.title
// 						}));
// 					}
// 				);
// 				const gridRange = parseSpreadsheetRangeToGridRange(
// 					resolvedDestination,
// 					{
// 						errorPrefix: `${errorPrefix}The ${getErrorInputName(destinationDynamicValue, 'destination', 'destination')} input `
// 					}
// 				);

// 				const start = {
// 					sheetId: gridRange.sheetId ?? 0,
// 					rowIndex: gridRange.startRowIndex ?? 0,
// 					columnIndex: gridRange.startColumnIndex ?? 0
// 				};

// 				let requestPayload: any = {
// 					updateCells: {
// 						start,
// 						rows: [
// 							{
// 								values: [
// 									{
// 										pivotTable: null
// 									}
// 								]
// 							}
// 						],
// 						fields: 'pivotTable'
// 					}
// 				};
// 				await proxy({
// 					method: 'POST',
// 					endpoint: `/v4/spreadsheets/${spreadsheetId}:batchUpdate`,
// 					data: {
// 						requests: [requestPayload]
// 					}
// 				});
// 				return {
// 					value: ExecutionTerminationType.Success,
// 					result: null,
// 					error: null
// 				};
// 			} catch (e: any) {
// 				const errorData = e.response?.data || e.message || e;
// 				Logger.log('[Google Sheets] error:', errorData);
// 				return {
// 					value:
// 						entity.catchesError || entity.errorCalls.length
// 							? ExecutionTerminationType.CaughtError
// 							: ExecutionTerminationType.UnhandledError,
// 					error: errorData,
// 					result: null
// 				};
// 			}
// 		}
// 	};
// }

export const ENTITIES_METADATA = ENTITIES_METADATA_JSON as any as Record<
	EntityId,
	{
		id?: EntityId;
		type: EntityType;
		hidden?: boolean;
		keywords: { word: string; score: number }[];
		entitlements: (string | 'paid-plan')[];
	}
>;
export interface IChannelConnections {
	channel: string;
	connections: Omit<IWSSessionChannelSubscription, 'channel'>[];
}

export enum ConnectionNodeType {
	PropertyOut = 'property-out',
	PropertyIn = 'property-in',
	EntryPointCaller = 'entry-point-caller',
	SuccessCaller = 'success-caller',
	ErrorCaller = 'error-caller',
	CalledBy = 'called-by',
	CalledByError = 'called-by-error'
}

export interface IRenderOptions {
	skipConnections?: boolean;
	onEachRendered?: (element: CanvasEntityElement) => void;
	debug?: boolean;
}

export interface IConnectionDrawingOptions {
	nodeType: ConnectionNodeType;
	// Only source or target element id can be present
	source?:
		| CallerEntityState
		| ArgumentDeclarationState
		| OutputMapState
		| ValueDescriptorState
		| VariableState;
	target?: ExecutableEntityState | InputMapState | VariableState;
	// The ids of the specific DOM elements that anchor the connection
	sourceId?: string;
	targetId?: string;
	// The parent canvas object that owns this entity and all elements in it
	draggableObject?: DraggableObject;
}

export class UserSettings {
	'has-started-test': boolean = false;
	columnWidths: Record<string, number> = {};
	lastOpenInfraResourcePathByProject: Record<string, string> = {};
	jsonEditorMode: 'tree' | 'code' = 'tree';

	constructor(
		public userId: string,
		init?: Partial<UserSettings>
	) {
		// Read from local storage first, override with 'init' values if present
		const storedSettings = localStorage.getItem(`user-settings:${userId}`);
		if (storedSettings) {
			try {
				Object.assign(this, JSON.parse(storedSettings));
			} catch (e) {
				// ignore
			}
		}
		if (init) {
			Object.assign(this, init);
		}
		if (!this.columnWidths) {
			this.columnWidths = {};
		}
		if (!this.lastOpenInfraResourcePathByProject) {
			this.lastOpenInfraResourcePathByProject = {};
		}
		if (!this.jsonEditorMode) {
			this.jsonEditorMode = 'tree';
		}
		localStorage.setItem(`user-settings:${userId}`, JSON.stringify(this));
	}

	set<K extends keyof UserSettings>(key: K, value: UserSettings[K]) {
		(this as any)[key] = value;
		localStorage.setItem(
			`user-settings:${this.userId}`,
			JSON.stringify(this)
		);
	}
}

export interface CanvasEntityConfig {
	draggableObject: DraggableObject;
	entity: CanvasEntityState;
}

export interface ICanvasCopyPayload {
	elyx_entities: UserManagedElementShallowTransfer[];
	elyx_project_id: string;
}

export class ProjectFetch {
	static MAX_RETRIES = 3; // configurable
	static REQUEST_DEBOUNCE_MS = 2000;

	finished = false;
	projectState: ProjectState | null = null;
	branch: IActiveBranchHeadResult | null = null;
	fetchActionId = ProjectState.UUID.uuid();
	sessionId: string | null = null;
	lastChunkIndex: number | null = null;
	lastProcessedChunkIndex = -1;
	chunkCache: {
		[key: number]: {
			order: EntityId[];
			size: number;
			index: number;
			record: Record<EntityId, UserManagedElementShallowTransfer>;
		};
	} = {};
	hasReceivedComplete = false;

	initialChunkArrivalOrder: number[] = [];

	allChunks: {
		[key: number]: {
			order: EntityId[];
			size: number;
			index: number;
			record: Record<EntityId, UserManagedElementShallowTransfer>;
		};
	} = {};

	allSeenEntities: Map<EntityId, UserManagedElementShallowTransfer> =
		new Map();

	seenIndexes: Set<number> = new Set();
	private pendingMissingChunks = new Set<number>();
	private retryCounts = new Map<number, number>();
	private processedIndexes: Set<number> = new Set(); // separate from "seen"
	private debouncedSendMissing: () => void;

	logger!: LoggerInstance;

	resolve: ((projectState: ProjectState | null) => void) | null = null;
	_reject: ((err: any) => void) | null = null;

	onProjectHeadLoadedCallback:
		| null
		| ((
				projectState: ProjectState,
				branch: IActiveBranchHeadResult
		  ) => void | Promise<void>) = null;
	onChunkAddedCallback:
		| null
		| ((chunk: {
				order: EntityId[];
				size: number;
				index: number;
				record: Record<EntityId, UserManagedEntityState>;
		  }) => void | Promise<void>) = null;
	onErrorCallback: null | ((error: any) => void) = null;

	constructor(
		public projectId: string,
		public websocketConnection: IWebsocketsClient,
		public accessToken: string,
		public refreshToken: string,
		public editor: IEditor, // As parent context for the project
		public branchId: string | null = null,
		public projectVersion: string | null = null
	) {
		this.debouncedSendMissing = debounce(
			() => this.flushMissingRequests(),
			ProjectFetch.REQUEST_DEBOUNCE_MS
		);

		this.logger = Logger.module(`project-fetch:${this.fetchActionId}`);

		if (!this.projectVersion) {
			Logger.includeModules([
				'auth:*',
				`project-fetch:${this.fetchActionId}`
			]);
		}
	}

	get pageSize() {
		return 3;
	}

	onProjectHeadLoaded(
		callback: (
			projectState: ProjectState,
			branch: IActiveBranchHeadResult
		) => void | Promise<void>
	) {
		this.onProjectHeadLoadedCallback = callback;
	}

	onChunkAdded(
		callback: (chunk: {
			order: EntityId[];
			size: number;
			index: number;
			record: Record<EntityId, UserManagedEntityState>;
		}) => void | Promise<void>
	) {
		this.onChunkAddedCallback = callback;
	}

	onError(callback: (error: any) => void) {
		this.onErrorCallback = callback;
	}

	teardown() {
		this.websocketConnection.off('message', this.handleMessage);
	}

	completeInitialization() {
		if (this.projectVersion) this.logger.debug('completeInitialization');
		this.projectState?.instancesList.forEach((entity) => {
			(entity as UserManagedEntityState).captureVersion?.();
			(entity as UserManagedEntityState).initialized = true;
		});

		this.projectState.initialized = true;
		this.projectState.emit(
			ProjectStateEvents.PROJECT_INITIALIZED,
			this.projectState,
			null
		);
	}

	private flushMissingRequests() {
		const requestedChunks = Array.from(this.pendingMissingChunks)
			.filter(
				(idx) =>
					(this.retryCounts.get(idx) || 0) < ProjectFetch.MAX_RETRIES
			)
			// don't request what we already received
			.filter(
				(idx) => !this.allChunks[idx] && !this.processedIndexes.has(idx)
			);

		if (requestedChunks.length === 0) {
			// If some chunks exceeded retries, fail the fetch.
			const exhausted = Array.from(this.pendingMissingChunks).filter(
				(idx) =>
					(this.retryCounts.get(idx) || 0) >= ProjectFetch.MAX_RETRIES
			);
			if (exhausted.length && this._reject) {
				this._reject(
					new Error(
						`Project fetch failed. Max retries reached for chunks: ${exhausted.join(
							', '
						)}`
					)
				);
			}
			return;
		}

		// increment retry counters
		requestedChunks.forEach((idx) => {
			this.retryCounts.set(idx, (this.retryCounts.get(idx) || 0) + 1);
		});

		if (this.projectVersion)
			this.logger.debug('Re-requesting chunks:', requestedChunks);

		// Important: use a distinct action for chunk requests
		this.websocketConnection.send({
			action: DTOAction.RequestProjectChunkV1,
			actionId: ProjectState.UUID.uuid(),
			userAuthor: ProjectState.sessionAuthor,
			agentAuthor: null,
			emittedAt: dayjs().toISOString(),
			channel: `project--${this.projectId}`,
			sessionId: this.sessionId as string,
			authorization: `Bearer ${this.accessToken}`,
			refreshToken: this.refreshToken,
			workspaceId: this.editor.activeWorkspace.id,
			message: null,
			type: LiveMessageEventType.Get,
			event: 'request-chunks',
			payload: {
				fetchActionId: this.fetchActionId,
				requestedChunks
			}
		});
	}

	// --- call when a chunk arrives to clear retry state
	private noteChunkArrived(index: number) {
		this.pendingMissingChunks.delete(index);
		this.retryCounts.delete(index);
	}

	processChunk(chunk: {
		order: EntityId[];
		size: number;
		index: number;
		record: Record<EntityId, UserManagedElementShallowTransfer>;
	}) {
		// DO NOT mark as "processed" yet; just record arrival
		this.seenIndexes.add(chunk.index);
		this.allChunks[chunk.index] = chunk;

		if (!this.initialChunkArrivalOrder.includes(chunk.index)) {
			this.initialChunkArrivalOrder.push(chunk.index);
		}

		// If not next in line, cache and exit
		if (chunk.index !== this.lastProcessedChunkIndex + 1) {
			this.chunkCache[chunk.index] = chunk;
			return;
		}

		// If we've already processed this one, skip
		if (this.processedIndexes.has(chunk.index)) {
			return;
		}

		// OK to process now
		this.lastProcessedChunkIndex = chunk.index;
		this.noteChunkArrived(chunk.index);

		const assembledChunkRecord: {
			order: EntityId[];
			size: number;
			index: number;
			record: Record<EntityId, UserManagedEntityState>;
		} = {
			order: chunk.order,
			size: chunk.size,
			index: chunk.index,
			record: {}
		};

		chunk.order.forEach((entityId) => {
			if (entityId === this.projectId) return;
			const entityTransfer = chunk.record[entityId];
			if (!entityTransfer) return;

			this.allSeenEntities.set(entityId, entityTransfer);
			if (entityTransfer.deleted) return;

			if (
				entityTransfer.type === EntityType.Operation &&
				(!entityTransfer.declaration ||
					!this.projectState.get(
						entityTransfer.declaration?.entityId
					))
			) {
				// This means that it has been deprecated
				return;
			}

			const entityInstance = createStateFromTypeAndSubscribe(
				entityTransfer as any as ElementTransfer,
				this.projectState as ProjectState
			) as UserManagedEntityState;

			try {
				entityInstance.hydrateAncestors();
				entityInstance.addSelfToProject(null);

				const referencesShallow = getReferencedIds(entityTransfer);

				// Any new entity, should check if it has any dependencies that are already loaded
				// and if so, re-hydrate them
				Object.keys(referencesShallow.downstream).forEach(
					(downstreamId) => {
						const downstreamEntity = this.projectState?.get(
							downstreamId
						) as UserManagedEntityState;

						if (!!downstreamEntity) {
							downstreamEntity.hydrateAncestors();
						}
					}
				);

				// if (
				// 	entityInstance.type === EntityType.Operation &&
				// 	!entityInstance.declaration
				// ) {
				// 	entityInstance.remove();
				// }

				// if (entityId === 'b1d3ab7b-34eb-4bee-98d6-0a52d84b46d8') {
				// 	const decl = this.projectState.getBuiltIn(
				// 		(entityTransfer as IOperationShallowTransfer)
				// 			?.declaration?.entityId
				// 	);
				// 	debugger;
				// }
			} catch (e) {
				this.logger.error('HERE ERROR: Entity id', entityTransfer.id);
				this.logger.error('HERE ERROR: Error hydrating ancestors', e);
				this.logger.error(
					'HERE ERROR: Entity transfer',
					entityTransfer
				);
			}

			assembledChunkRecord.record[entityId] = entityInstance;
		});

		if (this.projectVersion) {
			this.logger.debug('Processed chunk', assembledChunkRecord.index);
		}
		this.processedIndexes.add(chunk.index);
		this.onChunkAddedCallback?.(assembledChunkRecord);

		// If the next cached chunk is available, process chain
		if (!!this.chunkCache[chunk.index + 1]) {
			const cachedChunk = this.chunkCache[chunk.index + 1];
			delete this.chunkCache[chunk.index + 1];
			this.processChunk(cachedChunk);
		} else if (
			this.hasReceivedComplete &&
			this.lastChunkIndex !== null &&
			this.lastProcessedChunkIndex === this.lastChunkIndex
		) {
			this.resolve?.(this.projectState);
		}
	}

	handleReceivedChunk(message: ILiveMessageDTO) {
		if (
			message.actionId === this.fetchActionId &&
			message.action === DTOAction.GetProjectV1 &&
			message.type === LiveMessageEventType.Progress &&
			message.event === 'get-project-request-progress' &&
			!!message.payload
		) {
			const data = message.payload as {
				order: EntityId[];
				size: number;
				index: number;
				record: Record<EntityId, UserManagedElementShallowTransfer>;
			};

			this.processChunk(data);

			// If we jumped ahead, schedule a debounced aggregated request
			if (data.index > this.lastProcessedChunkIndex + 1) {
				const start = this.lastProcessedChunkIndex + 1;
				const endExclusive = data.index;
				for (let idx = start; idx < endExclusive; idx++) {
					// Do not add to pending list if already received or cached
					if (
						!this.allChunks[idx] &&
						!this.chunkCache[idx] &&
						!this.processedIndexes.has(idx)
					) {
						this.pendingMissingChunks.add(idx);
					}
				}
				this.debouncedSendMissing();
			}
		}
	}

	private handleMessage = (message: ILiveMessageDTO) => {
		if (this.finished) {
			return;
		}

		this.logger.verbose('Project fetch -- message received', message);

		if (
			// This is a native websocket server error message that is not related to our fetch
			message.message === 'Internal server error' &&
			!message.actionId &&
			!message.action &&
			!message.type
		) {
			// Reject
			this.logger.error(
				'Project fetch -- server error message received',
				message
			);
			this.onErrorCallback?.(message.payload);
			this._reject?.(message.payload);
			return;
		}

		if (
			// this.hasReceivedComplete ||
			!message.actionId ||
			message.actionId !== this.fetchActionId ||
			!message.action ||
			message.action !== DTOAction.GetProjectV1
		) {
			const isValidActionId = message.action === DTOAction.GetProjectV1;
			const isValidActionType = message.action === DTOAction.GetProjectV1;

			let suffix = '';

			if (!isValidActionId) {
				suffix += `actionId: "${message.actionId}" does not match fetchActionId: "${this.fetchActionId}"`;
			}

			if (!isValidActionType) {
				if (suffix.length > 0) {
					suffix += '\nand\n';
				}
				suffix += `action: "${message.action}" does not match expected "${DTOAction.GetProjectV1}"`;
			}

			this.logger.debug(
				'Message not for this fetch because of ' + suffix
			);
			return;
		}

		if (
			message.actionId === this.fetchActionId &&
			message.action === DTOAction.GetProjectV1 &&
			message.type === LiveMessageEventType.Progress &&
			message.event === 'get-project-request-head'
		) {
			this.logger.debug('At get-project-request-head', message.payload);
			const data = message.payload as {
				project: IProjectShallowTransfer;
				branch: IActiveBranchHeadResult;
				order: EntityId[];
			};

			// Deduce total number of pages based on the size of the order list
			// this.lastChunkIndex = Math.ceil(data.order.length / this.pageSize);

			this.projectState = initBaseProjectEntity(
				data.project as any as IProjectTransfer,
				{
					shallowErrors: false
				},
				this.editor
			);

			// this.projectState._testProp = true

			this.projectState.instances[this.projectId] = this.projectState;
			this.branch = data.branch;

			this.onProjectHeadLoadedCallback?.(this.projectState, data.branch);
		}

		this.handleReceivedChunk(message);

		if (
			message.actionId === this.fetchActionId &&
			message.action === DTOAction.GetProjectV1 &&
			message.type === LiveMessageEventType.Progress &&
			message.event === 'get-project-request-acknowledged'
		) {
			if (this.projectVersion)
				this.logger.debug(
					'At get-project-request-acknowledged',
					message.payload
				);
			// Do nothing
		}

		if (
			message.actionId === this.fetchActionId &&
			message.action === DTOAction.GetProjectV1 &&
			message.type === LiveMessageEventType.Complete &&
			message.event === 'get-project-request-full-body'
		) {
			// Resolve
			// It means the project was cached and returned all at once in full
			this.projectState = initBaseProjectEntity(
				message.payload?.project as any as IProjectTransfer
			);
			this.projectState.instances[this.projectId] = this.projectState;
			this.branch = message.payload?.branch;

			if (this.projectVersion)
				this.logger.log(
					'Project fetch completed with full body'
					// message.payload?.project,
					// message.payload?.branch
				);

			// Process the chunk
			this.processChunk({
				order: message.payload?.order,
				size: message.payload?.size,
				index: 0,
				record: message.payload?.record
			});
			this.resolve?.(this.projectState as ProjectState);
			return;
		}

		if (
			message.actionId === this.fetchActionId &&
			message.action === DTOAction.GetProjectV1 &&
			message.type === LiveMessageEventType.Complete &&
			message.event === 'get-project-request-complete'
		) {
			if (this.projectVersion)
				this.logger.debug(
					'At get-project-request-complete',
					message.payload
				);
			this.hasReceivedComplete = true;
			this.lastChunkIndex = message.payload?.lastChunkIndex;
			if (this.projectVersion)
				this.logger.debug('Last chunk index', this.lastChunkIndex);
			if (this.projectVersion)
				this.logger.debug(
					'Last processed chunk index',
					this.lastProcessedChunkIndex
				);

			// Check if all chunks have been processed
			if (
				this.lastChunkIndex !== null &&
				this.lastProcessedChunkIndex === this.lastChunkIndex
			) {
				if (this.projectVersion)
					this.logger.debug(
						'Last fetch message received. Resolving fetch promise'
					);

				this.resolve?.(this.projectState);
			} else {
				if (this.projectVersion)
					this.logger.debug(
						'Project fetch completion conditions not met: ',
						this.lastChunkIndex,
						this.lastProcessedChunkIndex
					);
			}
		}

		if (
			message.actionId === this.fetchActionId &&
			message.action === DTOAction.GetProjectV1 &&
			message.type === LiveMessageEventType.Error
		) {
			if (this.projectVersion)
				this.logger.error(
					'Project fetch error message received: ',
					message.message,
					message.payload
				);
			this.hasReceivedComplete = true;
			this.onErrorCallback?.(message.payload);
			this._reject(message.payload);
		}
	};

	async fetch(): Promise<ProjectState | null> {
		return new Promise(async (resolve, reject) => {
			this.resolve = (_) => {
				this.completeInitialization();
				this.finished = true;
				this.teardown();
				resolve(_);
			};
			this._reject = (err) => {
				this.finished = true;
				this.teardown();
				reject(err);
			};

			if (this.projectVersion)
				this.logger.debug('Fetching project', this.projectId);

			// Subscribe to websocket channels
			this.websocketConnection.send({
				action: DTOAction.GetProjectV1,
				actionId: this.fetchActionId,
				userAuthor: ProjectState.sessionAuthor,
				agentAuthor: null,
				emittedAt: dayjs().toISOString(),
				channel: `project--${this.projectId}`,
				sessionId: this.sessionId as string,
				authorization: `Bearer ${this.accessToken}`,
				refreshToken: this.refreshToken,
				workspaceId: this.editor.activeWorkspace.id,
				message: null,
				type: LiveMessageEventType.Get,
				event: null,
				payload: {
					projectId: this.projectId,
					projectVersion: this.projectVersion,
					branchId: this.branchId || null
				}
			});

			// this.websocketConnection.on('close', ({ code, reason }) => {
			// 	if (this.projectVersion) this.logger.debug('Websocket connection closed', {
			// 		code,
			// 		reason: reason.toString(),
			// 	});
			// });
			// // On Error
			// this.websocketConnection.on('error', (event) => {
			// 	if (this.projectVersion) this.logger.debug('Websocket connection error', event);
			// });

			this.websocketConnection.on('message', this.handleMessage);
		});
	}
}

export interface IProjectVersionTransitionConfig {
	transitionalChangeSet: ChangeSet; // Temporary change set containing the reversal of changes
	transitionTime: string; // ISO date string
	timeOfOriginalTargetChanges: string; // ISO date string
}

/*
	This class represents the state management an business logic of the visual programing language,
	which is built on top of a lower level canvas library, which manages the basic user interactions.
	
	The visual programming language is represented as a tree of logic that reference each other.
	Not all entities need to be represented in the canvas as draggable objects, since some entities live inside of the card/draggable object of another entity.
	For example: properties are rendered as a list inside of their parent entity card, so they don't need their own canvas draggable card.

	To render the visual programming language, we need to first flatten that nested tree structure into a flat array of entities that need their own draggable canvas objects.
	Then we establish all connections between them.

	For the most part, if the user interacts with a card, it does so with either the internal business logic component inside of the draggable object, of which the canvas entity is not aware of,
	in which case we use the normal functionality of the UI framework to do state management, update, re-render, etc.
	Or it does a canvas interaction, like dragging an entity, selecting all entities in an area,  linking two of them with an arrow, etc,
	in which case we listen to events emited by the canvas engine/library instance, like:
	"on drag start", "on drag end", "on select", "on unselect", "on connect", etc.

	We work with classes and instances because in one editor, there could be multiple canvases,
	for example when we want to write an isolated function that doesn't live in the canvas with the rest of the logic.
*/
export class EditorService
	implements IEditor, IEditorContext, IValueResolutionContext
{
	isCreateEntityMenuOpen: boolean = false;
	abortedGeneration: boolean = false;
	ready: boolean = false;
	hasLoadedLogic: boolean = false;
	executingInitialRender: boolean = false;
	hasRendered: boolean = false;
	destroyed: boolean = false;
	shouldResolveOwnInitialScroll: boolean = false;
	logicLoadingPromise: Promise<void> | null = null;
	initialTimelineFetchPromise: Promise<any> | null = null;

	// Active DOM elements
	createEntityMenu: CanvasMenuElement | null = null;
	deleteConnectionElement: CanvasConnectionDeleteButtonElement | null = null;

	// Canvas engine library
	canvas: CanvasLib | null = null;

	env: IEnvConfig = envConfig;

	// Project logic tree with all the entities' state
	logic!: ProjectState;
	// The project state, which is currently live, previously deployed
	// In the future there will be multiple, because there might be multiple branches of the project published
	// as well as multiple environments per published branch
	lastPublishedProjectState: ProjectState | null = null;
	branchHead: IActiveBranchHeadResult | null = null;
	branchHeadPromise: Promise<IActiveBranchHeadResult | null> | null = null;
	projectId: EntityId;
	initialVersion!: string;
	id: string;

	// Multiplayer
	sessionId: string | null = null;
	// The user id of the current user
	userAuthorId!: string;
	// Indexed by channel id
	peerConnections: Record<string, IChannelConnections> = {};
	private _peerPendingByPrev: Map<
		string,
		PersistChangeSetEntityActionRequestPayload[]
	> = new Map();
	private _peerSeenVersions: Set<string> = new Set();
	private _externalChangeSetsQueue: PersistChangeSetEntityActionRequestPayload[] =
		[];
	// Only for temporarily storing incomplete change-sets as individual chunks,
	// Once the full change-set is received, it is moved to the _externalChangeSetsQueue
	// We index by change-set id, then by chunk index
	private _cachedChangeSetChunks: Map<
		string,
		Map<number, PersistChangeSetEntityActionRequestPayload>
	> = new Map();

	// Set up state
	// Only used when setting up the canvas
	defferedElementsToConnect: CanvasEntityElement[] = [];
	canvasLayout: CanvasEntityState[] = [];
	elements: {
		[id: string]: CanvasEntityElement;
	} = {};

	// Ongoing connection options
	onGoingConnectionAttemptId: string | null = null;
	onGoingConnectionSource: UserManagedEntityState | null = null;
	onGoingConnectionSourceId: string | null = null;
	onGoingConnectionTarget: UserManagedEntityState | null = null;
	onGoingConnectionTargetId: string | null = null;
	onGoingConnectionNodeType: ConnectionNodeType | null = null;
	onGoingConnectionCompatibleEntities: IConnectionCompatibleOptions | null =
		null;
	onGoingConnectionIncompatibleEntities: IConnectionIncompatibleOptions | null =
		null;

	// Testing
	// Test execution
	test: Test | null = null;
	localDatabaseStore: LocalRelationalDatabasesStore;

	// Local test values that the user can set in the canvas
	localTestValues: LocalBrowserValueStore;
	// Resolved values cached so the calculation doesn't have to be done every time
	resolvedValues: LocalBrowserValueStore;
	// Values saved from previous executions results
	persistedExecutionResults: LocalBrowserValueStore;

	// Last execution results values from the last execution of their respective entities
	// This values are temporary and used to save them to the 'persistedExecutionResults' or discard them after the execution
	// lastExecutionResults: LocalBrowserValueStore;

	// Key shortcuts
	keysCurrentlyPressed: string[] = [];

	socket: IWebsocketsClient;
	events: Events;
	socketUnexpectedlyClosed: boolean = false;

	// Project publishing
	publication: PublicationRun | null = null;

	extensionsRegistry!: ExtensionsRegistry<
		EditorService,
		DefaultProjectLogicContext,
		any,
		any,
		EditorUIContext,
		any
	>;
	contextType: ExtensionContextType.Editor = ExtensionContextType.Editor;

	livePublishedVersions: PublicationRun[] = [];
	publications: PublicationRun[] = [];
	liveResources: InfrastructureResource[] | null = null;

	// This is just a way to avoid rendering multiple times the same event emitted by a change set.
	renderedChangeSetEvents = new Map<string, Set<string>>();

	onProjectHeadLoadedCallback: null | ((projectState: ProjectState) => void) =
		null;
	onLogicLoadingCompleteCallback: null | ((chunk: any) => void) = null;
	onRenderedCallback: null | (() => void) = null;
	onProjectSetupErrorCallback: null | ((error: any) => void) = null;

	integrationsService: ExternalIntegrationsService;

	editorUIContext!: EditorUIContext;

	pastSessionIds: Set<string> = new Set();

	userSettings: UserSettings;
	activeWorkspace: IWorkspace;

	branches: IBranch[] = [];

	roles: IRichProjectRoleDTO[] = [];

	READ_ONLY: boolean = true;

	constructor(
		projectId: EntityId,
		socket: IWebsocketsClient,
		events: Events | null,
		activeWorkspace: IWorkspace,
		public callbacks: {
			requestDynamicDialog: (
				callback: (handlers: {
					close: (event: any) => Promise<void> | void;
				}) => Promise<{
					id: string;
					component: React.ReactNode;
					props: IComponentLifecycleProps &
						Omit<IDialogProps, 'children'>;
				}>
			) => void;
			removeActiveDynamicDialog: () => void;
			removeAllDynamicDialogs: () => void;
			removeDynamicDialog: (id: string) => void;
			requestSmallDynamicDialog: (
				callback: (handlers: {
					close: (event: any) => Promise<void> | void;
				}) => Promise<{
					id: string;
					component: React.ReactNode;
					props: IComponentLifecycleProps &
						Omit<ISmallDialogProps, 'children'>;
				}>
			) => void;
			removeActiveSmallDynamicDialog: () => void;
			removeAllSmallDynamicDialogs: () => void;
			removeSmallDynamicDialog: (id: string) => void;
			/**
			 * Gets a list of the currently active and queued dynamic dialogs
			 * @returns
			 */
			getQueuedDynamicDialogs: () => {
				id: string;
				component: React.ReactNode;
				props: IComponentLifecycleProps &
					Omit<IDialogProps, 'children'>;
			}[];
		}
	) {
		this.id = projectId;
		this.projectId = projectId;
		this.socket = socket;
		this.events = events || new Events('editor-service-fallback-events');
		this.activeWorkspace = activeWorkspace;
		this.integrationsService = new ExternalIntegrationsService(this);

		this.events.yieldEvery = 75;

		const sId = crypto.randomUUID
			? crypto.randomUUID()
			: Math.random().toString(36).substring(2);
		this.sessionId = sId;

		this.initRegistry();

		// Bindings
		this.handleIncommingWebsocketMessage =
			this.handleIncommingWebsocketMessage.bind(this);
		this.handleReconnectingWebsocket =
			this.handleReconnectingWebsocket.bind(this);
		this.handleClosedWebsocket = this.handleClosedWebsocket.bind(this);
		this.handlePersistChangeSetMessage =
			this.handlePersistChangeSetMessage.bind(this);
		this.handleNotificationChannelsMessage =
			this.handleNotificationChannelsMessage.bind(this);
		this.toggleEntityCreationMenu =
			this.toggleEntityCreationMenu.bind(this);
		this.createElementFromEntity = this.createElementFromEntity.bind(this);
		this.clearOnGoingConnectionState =
			this.clearOnGoingConnectionState.bind(this);
		this.onGeneralKeyDown = this.onGeneralKeyDown.bind(this);
		this.onGeneralKeyUp = this.onGeneralKeyUp.bind(this);
		this.undo = this.undo.bind(this);
		this.redo = this.redo.bind(this);
		this.requestExtension = this.requestExtension.bind(this);
		this.onOfflineWindowEventHandler =
			this.onOfflineWindowEventHandler.bind(this);
		this.onOnlineWindowEventHandler =
			this.onOnlineWindowEventHandler.bind(this);
		this.onChangeSetEventHandler = this.onChangeSetEventHandler.bind(this);
		this.handleProjectPublicationCompleted =
			this.handleProjectPublicationCompleted.bind(this);
		this.handleProjectPublicationError =
			this.handleProjectPublicationError.bind(this);
		this.addCallerConnection = this.addCallerConnection.bind(this);
		this.removeCallConnection = this.removeCallConnection.bind(this);
	}

	static SAVING_ENABLED = true;

	static SAFE_CHUNK_WS_CONTENT_SIZE = 64 * 1024;

	static navigate = (url: string) => {
		// Default native browser navigation
		window.location.href = url;
	};

	activeExecution: Execution | null = null;

	get execution(): Execution | null {
		return this.activeExecution || this.test || null;
	}

	get project(): ProjectState {
		return this.logic as ProjectState;
	}

	/*
	 * Reads the existing path parameter to extract the branch name, if present, and otherwise returns 'main'
	 */
	get viewingBranch(): string {
		const pathParts = location.pathname.split('/');
		// ws/:workspaceId/editor/:projectId/:branchName/:version/*
		const branchNameIndex = 5;
		if (pathParts.length > branchNameIndex) {
			return pathParts[branchNameIndex];
		}
		return 'main';
	}

	get viewingBranchId(): string {
		return this.branchHead?.branchId;
	}

	/*
	 * Reads the existing path parameter to extract the version, if present, and otherwise returns 'latest'
	 */
	get viewingVersion(): string {
		const pathParts = location.pathname.split('/');
		// ws/:workspaceId/editor/:projectId/:branchName/:version/*
		const versionIndex = 6;
		if (pathParts.length > versionIndex) {
			return pathParts[versionIndex];
		}
		return 'latest';
	}

	get viewingVersionId() {
		if (this.viewingVersion === 'latest') {
			return this.branchHead?.headVersion || 'latest';
		}
		return this.viewingVersion;
	}

	get editorBasePath() {
		return `/ws/${this.activeWorkspace?.slug}/editor/${this.projectId}/${this.viewingBranch}/${this.viewingVersion}`;
	}

	get isViewingNonHead() {
		if (this.viewingVersion === 'latest') {
			return false;
		}

		return this.viewingVersion !== this.branchHead?.headVersion;
	}

	// Last execution results values from the last execution of their respective entities
	// This values are temporary and used to save them to the 'persistedExecutionResults' or discard them after the execution
	get lastExecutionResults(): EfimeralValueStore | null {
		return (
			this.execution?.lastExecutionResults ||
			generatePlaceholderValueStore(
				'project--' +
					this.projectId +
					'--last-execution-results--value-store',
				this.logic
			)
		);
	}

	get undoableStackValueIndex(): number {
		if (!!this.logic) {
			return this.logic.undoableStackValueIndex;
		}
	}

	set undoableStackValueIndex(value: number) {
		if (!!this.logic) {
			this.logic.undoableStackValueIndex = value;
		}
	}

	get PROJECT_NOTIFICATIONS_CHANNEL() {
		return `project--${this.projectId}`;
	}

	get isNaiveSubpage() {
		const restOfUrl = location.pathname.replace(this.editorBasePath, '');

		const isNaiveSubpage = !!restOfUrl && restOfUrl !== '/';

		const subpagesWithLogic = [
			...this.editorSubpagesThatRequireLogicToBeLoaded
		];

		const currentIsOneOfSubpagesWithLogic = subpagesWithLogic.some(
			(subpage) => {
				const requiresLogic = location.pathname.includes(subpage);
				return requiresLogic;
			}
		);

		return isNaiveSubpage && !currentIsOneOfSubpagesWithLogic;
	}

	get isViewingCanvasDirectly() {
		const restOfUrl = location.pathname.replace(this.editorBasePath, '');
		return !restOfUrl || restOfUrl === '/';
	}

	// Returns relative paths of subpages that require the logic to be loaded
	get editorSubpagesThatRequireLogicToBeLoaded(): string[] {
		const subpages: string[] = [];

		let prepend = '';

		if (this.projectId) {
			prepend = this.editorBasePath;
		}

		subpages.push(`${prepend}/project-configuration`);
		subpages.push(`${prepend}/starting-logic-generation`);
		subpages.push(`${prepend}/generating-starting-logic`);
		subpages.push(`${prepend}/publication`);
		subpages.push(`${prepend}/costs`);
		subpages.push(`${prepend}/profile`);
		subpages.push(`${prepend}/resources`);
		subpages.push(`${prepend}/external-integration-connections`);
		subpages.push(`${prepend}/test-relational-database`);

		Object.values(EntityType).forEach((entityType) => {
			subpages.push(`${prepend}/entity/${entityType}`);
		});

		return subpages;
	}

	get livePublication(): PublicationRun | null {
		const lastLivePublication = this.livePublishedVersions
			.filter((pub) => pub.status === PublicationStatus.Success)
			.reduce((prev, current) => {
				return dayjs(prev.createdAt).isAfter(dayjs(current.createdAt))
					? prev
					: current;
			}, this.livePublishedVersions[0]);

		if (!!lastLivePublication?.projectVersion) {
			return lastLivePublication || null;
		}

		return null;
	}

	// Based on loaded roles and current user id in the `UserSettings`, returns whether the user has permissions to edit the project
	get canEdit(): boolean {
		if (
			!this.userSettings ||
			!this.userSettings?.userId ||
			!this.roles.length
		) {
			return false;
		}

		const userRoles = this.roles.filter((role) =>
			(role.userId || role.user?.id).includes(this.userSettings!.userId)
		);

		return userRoles.some(
			(role) =>
				[UserProjectRole.Owner, UserProjectRole.Editor].includes(
					role.role
				) ||
				[UserProjectRole.Owner, UserProjectRole.Editor].includes(
					`role_${role.role}` as UserProjectRole
				) ||
				['owner', 'editor'].includes(role.role)
		);
	}

	get off(): Events['off'] {
		return this.events.off;
	}
	get on(): Events['on'] {
		return this.events.on;
	}
	get emit(): Events['emit'] {
		return this.events.emit;
	}
	get emitAsync(): Events['emitAsync'] {
		return this.events.emitAsync;
	}
	get emitAsyncAll(): Events['emitAsyncAll'] {
		return this.events.emitAsyncAll;
	}
	get emitAsyncAllSettled(): Events['emitAsyncAllSettled'] {
		return this.events.emitAsyncAllSettled;
	}
	get emitAsyncSequentially(): Events['emitAsyncSequentially'] {
		return this.events.emitAsyncSequentially;
	}
	get emitAsyncSequentiallyAll(): Events['emitAsyncSequentiallyAll'] {
		return this.events.emitAsyncSequentiallyAll;
	}
	get emitAsyncSequentiallyAllSettled(): Events['emitAsyncSequentiallyAllSettled'] {
		return this.events.emitAsyncSequentiallyAllSettled;
	}

	checkIsOwnSession(sessionId: string | null): boolean {
		if (!sessionId) return false;

		return (
			this.sessionId === sessionId || this.pastSessionIds.has(sessionId)
		);
	}

	onProjectHeadLoaded(callback: (projectState: ProjectState) => void) {
		this.onProjectHeadLoadedCallback = callback;
	}

	onLogicLoadingComplete(callback: (chunk: any) => void) {
		this.onLogicLoadingCompleteCallback = callback;
	}

	onRendered(callback: () => void) {
		this.onRenderedCallback = callback;
	}

	onProjectSetupError(callback: (error: any) => void) {
		this.onProjectSetupErrorCallback = callback;
	}

	// Add key to list of keys currently pressed if it isn't already there
	addKeyPressTracking(code: string) {
		if (!this.keysCurrentlyPressed.includes(code)) {
			this.keysCurrentlyPressed.push(code);
		}
	}

	// Remove key from list of keys currently pressed
	removeKeyPressTracking(code: string) {
		this.keysCurrentlyPressed = this.keysCurrentlyPressed.filter(
			(key) => key !== code
		);
	}

	async onGeneralKeyDown(e: KeyboardEvent) {
		this.addKeyPressTracking(e.code);

		switch (e.code) {
			case 'KeyF': {
				if ((e.ctrlKey || e.metaKey) && this.isViewingCanvasDirectly) {
					this.emit('global-canvas-search', e);
				}
				break;
			}
			case 'Escape': {
				this.keysCurrentlyPressed = [];
				// If the entity creation menu is open, close it
				if (this.isCreateEntityMenuOpen) {
					this.hideEntityCreationMenu();
				}

				this.clearOnGoingConnectionState();

				// If the delete connection button is open, close it
				if (this.deleteConnectionElement) {
					this.deleteConnectionElement.destroy();
					this.deleteConnectionElement = null;
				}

				// If the user is dragging a connection, cancel it
				if (!!this.canvas?.activeConnectionDrawing) {
					this.canvas?.removeConnectionDrawing();
				}

				this.emitAsync('escape-key-press', e);

				// // Remove all popups (relative objects)
				// for (const obj of this.canvas?.draggableObjects) {
				// 	obj.relativeObjects.
				// }

				break;
			}
		}
	}

	get(entityId: string): CanvasEntityElement {
		return this.elements[entityId];
	}

	getOrCreateElementFromEntity(
		entity: CanvasEntityState,
		options: ICanvasElementOptions = {
			debug: false
		}
	): CanvasEntityElement {
		const existingElement = this.getElement(entity.id);

		if (existingElement) {
			return existingElement;
		}

		const canvasElement = new CanvasEntityElement(this, entity);

		this.elements[entity.id] = canvasElement;

		return canvasElement;
	}

	onGeneralKeyUp(e: KeyboardEvent) {
		this.removeKeyPressTracking(e.code);

		switch (e.code) {
			// Shift
			case 'MetaRight':
			case 'ControlRight':
			case 'ControlLeft':
			case 'MetaLeft': {
				// This is a hack to fix a browser bug where the keyup event is not triggered for any key when the meta/ctrl key is still pressed
				// So we clear the keys pressed list after meta/ctrl is released
				// this.keysCurrentlyPressed = [];
				break;
			}
		}
	}
	onWindowBlur() {
		this.keysCurrentlyPressed = [];
	}

	setupShortcuts() {
		// Bind methods
		this.onGeneralKeyDown = this.onGeneralKeyDown.bind(this);
		this.onGeneralKeyUp = this.onGeneralKeyUp.bind(this);
		this.onWindowBlur = this.onWindowBlur.bind(this);

		// On escape, unselect all objects
		window.addEventListener('keydown', this.onGeneralKeyDown);

		window.addEventListener('keyup', this.onGeneralKeyUp);
		window.addEventListener('blur', this.onWindowBlur);
	}

	teardownShortcuts() {
		window.removeEventListener('keydown', this.onGeneralKeyDown);
		window.removeEventListener('keyup', this.onGeneralKeyUp);
		window.removeEventListener('blur', this.onWindowBlur);
	}

	createElementFromEntity(
		entity: CanvasEntityState,
		options: ICanvasElementOptions = {
			debug: false
		}
	): Promise<CanvasEntityElement> {
		const canvasElement = new CanvasEntityElement(this, entity);
		return canvasElement.init(options);
	}

	clearOnGoingConnectionState() {
		this.onGoingConnectionAttemptId = null;
		this.emitAsync('canvas-connection-end', {});
		// Remove the active connection being drawing
		this.canvas?.removeConnectionDrawing();
		this.onGoingConnectionSource = null;
		this.onGoingConnectionSourceId = null;
		this.onGoingConnectionTarget = null;
		this.onGoingConnectionTargetId = null;
		this.onGoingConnectionNodeType = null;
		this.onGoingConnectionCompatibleEntities = null;
		this.onGoingConnectionIncompatibleEntities = null;
	}

	async addCallerConnection(
		sourceEntity: UserManagedEntityState,
		targetEntity: UserManagedEntityState,
		connectionType: ConnectionNodeType
	) {
		// Draw the new connection
		if (connectionType !== ConnectionNodeType.CalledBy) {
			return;
		}

		if (ENTRY_POINT_TYPES.includes(sourceEntity.type)) {
			connectEntryCallerToExecutionNode(
				sourceEntity as EntryPointEntityState,
				this.getElement(sourceEntity.id),
				targetEntity as CallableEntityState,
				this
			);
		} else if (PASS_THROUGH_CALLABLE_TYPES.includes(sourceEntity.type)) {
			connectSuccessToExecutionNode(
				sourceEntity as PassThroughCallableEntityState,
				this.getElement(sourceEntity.id),
				targetEntity as CallableEntityState,
				this
			);
		}
	}

	async startConnection(options: IConnectionDrawingOptions) {
		// Check if both a source and target are present
		if (options.source && options.target) {
			throw new Error(
				'Both source and target cannot be present at the same time when starting a connection on the canvas'
			);
		}

		// Check that at least one of the source or target is present
		if (!options.source && !options.target) {
			throw new Error(
				'Either source or target must be present when starting a connection on the canvas'
			);
		}

		// Check that the source or target id is present
		if (options.target && !options.targetId) {
			throw new Error(
				'Target id must be present when starting a connection on the canvas'
			);
		}

		// Check that the source or target id is present
		if (options.source && !options.sourceId) {
			throw new Error(
				'Source id must be present when starting a connection on the canvas'
			);
		}

		this.hideEntityCreationMenu();

		const startsInSource = !!options.source;

		const canvasConnectionOptions: {
			sourceId?: string;
			targetId?: string;
			parentObject: DraggableObject;
		} = {
			parentObject: options.draggableObject,
			sourceId: options.sourceId,
			targetId: options.targetId
		};

		// The line options change the styel of the line
		// We should determine the style based on the type of connection
		const callConnectionTypes = [
			ConnectionNodeType.EntryPointCaller,
			ConnectionNodeType.SuccessCaller,
			ConnectionNodeType.ErrorCaller,
			ConnectionNodeType.CalledBy
		];

		const connectionDrawingOptions: IConnectionOptions =
			callConnectionTypes.includes(options.nodeType)
				? {
						dash: { animation: true },
						size: 5,
						color: 'var(--color-main-primary)'
					}
				: {
						size: 3,
						color: 'var(--color-main-primary)'
					};

		const connectionAttemptId =
			Date.now().toString() + Math.random().toString();
		this.onGoingConnectionAttemptId = connectionAttemptId;

		// Not awaiting so the connection can start drawing immediately
		getIncompatibleConnectionEntitiesAsync(
			options.source || options.target,
			options.nodeType,
			{
				allowReadWriteToFixableScope: true
			}
		).then((relatedEntities) => {
			if (this.onGoingConnectionAttemptId !== connectionAttemptId) return;
			this.onGoingConnectionSource = options.source || null;
			this.onGoingConnectionSourceId = options.sourceId || null;
			this.onGoingConnectionTarget = options.target || null;
			this.onGoingConnectionTargetId = options.targetId || null;
			this.onGoingConnectionNodeType = options.nodeType;
			this.onGoingConnectionCompatibleEntities =
				relatedEntities.compatible;
			this.onGoingConnectionIncompatibleEntities =
				relatedEntities.incompatible;

			this.emitAsync('canvas-connection-start', {
				source: options.source,
				target: options.target,
				nodeType: options.nodeType,
				compatible: relatedEntities.compatible,
				incompatible: relatedEntities.incompatible
			});
		});

		this.canvas
			.startConnection(canvasConnectionOptions)
			.setOptions(connectionDrawingOptions)
			.onCursorDrawingMove((_, { coordinates, anchorElement }) => {
				const anchorCanvasCoords =
					getElementBoundingBoxInCanvasCoordinates(
						anchorElement,
						this.canvas?.canvasElement
					);

				// Show tooltip directly on the cursor in the canvas, and change the cursor to a forbidden sign
				if (!!this.onGoingConnectionSource) {
					if (anchorCanvasCoords.right + 5 > coordinates.x) {
						if (!this.canvas?.isTooltipOpen) {
							this.canvas?.showTooltip(
								'cursor-active-drawing-tooltip',
								'A connection cannot be drawn further left than the starting node'
							);
							if (!!this.canvas) {
								this.canvas.tooltip.style.fontSize = '28px';
								this.canvas.canvasElement.style.cursor =
									'not-allowed';
							}
						}
						return;
					}
				} else if (!!this.onGoingConnectionTarget) {
					if (anchorCanvasCoords.left - 5 < coordinates.x) {
						if (!this.canvas?.isTooltipOpen) {
							this.canvas?.showTooltip(
								'cursor-active-drawing-tooltip',
								'A connection cannot be drawn further right than the starting node'
							);
							if (!!this.canvas) {
								this.canvas.tooltip.style.fontSize = '28px';
								this.canvas.canvasElement.style.cursor =
									'not-allowed';
							}
						}
						return;
					}
				}

				if (
					this.canvas?.isTooltipOpen &&
					this.canvas?.activeUserSetTooltipId ===
						'cursor-active-drawing-tooltip'
				) {
					this.canvas?.hideTooltip('cursor-active-drawing-tooltip');
					if (!!this.canvas) {
						this.canvas.tooltip.style.fontSize = 'unset';
						this.canvas.canvasElement.style.cursor = 'unset';
					}
				}
			})
			.onEnd(async ({ coordinates, element: _ }, connectionDrawing) => {
				this.canvas?.hideTooltip();

				if (!!this.canvas?.tooltip) {
					this.canvas.tooltip.style.fontSize = 'unset';
				}
				if (!!this.canvas) {
					this.canvas.canvasElement.style.cursor = 'unset';
				}
				/*
					If the connection goes passed the point where the arrows cannot be rendered,
					we should show an error popup notification and clear the connection state
					To calculate this:
						- if we have a 'source' the resolve coordinates should be further to the left than the 'onEnd' coordinates (plus a small hardcoded margin)
						- if we have a 'target' the resolve coordinates should be further to the right than the 'onEnd' coordinates (plus a small hardcoded margin)
				*/
				if (!!this.onGoingConnectionSource) {
					const sourceParentCanvasEntity = getParentCanvasEntity(
						this.onGoingConnectionSource
					);

					if (sourceParentCanvasEntity.x - 20 > coordinates.x) {
						popupNotification({
							color: 'error',
							text: 'The target node needs to be further right than the starting node'
						});

						this.emitAsync('canvas-connection-end', {
							error: true
						});
						this.clearOnGoingConnectionState();
						return;
					}
				} else if (!!this.onGoingConnectionTarget) {
					const targetParentCanvasEntity = getParentCanvasEntity(
						this.onGoingConnectionTarget
					);

					if (targetParentCanvasEntity.x + 20 < coordinates.x) {
						popupNotification({
							color: 'error',
							text: 'The target node needs to be further left than the starting node'
						});

						this.emitAsync('canvas-connection-end', {
							error: true
						});
						this.clearOnGoingConnectionState();
						return;
					}
				}

				let actionName = StateMutationAction.ConnectNodes;

				const connectionChangeSet = this.logic.addChangeSet(
					new ChangeSet(
						this.logic,
						ProjectState.sessionAuthor,
						new Date().toISOString(),
						this.onGoingConnectionSource ||
							this.onGoingConnectionTarget ||
							this.logic,
						false,
						actionName
					)
				);

				// If there is already a menu, instead of toggling it off, we should remove it, and then create a new one
				this.hideEntityCreationMenu();

				// User dragged to connect two entities together, instead of creating a new one
				if (
					this.onGoingConnectionSource &&
					this.onGoingConnectionSourceId &&
					this.onGoingConnectionTarget &&
					this.onGoingConnectionTargetId
				) {
					if (
						this.onGoingConnectionTargetId !==
							getCanvasEntityNewInputButtonDOMId(
								this.onGoingConnectionTarget
							) &&
						this.onGoingConnectionSourceId !==
							getCanvasEntityNewOutputButtonDOMId(
								this.onGoingConnectionSource
							)
					) {
						// Connect the two entities together
						connectEntitiesBasedOnConenctionType(
							this.onGoingConnectionSource,
							this.onGoingConnectionTarget,
							options.nodeType,
							connectionChangeSet
						);
					}

					// Connect them inthe canvas
					const sourceEntityParentCanvasElement =
						getParentCanvasEntity(this.onGoingConnectionSource);
					const targetEntityParentCanvasElement =
						getParentCanvasEntity(this.onGoingConnectionTarget);

					const sourceCanvasElement = this.getElement(
						sourceEntityParentCanvasElement.id
					);
					const targetCanvasElement = this.getElement(
						targetEntityParentCanvasElement.id
					);

					const isDynamicInput =
						this.onGoingConnectionTargetId.includes(
							'--new-dynamic-input--'
						);

					if (isDynamicInput) {
						const inputValueDescriptorId =
							getInputValueDescriptorIdFromNewDynamicInputButtonDOMId(
								this.onGoingConnectionTargetId
							);

						const valueDescriptor = this.logic.get(
							inputValueDescriptorId
						) as ValueDescriptorState;

						const newInputMapTransfer: IActionInputMapTransfer =
							InputMapState.new(
								connectionChangeSet
							) as IActionInputMapTransfer;
						newInputMapTransfer.declaration =
							valueDescriptor.toJSON() as IValueDescriptorTransfer;
						newInputMapTransfer.index = (
							this.onGoingConnectionTarget as
								| OperationState
								| ConditionState
						).inputs.length;
						newInputMapTransfer.readsValue = (
							this
								.onGoingConnectionSource as ValueWritingEntityState
						).toReference();
						newInputMapTransfer.parent = (
							this.onGoingConnectionTarget as
								| OperationState
								| ConditionState
						).toReference();

						if (
							this.onGoingConnectionTarget?.type ===
							EntityType.Operation
						) {
							connectionChangeSet.actionName =
								StateMutationAction.ConnectValueToNewOperationInput;
						} else if (
							this.onGoingConnectionTarget?.type ===
							EntityType.Condition
						) {
							connectionChangeSet.actionName =
								StateMutationAction.ConnectValueToNewConditionInput;
						} else {
							connectionChangeSet.actionName =
								StateMutationAction.ConnectValueToNewInput;
						}

						const newInstance = createStateFromTypeAndSubscribe(
							newInputMapTransfer,
							this.logic
						) as InputMapState;

						newInstance.hydrateAncestors();

						connectionChangeSet.add(
							newInstance,
							ChangeSetEntityChangeType.Added
						);

						newInstance.setParent(
							this.onGoingConnectionTarget as
								| OperationState
								| ConditionState,
							connectionChangeSet
						);
						newInstance.addSelfToProject(connectionChangeSet);
						newInstance.initChildren(connectionChangeSet);

						await applyConnectionCompatibilityAutoFixes(
							this.onGoingConnectionSource,
							this.onGoingConnectionTarget,
							options.nodeType,
							connectionChangeSet,
							{
								compatible:
									this.onGoingConnectionCompatibleEntities,
								incompatible:
									this.onGoingConnectionIncompatibleEntities
							},
							{
								onConnection: this.addCallerConnection,
								onCallRemoved: this.removeCallConnection
							}
						);

						this.renderAndCloseChangeSet(connectionChangeSet, {
							debug: true
						});

						this.onGoingConnectionTarget = newInstance;

						await targetCanvasElement.render({
							debug: false
						});

						this.onGoingConnectionTargetId = getCanvasEntityDOMId(
							this.onGoingConnectionTarget
						);

						this.canvas?.activeConnectionDrawing.snap(
							getCanvasEntityDOMId(this.onGoingConnectionTarget)
						);
					} else if (
						this.onGoingConnectionSourceId ===
						getCanvasEntityNewOutputButtonDOMId(
							this.onGoingConnectionSource
						)
					) {
						// This means that it is connected to a new entity, that has to be created first
						if (
							this.onGoingConnectionSource.type ===
							EntityType.FunctionDeclaration
						) {
							connectionChangeSet.actionName =
								StateMutationAction.ConnectNewFuncDeclArgToValue;

							// Create new argument declaration for the function declaration
							const newArgumentDeclarationTransfer: IArgumentDeclarationTransfer =
								ArgumentDeclarationState.new(
									connectionChangeSet
								);
							newArgumentDeclarationTransfer.index =
								this.onGoingConnectionSource.inputs.length;
							newArgumentDeclarationTransfer.name =
								resolveEntityName(
									this.onGoingConnectionTarget,
									this.logic
								);
							// TODO: Deduce 'required' from the value reading entity (eg: if it doesn't have a default value)
							newArgumentDeclarationTransfer.required = true;
							newArgumentDeclarationTransfer.writesValues = [
								(
									this
										.onGoingConnectionTarget as ValueReadingEntityState
								).toJSON()
							];
							newArgumentDeclarationTransfer.dataType = (
								this
									.onGoingConnectionTarget as ValueReadingEntityState
							)
								.getDataType(connectionChangeSet)
								.clone(connectionChangeSet);
							newArgumentDeclarationTransfer.parent =
								this.onGoingConnectionSource.toReference();

							const newInstance = createStateFromTypeAndSubscribe(
								newArgumentDeclarationTransfer,
								this.logic
							) as ArgumentDeclarationState;

							newInstance.hydrateAncestors();

							connectionChangeSet.add(
								newInstance,
								ChangeSetEntityChangeType.Added
							);

							newInstance.setParent(
								this.onGoingConnectionSource,
								connectionChangeSet
							);
							newInstance.addSelfToProject(connectionChangeSet);
							newInstance.initChildren(connectionChangeSet);

							await applyConnectionCompatibilityAutoFixes(
								this.onGoingConnectionSource,
								this.onGoingConnectionTarget,
								options.nodeType,
								connectionChangeSet,
								{
									compatible:
										this
											.onGoingConnectionCompatibleEntities,
									incompatible:
										this
											.onGoingConnectionIncompatibleEntities
								},
								{
									onConnection: this.addCallerConnection,
									onCallRemoved: this.removeCallConnection
								}
							);

							this.renderAndCloseChangeSet(connectionChangeSet);

							this.onGoingConnectionSource = newInstance;
						}

						await sourceCanvasElement.render({
							debug: false
						});

						this.onGoingConnectionSourceId = getCanvasEntityDOMId(
							this.onGoingConnectionSource
						);
						this.canvas?.activeConnectionDrawing.snap(
							getCanvasEntityDOMId(this.onGoingConnectionSource)
						);
					} else if (
						this.onGoingConnectionTargetId ===
						getCanvasEntityNewInputButtonDOMId(
							this.onGoingConnectionTarget
						)
					) {
						if (
							VARIABLE_TYPES.includes(
								this.onGoingConnectionTarget.type
							)
						) {
							connectionChangeSet.actionName =
								StateMutationAction.ConnectValueToNewVarDeclProperty;

							if (
								this.onGoingConnectionTarget.type ===
								EntityType.VariableInstance
							) {
								connectionChangeSet.actionName =
									StateMutationAction.ConnectValueToNewVarInstProperty;
							}

							const entity = this
								.onGoingConnectionTarget as VariableState;
							const variableDeclaration = getDeclaration(entity);

							let resolvedDataType: DataTypeState =
								variableDeclaration.getDataType(
									connectionChangeSet
								);
							let dataTypeEntity: DefinitionEntityState;

							if (
								!!resolvedDataType.entity &&
								resolvedDataType.entity.type ===
									EntityType.DefinitionEntity &&
								resolvedDataType.entity.parent?.id ===
									resolvedDataType.id
							) {
								dataTypeEntity =
									resolvedDataType.entity as DefinitionEntityState;
							}

							if (!resolvedDataType) {
								const newDataTypeTransfer =
									DataTypeState.new(connectionChangeSet);
								newDataTypeTransfer.parent =
									variableDeclaration.toReference();
								newDataTypeTransfer.inferred = true;

								resolvedDataType =
									createStateFromTypeAndSubscribe(
										newDataTypeTransfer,
										this.logic
									) as DataTypeState;

								resolvedDataType.hydrateAncestors();
								resolvedDataType.addSelfToProject(
									connectionChangeSet
								);
								connectionChangeSet.add(
									resolvedDataType,
									ChangeSetEntityChangeType.Added
								);
								resolvedDataType.initChildren(
									connectionChangeSet
								);
							}

							if (!dataTypeEntity) {
								const newDefEntityTransfer =
									DefinitionEntityState.new(
										connectionChangeSet
									);
								const allOtherDefinitions =
									this.logic.getDefinitionEntities();

								const desiredName = 'Custom inline definition';

								const newName = findNextAvailableName(
									desiredName,
									allOtherDefinitions
								);

								newDefEntityTransfer.name = newName;
								newDefEntityTransfer.parent =
									resolvedDataType.toReference();

								dataTypeEntity =
									createStateFromTypeAndSubscribe(
										newDefEntityTransfer,
										this.logic
									) as DefinitionEntityState;

								dataTypeEntity.hydrateAncestors();
								dataTypeEntity.addSelfToProject(
									connectionChangeSet
								);
								connectionChangeSet.add(
									dataTypeEntity,
									ChangeSetEntityChangeType.Added
								);
								dataTypeEntity.initChildren(
									connectionChangeSet
								);
								resolvedDataType.setEntity(
									dataTypeEntity,
									connectionChangeSet
								);

								connectionChangeSet.add(
									resolvedDataType,
									ChangeSetEntityChangeType.Updated
								);
							}
							const newPropertyTransfer =
								PropertyState.new(connectionChangeSet);
							newPropertyTransfer.parent =
								dataTypeEntity.toReference();

							newPropertyTransfer.name = findNextAvailableName(
								'Property',
								dataTypeEntity.properties
							);

							const newProperty = createStateFromTypeAndSubscribe(
								newPropertyTransfer,
								this.logic
							) as PropertyState;

							newProperty.hydrateAncestors();
							newProperty.addSelfToProject(connectionChangeSet);
							connectionChangeSet.add(
								newProperty,
								ChangeSetEntityChangeType.Added
							);
							newProperty.initChildren(connectionChangeSet);

							const newEntityInputTransfer =
								VariableInputMapState.new(connectionChangeSet);
							newEntityInputTransfer.parent =
								entity.toReference();
							newEntityInputTransfer.declaration =
								newProperty.toJSON() as IPropertyTransfer;
							newEntityInputTransfer.index = (
								this.onGoingConnectionTarget as VariableState
							).inputs.length;
							newEntityInputTransfer.readsValue = (
								this
									.onGoingConnectionSource as ValueWritingEntityState
							).toReference();
							newEntityInputTransfer.parent = (
								this.onGoingConnectionTarget as VariableState
							).toReference();

							const newEntityInput =
								createStateFromTypeAndSubscribe(
									newEntityInputTransfer,
									this.logic
								) as VariableInputMapState;

							newEntityInput.hydrateAncestors();
							newEntityInput.addSelfToProject(
								connectionChangeSet
							);
							connectionChangeSet.add(
								newEntityInput,
								ChangeSetEntityChangeType.Added
							);
							newEntityInput.initChildren(connectionChangeSet);
							await applyConnectionCompatibilityAutoFixes(
								this.onGoingConnectionSource,
								this.onGoingConnectionTarget,
								options.nodeType,
								connectionChangeSet,
								{
									compatible:
										this
											.onGoingConnectionCompatibleEntities,
									incompatible:
										this
											.onGoingConnectionIncompatibleEntities
								},
								{
									onConnection: this.addCallerConnection,
									onCallRemoved: this.removeCallConnection
								}
							);

							this.onGoingConnectionTarget = newEntityInput;
						} else if (
							TERMINATION_TYPES.includes(
								this.onGoingConnectionTarget.type
							)
						) {
							const targetTermination = this
								.onGoingConnectionTarget as TerminationEntityState;
							const valueWriter = this
								.onGoingConnectionSource as ValueWritingEntityState;

							let altName: string | null = null;

							if (
								this.onGoingConnectionTarget.type ===
								EntityType.ReturnStatement
							) {
								connectionChangeSet.actionName =
									StateMutationAction.ConnectValueToNewReturnStmtProperty;
							} else if (
								this.onGoingConnectionTarget.type ===
								EntityType.ContinueStatement
							) {
								connectionChangeSet.actionName =
									StateMutationAction.ConnectValueToNewContinueStmtProperty;
							} else if (
								this.onGoingConnectionTarget.type ===
								EntityType.BreakStatement
							) {
								connectionChangeSet.actionName =
									StateMutationAction.ConnectValueToNewBreakStmtProperty;
							}

							if (
								!!(
									valueWriter.type === EntityType.Operation ||
									valueWriter.type === EntityType.InternalCall
								) &&
								valueWriter.declaration?.type ===
									EntityType.ActionDescriptor &&
								!!valueWriter.declaration.outputName
							) {
								altName = valueWriter.declaration.outputName;
							} else if (
								valueWriter.type === EntityType.FunctionCall &&
								valueWriter.declaration.implements?.type ===
									EntityType.ActionDescriptor &&
								!!valueWriter.declaration.implements.outputName
							) {
								altName =
									valueWriter.declaration.implements
										.outputName;
							} else if (
								valueWriter.type === EntityType.Operation ||
								valueWriter.type === EntityType.InternalCall ||
								valueWriter.type === EntityType.FunctionCall
							) {
								altName =
									'Main output of ' +
									resolveEntityName(valueWriter, this.logic);
							}

							const desiredName =
								altName ||
								resolveEntityName(valueWriter, this.logic);

							// Ensure the name is unique in the scope of the writter
							const name = findNextAvailableName(
								desiredName,
								targetTermination.outputs.map(
									(e) => e.declaration
								)
							);

							let newInstance!: InputMapState | PropertyState;

							if (
								targetTermination.parent.type ===
									EntityType.Loop &&
								[
									EntityType.ContinueStatement,
									EntityType.BreakStatement
								].includes(targetTermination.type)
							) {
								const newEntityTransfer =
									InputMapState.new(connectionChangeSet);
								newEntityTransfer.parent =
									targetTermination.toReference();

								newEntityTransfer.name = name;

								newInstance = createStateFromTypeAndSubscribe(
									newEntityTransfer,
									this.logic
								) as InputMapState;

								newInstance.hydrateAncestors();

								connectionChangeSet.add(
									newInstance,
									ChangeSetEntityChangeType.Added
								);

								newInstance.addSelfToProject(
									connectionChangeSet
								);
								newInstance.afterAllChildrenInitialized(
									connectionChangeSet
								);

								targetTermination.afterAllChildrenInitialized(
									connectionChangeSet
								);
							} else if (
								targetTermination.parent.type ===
								EntityType.FunctionDeclaration
							) {
								const parentFuncDeclaration: FunctionDeclarationState =
									targetTermination.parent;
								const dataType =
									targetTermination.parent.dataType;
								let resolvedDataType: DataTypeState = dataType;
								let dataTypeEntity: DefinitionEntityState;

								if (
									!!resolvedDataType.entity &&
									resolvedDataType.entity.type ===
										EntityType.DefinitionEntity &&
									resolvedDataType.entity.parent?.id ===
										resolvedDataType.id
								) {
									dataTypeEntity =
										resolvedDataType.entity as DefinitionEntityState;
								}

								if (!resolvedDataType) {
									const newDataTypeTransfer =
										DataTypeState.new(connectionChangeSet);
									newDataTypeTransfer.parent =
										parentFuncDeclaration.toReference();
									newDataTypeTransfer.inferred = true;

									resolvedDataType =
										createStateFromTypeAndSubscribe(
											newDataTypeTransfer,
											this.logic
										) as DataTypeState;

									resolvedDataType.hydrateAncestors();
									resolvedDataType.addSelfToProject(
										connectionChangeSet
									);
									connectionChangeSet.add(
										resolvedDataType,
										ChangeSetEntityChangeType.Added
									);
									resolvedDataType.initChildren(
										connectionChangeSet
									);
								}

								if (!dataTypeEntity) {
									const newDefEntityTransfer =
										DefinitionEntityState.new(
											connectionChangeSet
										);
									const allOtherDefinitions =
										this.logic.getDefinitionEntities();

									const desiredName =
										'Custom inline definition';

									const newName = findNextAvailableName(
										desiredName,
										allOtherDefinitions
									);

									newDefEntityTransfer.name = newName;
									newDefEntityTransfer.parent =
										resolvedDataType.toReference();

									dataTypeEntity =
										createStateFromTypeAndSubscribe(
											newDefEntityTransfer,
											this.logic
										) as DefinitionEntityState;

									dataTypeEntity.hydrateAncestors();
									dataTypeEntity.addSelfToProject(
										connectionChangeSet
									);
									connectionChangeSet.add(
										dataTypeEntity,
										ChangeSetEntityChangeType.Added
									);
									dataTypeEntity.initChildren(
										connectionChangeSet
									);
									resolvedDataType.setEntity(
										dataTypeEntity,
										connectionChangeSet
									);

									connectionChangeSet.add(
										resolvedDataType,
										ChangeSetEntityChangeType.Updated
									);
								}

								const newPropertyTransfer =
									PropertyState.new(connectionChangeSet);
								newPropertyTransfer.parent =
									dataTypeEntity.toReference();

								newPropertyTransfer.name = name;

								const newProperty =
									createStateFromTypeAndSubscribe(
										newPropertyTransfer,
										this.logic
									) as PropertyState;

								newProperty.hydrateAncestors();
								newProperty.addSelfToProject(
									connectionChangeSet
								);
								connectionChangeSet.add(
									newProperty,
									ChangeSetEntityChangeType.Added
								);
								newProperty.initChildren(connectionChangeSet);

								const newEntityInputTransfer =
									TerminationInputMapState.new(
										connectionChangeSet
									);
								newEntityInputTransfer.parent =
									targetTermination.toReference();
								newEntityInputTransfer.declaration =
									newProperty.toJSON() as IPropertyTransfer;

								newInstance = createStateFromTypeAndSubscribe(
									newEntityInputTransfer,
									this.logic
								) as TerminationInputMapState;

								newInstance.hydrateAncestors();
								newInstance.addSelfToProject(
									connectionChangeSet
								);
								connectionChangeSet.add(
									newInstance,
									ChangeSetEntityChangeType.Added
								);
								newInstance.initChildren(connectionChangeSet);

								dataType.metaSync(
									{
										inferred: false
									},
									connectionChangeSet
								);
							}

							connectionChangeSet.add(
								this
									.onGoingConnectionTarget as UserManagedEntityState,
								ChangeSetEntityChangeType.Affected
							);
							// Recalculating parent scope entity
							(
								this
									.onGoingConnectionTarget as TerminationEntityState
							).parent // | ContinueStatementState // | BreakStatementState
								.afterAllChildrenInitialized(
									connectionChangeSet
								);

							await applyConnectionCompatibilityAutoFixes(
								this.onGoingConnectionSource,
								this.onGoingConnectionTarget,
								options.nodeType,
								connectionChangeSet,
								{
									compatible:
										this
											.onGoingConnectionCompatibleEntities,
									incompatible:
										this
											.onGoingConnectionIncompatibleEntities
								},
								{
									onConnection: this.addCallerConnection,
									onCallRemoved: this.removeCallConnection
								}
							);

							this.renderAndCloseChangeSet(connectionChangeSet);

							this.onGoingConnectionTarget = newInstance;
						} else if (
							this.onGoingConnectionTarget.type ===
							EntityType.Search
						) {
							connectionChangeSet.actionName =
								StateMutationAction.ConnectValueToNewSearchInput;

							const { inputMap, declaration } =
								initializeNewInputDeclarationForSearch(
									this,
									this.onGoingConnectionTarget,
									'Input',
									connectionChangeSet
								);

							inputMap.setValueWriter(
								this
									.onGoingConnectionSource as ValueWritingEntityState,
								connectionChangeSet
							);
							(
								this
									.onGoingConnectionSource as ValueWritingEntityState
							).addValueReader(inputMap, connectionChangeSet);

							this.onGoingConnectionTarget = inputMap;

							if (!declaration.dataType) {
								const newDT =
									DataTypeState.new(connectionChangeSet);
								newDT.parent = declaration.toReference();
								newDT.inferred = true;

								const newDTInstance =
									createStateFromTypeAndSubscribe(
										newDT,
										this.logic
									) as DataTypeState;

								newDTInstance.hydrateAncestors();
								newDTInstance.addSelfToProject(
									connectionChangeSet
								);
								connectionChangeSet.add(
									newDTInstance,
									ChangeSetEntityChangeType.Added
								);
								newDTInstance.initChildren(connectionChangeSet);

								declaration.setDataType(
									newDTInstance,
									connectionChangeSet
								);
							}

							if (
								!!(
									this
										.onGoingConnectionSource as ValueWritingEntityState
								).getDataType()
							) {
								declaration.dataType.merge(
									(
										this
											.onGoingConnectionSource as ValueWritingEntityState
									).getDataType()!,
									connectionChangeSet
								);
							}
						}

						await targetCanvasElement.render({
							debug: false
						});

						this.onGoingConnectionTargetId = getCanvasEntityDOMId(
							this.onGoingConnectionTarget
						);

						this.canvas?.activeConnectionDrawing.snap(
							getCanvasEntityDOMId(this.onGoingConnectionTarget)
						);
					}

					const sourceDOMElement = document.getElementById(
						this.onGoingConnectionSourceId
					);
					const targetDOMElement = document.getElementById(
						this.onGoingConnectionTargetId
					);

					const resolvedConnectionDrawingOptions: IConnectionOptions =
						callConnectionTypes.includes(options.nodeType)
							? {
									dash: { animation: false },
									size: 5,
									color: 'var(--color-main-grey)'
								}
							: {
									size: 3
								};

					this.canvas?.connect(
						sourceDOMElement,
						this.onGoingConnectionSourceId,
						targetDOMElement,
						this.onGoingConnectionTargetId,
						sourceCanvasElement.draggableObject,
						targetCanvasElement.draggableObject,
						resolvedConnectionDrawingOptions
					);

					if (!!this.onGoingConnectionTarget) {
						// Add entities to change set
						connectionChangeSet.add(
							this
								.onGoingConnectionTarget as UserManagedEntityState,
							ChangeSetEntityChangeType.Updated
						);
					}

					if (!!this.onGoingConnectionSource) {
						// Add entities to change set
						connectionChangeSet.add(
							this
								.onGoingConnectionSource as UserManagedEntityState,
							ChangeSetEntityChangeType.Affected
						);
					}

					if (this.onGoingConnectionSource?.id) {
						this.emitAsync(this.onGoingConnectionSource?.id, {});
					}
					if (this.onGoingConnectionTarget?.id) {
						this.emitAsync(this.onGoingConnectionTarget?.id, {});
					}

					await applyConnectionCompatibilityAutoFixes(
						this.onGoingConnectionSource,
						this.onGoingConnectionTarget,
						options.nodeType,
						connectionChangeSet,
						{
							compatible:
								this.onGoingConnectionCompatibleEntities,
							incompatible:
								this.onGoingConnectionIncompatibleEntities
						},
						{
							onConnection: this.addCallerConnection,
							onCallRemoved: this.removeCallConnection
						}
					);

					this.renderAndCloseChangeSet(connectionChangeSet);

					this.clearOnGoingConnectionState();

					return;
				}

				// this.emitAsync('canvas-connection-end', {});

				if (!!this.onGoingConnectionTarget) {
					// Add entities to change set
					connectionChangeSet.add(
						this.onGoingConnectionTarget as UserManagedEntityState,
						ChangeSetEntityChangeType.Updated
					);
				}

				if (!!this.onGoingConnectionSource) {
					// Add entities to change set
					connectionChangeSet.add(
						this.onGoingConnectionSource as UserManagedEntityState,
						ChangeSetEntityChangeType.Affected
					);
				}

				// Close in case it wasn't closed yet
				await applyConnectionCompatibilityAutoFixes(
					this.onGoingConnectionSource,
					this.onGoingConnectionTarget,
					options.nodeType,
					connectionChangeSet,
					{
						compatible: this.onGoingConnectionCompatibleEntities,
						incompatible: this.onGoingConnectionIncompatibleEntities
					},
					{
						onConnection: this.addCallerConnection,
						onCallRemoved: this.removeCallConnection
					}
				);

				this.renderAndCloseChangeSet(connectionChangeSet);

				// Sometimes we want to offset the coordinates of the menu spawn
				const resolvedCoordinates = {
					x: !startsInSource
						? coordinates.x - CANVAS_CARD_WIDTH
						: coordinates.x,
					y: coordinates.y
				};

				await this.showEntityCreationMenu(resolvedCoordinates, options);

				let menuConnectionAnchorId: string =
					getCreateEntityMenuHeaderNodeId();

				// If the connection comes from the right, we connect it to the menu success and error nodes
				if (options.nodeType === ConnectionNodeType.CalledBy) {
					menuConnectionAnchorId = getCreateEntityMenuSuccessNodeId();
				} else if (options.nodeType === ConnectionNodeType.PropertyIn) {
					menuConnectionAnchorId =
						getCreateEntityMenuMainValueOutputNodeId();
				} else if (
					options.nodeType === ConnectionNodeType.PropertyOut
				) {
					menuConnectionAnchorId =
						getCreateEntityMenuMainValueInputNodeId();
				}

				const menuConnectionElement =
					this.createEntityMenu.ref.querySelector(
						'#' + menuConnectionAnchorId
					) as HTMLElement;

				// When the menu has been drawn, we should attack the connection to the menu execution node
				// Then remove the active connectionDrawing

				// We need to set two draggable objects as the source and target of the connection
				// One is the original source or target, the other is the menu
				// Here we decide which is which
				const sourceDraggableObject = startsInSource
					? options.draggableObject
					: this.createEntityMenu.canvasObject;
				const targetDraggableObject = startsInSource
					? this.createEntityMenu.canvasObject
					: options.draggableObject;

				const source: HTMLElement = startsInSource
					? connectionDrawing.anchorElement
					: menuConnectionElement;
				const startId: string =
					connectionDrawing.sourceId || menuConnectionAnchorId;
				const target: HTMLElement = startsInSource
					? menuConnectionElement
					: connectionDrawing.anchorElement;
				const endId: string =
					connectionDrawing.targetId || menuConnectionAnchorId;
				const draggableSourceParent: DraggableObject | CanvasObject =
					sourceDraggableObject;
				const draggableTargetParent: DraggableObject | CanvasObject =
					targetDraggableObject;

				this.canvas?.restoreScroll();

				// Based on what entity is being connected, the connection line will look different
				const fixedConnectionOptions: IConnectionOptions =
					callConnectionTypes.includes(options.nodeType)
						? {
								dash: { animation: true },
								size: 5,
								color: 'var(--color-main-primary)'
							}
						: {
								color: 'var(--color-main-primary)',
								size: 3
							};

				// Remove the active connection being drawing
				this.clearOnGoingConnectionState();

				this.canvas?.connect(
					source,
					startId,
					target,
					endId,
					draggableSourceParent,
					draggableTargetParent,
					fixedConnectionOptions
				);
			})
			.init();
	}

	removeValueByOwnerId(entityId: EntityId) {
		if (!this.logic) {
			return;
		}
		const valueOwner = this.logic.get(entityId);
		if (!valueOwner) {
			return;
		}

		if (!ENTITY_WITH_VALUE_TYPES.includes(valueOwner.type)) {
			return;
		}

		handleLiteralValueDelete(
			valueOwner as EntityWithValueState,
			this.logic,
			this.localTestValues
		);
		handleLiteralValueDelete(
			valueOwner as EntityWithValueState,
			this.logic,
			this.lastExecutionResults
		);
		handleLiteralValueDelete(
			valueOwner as EntityWithValueState,
			this.logic,
			this.persistedExecutionResults
		);
	}

	// Removes the value of an entity, from any store that is relevant, based on the payload of the value
	removeValue(dynamicValue: IDynamicValue) {
		if (dynamicValue.type === DynamicValueTypes.Testing) {
			handleLiteralValueDelete(
				dynamicValue.valueOwner,
				this.logic,
				this.localTestValues
			);
		} else if (dynamicValue.type === DynamicValueTypes.ExecutionResult) {
			if (
				!!this.lastExecutionResults?.readValue(
					dynamicValue.valueOwner.id
				)
			) {
				handleLiteralValueDelete(
					dynamicValue.valueOwner,
					this.logic,
					this.lastExecutionResults
				);
			} else if (
				!!this.persistedExecutionResults.readValue(
					dynamicValue.valueOwner.id
				)
			) {
				handleLiteralValueDelete(
					dynamicValue.valueOwner,
					this.logic,
					this.persistedExecutionResults
				);
			} else if (
				!!this.resolvedValues.readValue(dynamicValue.valueOwner.id)
			) {
				handleLiteralValueDelete(
					dynamicValue.valueOwner,
					this.logic,
					this.resolvedValues
				);
			} else {
				// The value is for whatever reason no longer present in any store,
				// So we trigger an entity update
				this.emit(dynamicValue.valueOwner.id, {});
			}
		}
	}

	async hideEntityCreationMenu() {
		if (this.isCreateEntityMenuOpen) {
			// Remove the previous component
			if (this.createEntityMenu) {
				await this.createEntityMenu.remove();
				this.createEntityMenu = null;
			}

			this.isCreateEntityMenuOpen = false;
			return;
		}
	}

	async showEntityCreationMenu(
		coordinates: { x: number; y: number },
		connectionOptions: IConnectionDrawingOptions = null
	): Promise<CanvasMenuElement> {
		const canvasMenuElement = new CanvasMenuElement(this, {
			coordinates,
			connectionOptions
		});

		await canvasMenuElement.init();

		this.createEntityMenu = canvasMenuElement;
		this.isCreateEntityMenuOpen = true;

		return canvasMenuElement;
	}

	async toggleEntityCreationMenu(
		coordinates: { x: number; y: number },
		connectionOptions: IConnectionDrawingOptions = null
	): Promise<CanvasMenuElement> {
		if (
			this.isCreateEntityMenuOpen ||
			!!this.canvas?.selectedObjects.length
		) {
			await this.hideEntityCreationMenu();
			return;
		}

		await this.showEntityCreationMenu(coordinates, connectionOptions);

		return this.createEntityMenu;
	}

	async hideConnectionDeleteButtonElement() {
		// Remove the previous component
		if (!!this.deleteConnectionElement) {
			await this.deleteConnectionElement.remove();
			this.deleteConnectionElement = null;
		}

		return;
	}

	async showConnectionDeleteButtonElement(
		connection: Connection
	): Promise<CanvasConnectionDeleteButtonElement> {
		if (!!this.deleteConnectionElement) {
			return this.toggleConnectionDeleteButtonElement(connection);
		}

		const canvasConnectionDeleteButtonElement =
			new CanvasConnectionDeleteButtonElement(this, {
				connection
			});

		await canvasConnectionDeleteButtonElement.init();

		this.deleteConnectionElement = canvasConnectionDeleteButtonElement;

		connection.setDeleteObject(
			canvasConnectionDeleteButtonElement.canvasObject
		);

		return canvasConnectionDeleteButtonElement;
	}

	// Remove old connection delete button and create a new one
	async toggleConnectionDeleteButtonElement(
		connection: Connection
	): Promise<CanvasConnectionDeleteButtonElement> {
		await this.hideConnectionDeleteButtonElement();

		return this.showConnectionDeleteButtonElement(connection);
	}

	async removeCallConnection(
		sourceEntity: CallerEntityState,
		targetEntity: CallableEntityState,
		callType: 'success' | 'error' | 'entry' | 'loop-body'
	) {
		const canvasParentOfSource = getParentCanvasEntity(sourceEntity);

		const sourceElement = this.getElement(canvasParentOfSource.id);

		if (!sourceElement) {
			Logger.warn(
				`Failed to find canvas element for source entity ${sourceEntity.id} when trying to remove call connection`
			);
			return;
		}

		let startId = getCanvasEntitySuccessCallerNodeDOMId(sourceEntity);

		if (['entry', 'loop-body'].includes(callType)) {
			startId = getCanvasEntityEntryCallerNodeDOMId(sourceEntity);
		} else if (callType === 'error') {
			startId = getCanvasEntityErrorCallerNodeDOMId(sourceEntity);
		}

		const endId = getCanvasEntityExecutionNodeId(targetEntity);

		this.canvas?.disconnect(startId, endId, sourceElement.draggableObject);
	}

	resolveConnections(
		canvasEntities: CanvasEntityElement[],
		options: {
			debug?: boolean;
		} = { debug: false }
	) {
		canvasEntities.forEach((createdElement) => {
			try {
				if (options.debug) {
					debugger;
				}

				setupEntityConnectionsInCanvas(createdElement, this, options);

				if (options.debug) {
					debugger;
				}
			} catch (error) {
				Logger.warn('Entity failed to setup its connections: ', error);
			}
		});
	}

	async getAllProjectLogicErrors(
		options: YieldOptions = {}
	): Promise<EntityError[]> {
		const tracker = YieldTracker.from(options);

		let errors: EntityError[] = [];

		const allActiveEntities = this.logic.instancesList;
		const allDeletedEntities = Object.values(this.logic.deletedInstances);

		const allEntities = [...allActiveEntities, ...allDeletedEntities];

		for (const entity of allEntities) {
			const entityErrors = await entity.getErrorsAsync();
			errors = [...errors, ...entityErrors];

			// Yield to the main thread to avoid blocking for too long
			await tracker.tick();
		}

		return (await filterOutDuplicateErrorsAsync(errors, {
			tracker
		})) as EntityError[];
	}

	async recalculateValidate(options: YieldOptions = {}) {
		const tracker = YieldTracker.from(options);

		const oldProjectErrors = await this.getAllProjectLogicErrors({
			tracker
		});
		await this.validateProjectState({ tracker });
		const newProjectErrors = await this.getAllProjectLogicErrors({
			tracker
		});

		// Remove any `oldProjectErrors` no longer present in the `newProjectErrors`
		const errorsToRemove = oldProjectErrors.filter(
			(error) =>
				!newProjectErrors.some((newError) => newError.id === error.id)
		);

		for (const error of errorsToRemove) {
			// Remove errors from the notification store
			notifications.remove(this.PROJECT_NOTIFICATIONS_CHANNEL, error.id);

			await this.emitAsync(error.entity.id, {});

			await tracker.tick();
		}
	}

	async recalculateValidateEntity(
		entity: UserManagedEntityState,
		options: YieldOptions = {}
	) {
		const tracker = YieldTracker.from(options);

		const oldEntityErrors = await entity.getErrorsAsync({ tracker });
		if (typeof (entity as any).validateAsync === 'function') {
			await (entity as any).validateAsync({ tracker });
		}
		const newEntityErrors = await entity.getErrorsAsync({ tracker });

		// Remove any `oldEntityErrors` no longer present in the `newEntityErrors`
		const errorsToRemove = oldEntityErrors.filter(
			(error) =>
				!newEntityErrors.some((newError) => newError.id === error.id)
		);

		for (const error of errorsToRemove) {
			// Remove errors from the notification store
			notifications.remove(this.PROJECT_NOTIFICATIONS_CHANNEL, error.id);
			await tracker.tick();
		}

		await this.emitAsync(entity.id, {});
	}

	async renderChangeSets(
		changeSets: ChangeSet[],
		options?: IRenderOptions & { order: 'reversal' | 'forward' }
	) {
		const order = options?.order || 'forward';

		const aggrCanvasEntitiesTouched: CanvasEntityState[] = [];
		const aggrCanvasEntitiesRemoved: UserManagedEntityState[] = [];

		// Sort change-sets by their creation time, oldest first
		changeSets.forEach((changeSet) => {
			const touchedEntities: CanvasEntityState[] =
				getTouchedCanvasEntitiesFromChangeSet(changeSet);

			const entitiesRemoved: UserManagedEntityState[] = Object.values(
				changeSet.removed
			);

			// If this changeSet
		});

		const uniqueDeletedEntities = filterOutNonCanvasEntities(
			aggrCanvasEntitiesRemoved
		);
		const uniqueCanvasTouchedEntities = filterOutNonCanvasEntities(
			aggrCanvasEntitiesTouched
		);

		return await Promise.all([
			this.render(uniqueCanvasTouchedEntities, options),
			uniqueDeletedEntities.map(async (ent) => {
				this.removeValueByOwnerId(ent.id);
				await this.getElement(ent.id)?.remove({ quiet: true });
				delete this.elements[ent.id];
			})
		]);
	}

	async renderAndCloseChangeSet(
		changeSet: ChangeSet,
		options?: IRenderOptions & {
			skipClosing?: boolean;
			skipRecalculation?: boolean;
		}
	) {
		const optionsWithDefaults: IRenderOptions & {
			skipClosing: boolean;
			skipRecalculation: boolean;
		} = {
			skipConnections: false,
			debug: false,
			skipClosing: false,
			skipRecalculation: false,
			...options
		};

		const canvasEntitiesTouched: CanvasEntityState[] =
			getTouchedCanvasEntitiesFromChangeSet(changeSet);

		const tracker = YieldTracker.from({ yieldEvery: 100 });

		if (changeSet.open) {
			if (!optionsWithDefaults.skipRecalculation) {
				for (const entity of canvasEntitiesTouched) {
					// This is to re-calculate missing entities, and/or add suggestions
					entity.afterAllChildrenInitialized(changeSet);

					// Yield to the main thread to avoid blocking for too long
					await tracker.tick();
				}
			}
		}

		this.recalculateValidate({ tracker });

		const afterCloseCanvasEntitiesTouched: CanvasEntityState[] =
			getTouchedCanvasEntitiesFromChangeSet(changeSet);

		const entitiesRemoved: UserManagedEntityState[] = Object.values(
			changeSet.removed
		);

		const uniqueDeletedEntities =
			filterOutNonCanvasEntities(entitiesRemoved);

		const valueOwnerEntities = afterCloseCanvasEntitiesTouched.filter(
			(entity) => ENTITY_WITH_VALUE_TYPES.includes(entity.type)
		);

		// RENDER 1
		Promise.all([
			...valueOwnerEntities.map(async (entity) =>
				this.emitAsync(entity.id, {})
			),
			this.render(afterCloseCanvasEntitiesTouched, optionsWithDefaults),
			uniqueDeletedEntities.map(async (ent) => {
				this.removeValueByOwnerId(ent.id);
				await this.getElement(ent.id)?.remove({ quiet: true });
				delete this.elements[ent.id];
			})
		]);

		this.emit('before-change-set-close', changeSet);

		if (!optionsWithDefaults.skipClosing) {
			try {
				if (EditorService.SAVING_ENABLED && !this.READ_ONLY) {
					await changeSet?.closeAsync({
						awaitExternalPersist: false,
						persistType: 'parallel'
					});
				} else {
					console.warn(
						'Change set closed without saving, because saving is disabled or the editor is in read-only mode.'
					);
					// window.alert(
					// 	'Changes were not saved, because saving is disabled or the editor is in read-only mode.'
					// );
				}
			} catch (error) {
				this.emit('change-set-submission-failed', changeSet);
				popupNotification({
					color: 'error',
					text: 'Failed to save changes'
				});
				console.error(
					'Failed to close change set: ',
					error,
					'\n',
					changeSet
				);

				this.renderedChangeSetEvents.delete(changeSet.id);

				// TODO: Maybe rollback changes here?
				return;
			}
		}

		// This is to notify the "project-name" component to update the name in the UI if it has changed
		this.emit(this.projectId, {});

		// RENDER 2
		await Promise.all([
			...valueOwnerEntities.map(async (entity) =>
				this.emitAsync(entity.id, {})
			),
			this.render(afterCloseCanvasEntitiesTouched, optionsWithDefaults),
			...uniqueDeletedEntities.map(async (ent) => {
				this.removeValueByOwnerId(ent.id);
				await this.getElement(ent.id)?.remove({ quiet: true });
				delete this.elements[ent.id];
			})
		]).then(() => {
			this.test?.validateLogicAsync().then(() => {
				this.test?.render().then(() => {
					this.teardownEntityEvents(entitiesRemoved);
					this.renderedChangeSetEvents.delete(changeSet.id);
				});
			});
		});
	}

	async remove(entityId: EntityId) {
		const entity = this.logic.get(entityId) as UserManagedEntityState;

		if (!entity) {
			return;
		}

		let actionName = StateMutationAction.RemoveNode;

		try {
			const readableEntityType =
				READABLE_ENTITY_TYPES[entity.type]?.shortSingular || 'Node';

			actionName =
				`remove-${toKebabCase(readableEntityType)}` as StateMutationAction;
		} catch (error) {
			Logger.warn(
				'Failed to find readable entity type for entity type: ',
				entity.type
			);
		}

		const deletionChangeSet = this.logic.addChangeSet(
			new ChangeSet(
				this.logic,
				ProjectState.sessionAuthor,
				new Date().toISOString(),
				entity,
				false,
				actionName
			)
		);

		entity.remove({ ignoreUpstream: false }, deletionChangeSet);

		await this.renderAndCloseChangeSet(deletionChangeSet);
	}

	deferConnections(...canvasEntities: CanvasEntityElement[]) {
		// Check if the entities don't already exist,
		// by instance first and entity id seconds,
		// before adding them to the deffered list
		canvasEntities.forEach((canvasEntity) => {
			if (this.defferedElementsToConnect.includes(canvasEntity)) {
				return;
			}

			const existingEntity = this.defferedElementsToConnect.find(
				(element) => element.entity.id === canvasEntity.entity.id
			);

			// Replace the instance
			if (existingEntity) {
				this.defferedElementsToConnect[
					this.defferedElementsToConnect.indexOf(existingEntity)
				] = canvasEntity;
				return;
			}

			this.defferedElementsToConnect.push(canvasEntity);
		});
	}

	connectDefferedEntities() {
		// Connect all the elements now that they have been created and rendered
		this.resolveConnections(this.defferedElementsToConnect);

		// Clear the deffered elements
		this.defferedElementsToConnect = [];
	}

	async render(
		layout: CanvasEntityState[],
		options: IRenderOptions = { skipConnections: false, debug: false }
	): Promise<CanvasEntityElement[]> {
		if (options.debug) {
			debugger;
		}

		// Initialize all canvas elements
		const canvasElements: CanvasEntityElement[] = layout.map((entity) =>
			this.getOrCreateElementFromEntity(entity)
		);

		if (options.debug) {
			debugger;
		}

		// Create the entities
		const newCanvasEntities = await Promise.all(
			canvasElements.map(async (element) => {
				if (options.debug) {
					debugger;
				}

				if (!element.initialized) {
					await element.init({ debug: options.debug });

					if (options.debug) {
						debugger;
					}

					options.onEachRendered?.(element);

					return element;
				}

				await element.render({ debug: options.debug });

				this.resolveConnections([element]);

				options.onEachRendered?.(element);

				return element;
			})
		);

		if (options.skipConnections) {
			if (options.debug) {
				debugger;
			}

			return newCanvasEntities;
		}

		if (options.debug) {
			debugger;
		}

		this.canvas?.persistScroll();

		if (options.debug) {
			debugger;
		}

		return newCanvasEntities;
	}

	handleUpdateEntitiesMessage(entitiesTransfer: ElementGenerationTarget[]) {
		if (this.abortedGeneration) {
			return;
		}

		Logger.log('handleUpdateEntitiesMessage: ', entitiesTransfer);

		entitiesTransfer.forEach((entityTransfer) => {});
	}

	handleNotificationChannelsMessage(message: ILiveMessageDTO): void {
		Logger.log('detected subscribed-channels: ', message.payload);
		const data: { channels: IChannelConnections[] } = message.payload as {
			channels: IChannelConnections[];
		};

		if (
			message.action === DTOAction.SubscribeChannelsV1 &&
			message.event === 'subscribed-channels'
		) {
			// Do nothing. We should not overwrite this tab's unique sessionId with the broadcaster's sessionId.
		}

		if (!!data?.channels && Array.isArray(data.channels)) {
			this.peerConnections = data.channels.reduce(
				(acc: { [key: string]: IChannelConnections }, channel) => {
					acc[channel.channel] = channel;
					return acc;
				},
				{}
			);

			this.emit('peer-connections-updated', this.peerConnections);
		}

		// Add the payload to the state
		// if (message.event === 'subscribed-channels') {
		// } else if (message.event === 'new-connection') {
		// 	this.peerConnections = data.channels.reduce(
		// 		(acc: { [key: string]: IChannelConnections }, channel) => {
		// 			acc[channel.channel] = channel;
		// 			return acc;
		// 		},
		// 		{}
		// 	);

		// 	this.emit(
		// 		'peer-connections-updated',
		// 		this.peerConnections
		// 	);
		// }

		Logger.log('Updated peerConnections: ', this.peerConnections);

		return;
	}

	handleStartingLogicGenerationMessage(message: ILiveMessageDTO): void {
		Logger.log('detected subscribed-channels: ', message.payload);

		switch (message.event) {
			case 'generate-starting-logic-start': {
				Logger.warn('generate-starting-logic-start', message);
				this.abortedGeneration = false;
				return;
			}
			case 'prompt-validation': {
				if (message.payload.isUserProvidedPromptValid) {
					// Globally disable canvas
					this.disableCanvasGlobally();

					EditorService.navigate(
						`${this.editorBasePath}/generating-starting-logic/${message.payload.taskId}`
					);
				}
				return;
			}
			case 'generate-starting-logic-failed': {
				popupNotification({
					color: 'error',
					text: 'An error occurred while generating the starting logic. Please try again later.',
					delay: 4000
				});

				this.abortedGeneration = true;
				if (!this.READ_ONLY) {
					this.enableCanvasGlobally();
				}

				EditorService.navigate(`${this.editorBasePath}`);

				return;
			}
			case 'generation-rate-limited': {
				const waitMs = message.payload?.waitMs ?? 0;
				const attempt = message.payload?.attempt ?? 0;
				const willRetry = message.payload?.willRetry ?? false;

				this.emit('generation-rate-limited', message.payload);

				popupNotification({
					color: 'warning',
					text: willRetry
						? `AI provider is rate-limited. Retrying in ${Math.round(waitMs / 1000)}s (attempt ${attempt}).`
						: `AI provider is rate-limited. No more retries will be attempted.`,
					delay: Math.min(Math.max(waitMs, 3000), 6000)
				});
				return;
			}
			case 'generation-rate-limit-resolved': {
				this.emit('generation-rate-limit-resolved', message.payload);

				popupNotification({
					color: 'success',
					text: 'Generation resumed.',
					delay: 2500
				});
				return;
			}
			case 'generate-starting-logic-finished': {
				popupNotification({
					color: 'success',
					text: 'Starting logic generated successfully.',
					delay: 4000
				});
				this.abortedGeneration = true;

				if (!this.READ_ONLY) {
					this.enableCanvasGlobally();
				}

				EditorService.navigate(`${this.editorBasePath}`);

				return;
			}
			case 'abort-generation-success': {
				popupNotification({
					text: 'Generation aborted successfully.',
					delay: 4000
				});

				this.abortedGeneration = true;

				if (!this.READ_ONLY) {
					this.enableCanvasGlobally();
				}
				EditorService.navigate(`${this.editorBasePath}`);
				return;
			}
			case 'abort-generation-failed': {
				popupNotification({
					color: 'error',
					text: 'Failed to abort generation. Please try again.',
					delay: 4000
				});

				this.abortedGeneration = true;

				return;
			}
			case 'not-found': {
				popupNotification({
					text: 'The generation task was not found. It may have already been completed or aborted.',
					delay: 4000
				});

				this.abortedGeneration = true;

				if (!this.READ_ONLY) {
					this.enableCanvasGlobally();
				}

				EditorService.navigate(`${this.editorBasePath}`);
				return;
			}
			default:
				if (message.message === 'Internal Server Error') {
					popupNotification({
						color: 'error',
						text: 'An error occurred while processing your request. Please try again later.',
						delay: 4000
					});

					if (!this.READ_ONLY) {
						this.enableCanvasGlobally();
					}

					this.abortedGeneration = true;
					return;
				}
		}

		if (message.type === LiveMessageEventType.Error) {
			popupNotification({
				color: 'error',
				text: 'An error occurred while generating the starting logic. Please try again later.',
				delay: 4000
			});
			if (!this.READ_ONLY) {
				this.enableCanvasGlobally();
			}
			this.abortedGeneration = true;

			return;
		}
	}

	async handleReconnectingWebsocket() {
		Logger.log('Reconnecting websocket...');

		// Show notification
		// popupNotification({
		// 	color: 'warning',
		// 	text: 'Reconnecting session...'
		// });

		await this.subscribeToProjectNotificationsChannel();

		// Send message to reconnect
		// this.socket.send({
		// 	action: DTOAction.ReconnectSessionV1,
		// 	actionId: ProjectState.UUID.uuid(),
		// 	userAuthor: ProjectState.sessionAuthor,
		// 	agentAuthor: null,
		// 	emittedAt: new Date().toISOString(),
		// 	channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
		// 	sessionId: this.sessionId as string,
		// 	authorization: 'Bearer ' + (await this.getAccessToken()),
		// 	type: LiveMessageEventType.Post,
		// 	event: null,
		// 	message: null,
		// 	payload: null,
		// });
	}

	async handleClosedWebsocket() {
		Logger.log('Websocket closed.');

		this.socketUnexpectedlyClosed = true;

		// Show notification
		// popupNotification({
		// 	color: 'error',
		// 	text: 'Session disconnected. Attempting to reconnect...'
		// });
	}

	// async handleOpenedWebsocket() {
	// 	Logger.log('Websocket opened.');

	// 	if (this.socketUnexpectedlyClosed) {
	// 		this.socketUnexpectedlyClosed = false;

	// 		// Show notification
	// 		popupNotification({
	// 			color: 'success',
	// 			text: 'Session reconnected.',
	// 		});
	// 	}
	// }

	handleChunkedChangeSetMessage(
		message: PersistChangeSetEntityActionRequestPayload
	): PersistChangeSetEntityActionRequestPayload | null {
		const { chunkIndex, totalChunks } = message.payload;

		// 1. If not a chunked message, return original payload to proceed as normal
		if (
			typeof chunkIndex !== 'number' ||
			typeof totalChunks !== 'number' ||
			totalChunks <= 1
		) {
			return message;
		}

		// 2. Store the chunk
		if (!this._cachedChangeSetChunks.has(message.actionId)) {
			const chunksMap = new Map<
				number,
				PersistChangeSetEntityActionRequestPayload
			>();

			chunksMap.set(chunkIndex, message);

			this._cachedChangeSetChunks.set(message.actionId, chunksMap);
		} else {
			const chunksMap = this._cachedChangeSetChunks.get(
				message.actionId
			)!;
			chunksMap.set(chunkIndex, message);
		}

		// 3. Check if we have all chunks
		const storedChunksMap = this._cachedChangeSetChunks.get(
			message.actionId
		)!;

		if (storedChunksMap.size < totalChunks) {
			// Still waiting for more chunks
			return null;
		}

		// 4. Assemble full change-set
		const assembledPayload: PersistChangeSetEntityActionRequestPayload['payload'] =
			{
				added: {},
				updated: {},
				removed: {},
				affected: [],
				self: null,
				seenEntities: [],
				isNewBranchHead: message.payload.isNewBranchHead,
				branch: message.payload.branch,
				totalChunks: 1, // Assembled now
				chunkIndex: 0
			};

		const seenEntitiesSet: Set<EntityId> = new Set();
		const affectedSet: Set<EntityId> = new Set();

		// Merge all chunks
		for (let i = 0; i < totalChunks; i++) {
			const chunkMessage = storedChunksMap.get(i);
			if (!chunkMessage) {
				// Missing chunk, should not happen as we checked size before
				console.error(
					`Missing chunk ${i} for change-set ${message.actionId}`
				);
				return null;
			}

			const chunkPayload = chunkMessage.payload;

			// Merge added
			if (chunkPayload.added) {
				Object.assign(assembledPayload.added, chunkPayload.added);
			}

			// Merge updated
			if (chunkPayload.updated) {
				Object.assign(assembledPayload.updated, chunkPayload.updated);
			}

			// Merge removed
			if (chunkPayload.removed) {
				Object.assign(assembledPayload.removed, chunkPayload.removed);
			}

			if (chunkPayload.affected) {
				chunkPayload.affected.forEach((entId) =>
					affectedSet.add(entId)
				);
			}

			if (chunkPayload.seenEntities) {
				chunkPayload.seenEntities.forEach((entId) =>
					seenEntitiesSet.add(entId)
				);
			}

			if (!assembledPayload.self && chunkPayload.self) {
				assembledPayload.self = chunkPayload.self;
			}

			if (
				!assembledPayload.isNewBranchHead &&
				chunkPayload.isNewBranchHead
			) {
				assembledPayload.isNewBranchHead = chunkPayload.isNewBranchHead;
			}

			if (!assembledPayload.branch && chunkPayload.branch) {
				assembledPayload.branch = chunkPayload.branch;
			}
		}

		assembledPayload.affected = Array.from(affectedSet);
		assembledPayload.seenEntities = Array.from(seenEntitiesSet);

		// 5. Clean up cached chunks
		this._cachedChangeSetChunks.delete(message.actionId);

		// 6. Return assembled message
		return {
			...message,
			payload: assembledPayload
		};
	}

	async handlePersistChangeSetMessage(
		_message: PersistChangeSetEntityActionRequestPayload
	): Promise<void> {
		if (this.destroyed) return;

		// We don't want to update the canvas if we are not viewing the actual latest version that teamates are updating
		if (this.isViewingNonHead) return;

		// Ignore our own changes
		if (this.checkIsOwnSession(_message.sessionId)) return;

		try {
			const payload = _message.payload; // Change-set transfer (entities diff)
			if (!payload) {
				return;
			}

			let message: PersistChangeSetEntityActionRequestPayload | null =
				null;

			// We must handle chunked change-sets
			// If a message is chunked, we need to queue and wait for all chunks
			// Once we receive the final chunk, we can assemble and process the full change-set
			if (payload.totalChunks && payload.totalChunks > 1) {
				const maybeFullMessage =
					this.handleChunkedChangeSetMessage(_message);

				if (!maybeFullMessage) {
					// Still waiting for more chunks
					return;
				}

				message = maybeFullMessage;
			} else {
				message = _message;
			}

			// If the project is still being fetched/loaded, queue for later
			if (!this.hasLoadedLogic) {
				// If it isn't already queued
				if (
					!this._externalChangeSetsQueue.find(
						(msg) => msg.actionId === message.actionId
					)
				) {
					this._externalChangeSetsQueue.push(message);
				}
				return;
			}

			// Defensive: we only care about the project entity diff to determine version & prevVersion
			const projectId = this.projectId;
			const projectDiff =
				payload.updated?.[projectId] || payload.added?.[projectId];

			const instancesList = this.logic.instancesList;
			const canvasEntitiesList = instancesList.filter(
				(ent) => getParentCanvasEntity(ent)?.id === ent.id
			) as CanvasEntityState[];

			const wasPreviouslyEmptyProject = canvasEntitiesList.length === 0;

			if (!projectDiff) {
				if (message.payload.isNewBranchHead) {
					// If it is from after the last change we did locally, then add it as our `branchHead`
					const isAfterLastLocal =
						!this.logic ||
						dayjs(message.emittedAt).isAfter(
							dayjs(this.logic.createdAt)
						);

					if (isAfterLastLocal && this.branchHead) {
						this.branchHead = {
							...this.branchHead,
							headVersion: message.actionId
						};
					}
				}

				// If for any reason the project shell isn't in updated/added, apply naively as before.
				const newChangeSet =
					this.logic?.applyExternalChangeSet(message);

				this.emit('applied-external-change-set', message);
				newChangeSet.open = false;
				await this._renderAppliedPeerChangeSet(newChangeSet);
				await this._tryApplyPeerQueues(); // In case this unblocked queued sets;

				if (wasPreviouslyEmptyProject) {
					// Scroll to first ent
					const firstCanvasEnt: CanvasEntityState | null =
						getTouchedCanvasEntitiesFromChangeSet(
							newChangeSet
						)?.[0] || null;

					if (firstCanvasEnt) {
						this.canvas?.scrollToObjectByIdInstantly(
							getCanvasEntityDOMId(firstCanvasEnt)
						);
					}
				}
				return;
			}

			const incomingVersion: string = projectDiff.version;
			const incomingPrev: string | null =
				projectDiff.previousVersion || null;

			if (message.payload.isNewBranchHead) {
				// If it is from after the last change we did locally, then add it as our `branchHead`
				const isAfterLastLocal =
					!this.logic ||
					dayjs(message.emittedAt).isAfter(
						dayjs(this.logic.createdAt)
					);

				if (isAfterLastLocal && this.branchHead) {
					this.branchHead = {
						...this.branchHead,
						headVersion: incomingVersion
					};
				}
			}

			const cs = this.logic.applyExternalChangeSet(message);
			this._peerSeenVersions.add(incomingVersion);

			this.emit('applied-external-change-set', message);

			cs.open = false;
			await this._renderAppliedPeerChangeSet(cs);
			await this._tryApplyPeerQueues();

			if (wasPreviouslyEmptyProject) {
				// Scroll to first ent
				const firstCanvasEnt: CanvasEntityState | null =
					getTouchedCanvasEntitiesFromChangeSet(cs)?.[0] || null;

				if (firstCanvasEnt) {
					this.canvas?.scrollToObjectByIdInstantly(
						getCanvasEntityDOMId(firstCanvasEnt)
					);
				}
			}
			return;

			// Otherwise, cache by prev to try again when its dependency arrives
			this._cachePeerChangeSet(incomingPrev || '__NO_PREV__', message);
		} catch (err) {
			Logger.error('Error handling peer PersistProjectChangeSet:', err);
		}
	}

	/* ⬇️ Helper: cache out-of-order peer change-sets until we learn their previousVersion. */
	private _cachePeerChangeSet(
		prevVersion: string,
		msg: PersistChangeSetEntityActionRequestPayload
	) {
		const list = this._peerPendingByPrev.get(prevVersion) || [];
		list.push(msg);
		this._peerPendingByPrev.set(prevVersion, list);
	}

	/* ⬇️ Helper: after applying any peer change, try to drain queues that became unblocked. */
	private async _tryApplyPeerQueues() {
		let progressed = true;

		// We'll iterate as long as we can resolve at least one queued item per pass
		while (progressed) {
			progressed = false;

			// Keys are previousVersion values we are waiting on
			for (const [prev, queue] of Array.from(
				this._peerPendingByPrev.entries()
			)) {
				// If prev is now known (exists in history) OR prev == current head,
				// we can attempt to apply all queued items for that prev.
				const knownPrevIdx =
					prev === '__NO_PREV__'
						? -1
						: this.logic.history.findIndex(
								(cs) =>
									cs.toJSON().updated[this.projectId]
										?.version === prev
							);

				// We consider it resolvable if:
				// - prev matches current head, OR
				// - prev exists somewhere in history (we can insert as needed), OR
				// - prev == '__NO_PREV__' but its message was repointed in the main handler path
				const resolvable =
					prev === '__NO_PREV__' ||
					knownPrevIdx >= 0 ||
					(this.logic.history.length &&
						prev ===
							this.logic.history[
								this.logic.history.length - 1
							].toJSON().updated[this.projectId]?.version);

				if (!resolvable) continue;

				// Drain this queue (copy to avoid mutation issues)
				const pending = queue.splice(0, queue.length);
				this._peerPendingByPrev.delete(prev);

				for (const msg of pending) {
					// Re-run the main handler; it will now find the prev and apply/insert accordingly.
					await this.handlePersistChangeSetMessage(msg);
					progressed = true;
				}
			}
		}
	}

	/* ⬇️ Helper: render + close change-set returned by applyExternalChangeSet */
	private async _renderAppliedPeerChangeSet(
		newChangeSet: ChangeSet | null | undefined
	) {
		if (!newChangeSet) {
			console.warn(
				'[_renderAppliedPeerChangeSet] Was not provided a change-set to render'
			);
			return;
		}

		const uniqueCanvasEntities = entitiesToUniqueCanvasEntities([
			...newChangeSet.listAdded,
			...newChangeSet.listUpdated,
			...newChangeSet.listAffected
		]);

		const uniqueDeletedEntities = entitiesToUniqueCanvasEntities(
			newChangeSet.listRemoved
		);
		const orderedEntitiesToRender = (await orderEntitiesForTraversalAsync(
			uniqueCanvasEntities,
			{
				allBuiltInEntityIds: this.logic.diggestedBuiltInBaseEntitiesIds,
				yieldEvery: 100
			}
		)) as CanvasEntityState[];

		if (!Object.keys(this.elements).length) {
			// No previous elements on the canvas, let the original bootstrap path handle initial render
			this.canvasLayout = await toCanvasFlatArray(
				this.logic,
				newChangeSet
			);
			this.hasRendered = false;
			await this.initialRender();
		} else {
			// Position newly added canvas entities near their logical parents and render them
			const positionedEntities = this.resolveInitialChildrenPositions(
				null,
				orderedEntitiesToRender,
				newChangeSet
			);

			const shouldNavigateTo = positionedEntities[0];

			await Promise.all(
				uniqueDeletedEntities.map(async (ent) => {
					this.removeValueByOwnerId(ent.id);
					await this.getElement(ent.id)?.remove({ quiet: true });
					delete this.elements[ent.id];
				})
			);

			await this.render(uniqueCanvasEntities, {
				debug: false,
				onEachRendered: (canvasElement) => {
					if (shouldNavigateTo?.id === canvasElement.entity?.id) {
						this.canvas?.scrollToObjectByIdInstantly(
							getCanvasEntityDOMId(shouldNavigateTo)
						);
					}
				}
			});
		}

		// Render & close the in-memory diff (skip persistence)
		newChangeSet.open = false;
		await this.renderAndCloseChangeSet(newChangeSet, {
			skipClosing: true,
			debug: false,
			skipRecalculation: true
		});

		newChangeSet.open = false;
		newChangeSet.dirty = false;
	}

	async handleIncommingWebsocketMessage(message: ILiveMessageDTO) {
		if (this.destroyed) {
			return;
		}

		//  Checking if it is a base AWS error message (since they don't have a consistent structure or event types yet)
		if (
			(message.message || '').toLocaleLowerCase() ===
				'internal server error' &&
			!message.type &&
			!message.event &&
			!message.action
		) {
			popupNotification({
				color: 'error',
				text: 'An error occurred while processing your request. Please try again later.'
			});
			EditorService.navigate(`${this.editorBasePath}`);
			return;
		}

		if (message.event === GenericEventName.Unauthorized) {
			// get new token or logout
			await getCurrentUserOrLogoutRedirect();
			return;
		}

		switch (message.action) {
			case DTOAction.PeerDisconnectedV1:
			case DTOAction.ReconnectSessionV1:
			case DTOAction.SubscribeChannelsV1: {
				this.handleNotificationChannelsMessage(message);
				return;
			}
			case DTOAction.PersistProjectChangeSet: {
				this.handlePersistChangeSetMessage(message as any);
				return;
			}
			case DTOAction.NewLog: {
				if (this.publication) {
					this.publication.addLog(message.payload as ILog);
				}
				return;
			}
			case DTOAction.PublishProjectV1: {
				Logger.log(
					'Detected ' + DTOAction.PublishProjectV1 + ': ',
					message
				);

				switch (message.event) {
					case ProjectPublicationEventName.ProjectPublishRequestAcknowledged: {
						this.publication = new PublicationRun(
							message.payload?.publication as IPublication,
							this
						);

						this.publication.init();

						this.publication.setSteps(
							message.payload
								.publishingSequence as IDeploymentStepDefinition[],
							message.emittedAt
						);

						// As a hack: Check also if current path includes "editor/{projectId}/publication/preview" and then navigate
						if (
							this.checkIsOwnSession(message.sessionId) ||
							window.location.pathname.includes(
								`${this.editorBasePath}/publication/preview`
							)
						) {
							EditorService.navigate(
								`${this.editorBasePath}/publication/publication-sequence/${this.publication.id}`
							);
						} else {
							popupNotification({
								text: 'A new publication has started',
								color: 'primary',
								delay: 5000
							});
						}

						// Add notification
						notifications.push(
							this.PROJECT_NOTIFICATIONS_CHANNEL,
							{
								types: [],
								severity: NotificationSeverity.Info,
								title: 'Publication started',
								message: 'Your project is being published',
								action: {
									type: NotificationActionType.InternalNavigation,
									// Canvas object id to scroll to
									value: `${this.editorBasePath}/publication/publication-sequence/${this.publication.id}`
								}
							},
							'publication-started--' + this.publication.id
						);
						break;
					}
					default: {
						if (!!this.publication) {
							Logger.log(
								'Updating publication with message: ',
								message
							);
							this.publication?.onUpdate(message);
						} else {
							Logger.log('Publication not in state');
						}
					}
				}

				return;
			}
			case 'start-project-starting-logic-generation':
			case 'abort-project-starting-logic-generation': {
				this.handleStartingLogicGenerationMessage(message);
				return;
			}
		}
	}

	async getAccessToken(): Promise<string> {
		return getAccessToken();
	}

	async getRefreshToken(): Promise<string | null> {
		return getRefreshToken();
	}

	async getLastPublishedVersionLogic(options: {
		version: EntityVersion;
		branchId: string;
	}): Promise<ProjectState | null> {
		const [accessToken, refreshToken] = await Promise.all([
			this.getAccessToken(),
			this.getRefreshToken()
		]);

		if (!options.version) {
			throw new Error(
				'Version is required to fetch last published logic'
			);
		}

		console.log(
			'[getLastPublishedVersionLogic] version: ',
			options.version,
			' branchId: ',
			options.branchId
		);

		Logger.log('Fetching project: ', this.projectId);
		return await new Promise(async (resolve, reject) => {
			try {
				const projectState = await getProject(
					{
						id: this.projectId
					},
					{
						ignoreCache: true,
						enrich: false,
						onFetch: async (id) => {
							const fetch = new ProjectFetch(
								this.projectId,
								this.socket,
								accessToken,
								refreshToken,
								this,
								options.branchId,
								options.version
							);

							fetch.onProjectHeadLoaded(
								(projectState, branch) => {
									Logger.log(
										'Last published project version head loaded: ',
										projectState
									);
									this.lastPublishedProjectState =
										projectState;
								}
							);

							fetch.onError((error) => {
								Logger.error(
									'Last published project version fetch error: ',
									error
								);
								this.onProjectSetupErrorCallback?.(error);
								reject(error);
							});

							fetch.sessionId = this.sessionId;

							while (!this.sessionId) {
								console.warn(
									'Session not ready, waiting before starting project fetch'
								);
								// Wait for 200 ms before retrying
								await new Promise((resolve) =>
									setTimeout(resolve, 200)
								);
								fetch.sessionId = this.sessionId;
							}

							const result = await fetch.fetch();
							// Las pub
							Logger.log(
								'Last published project version fetch result: ',
								result
							);

							resolve(result);
							// Las pub
							return result;
						}
					},
					this
				);

				this.lastPublishedProjectState = projectState;

				Logger.log(
					'Last published project version fetch result: ',
					this.lastPublishedProjectState
				);

				resolve(this.lastPublishedProjectState);

				return this.lastPublishedProjectState;
			} catch (error) {
				Logger.error('Failed to fetch project: ', error);
				reject(error);
			}
		});
	}

	async getLogic(
		options: { mockLogic?: ProjectState } = {}
	): Promise<ProjectState | null> {
		const [accessToken, refreshToken] = await Promise.all([
			this.getAccessToken(),
			this.getRefreshToken()
		]);

		let logicLoadingPromiseResolve: (value: null) => void;

		this.logicLoadingPromise = new Promise((resolve) => {
			logicLoadingPromiseResolve = resolve;
		});

		if (!options.mockLogic) {
			// Logger.log('Fetching project: ', this.projectId);
			return await new Promise(async (resolve, reject) => {
				try {
					await this.branchHeadPromise;
					// console.log('Branch fetch result: ', this.branchHead);

					const projectState = await getProject(
						{
							id: this.projectId
						},
						{
							ignoreCache: true,
							mock: this.projectId === mockClientProject.id,
							enrich: false,
							onFetch: async (id) => {
								const fetch = new ProjectFetch(
									this.projectId,
									this.socket,
									accessToken,
									refreshToken,
									this,
									this.branchHead?.branchId,
									// If we are viewing a specific version, we want to fetch that version's logic, not the head's logic
									// If the version is "latest", we want to fetch the head's logic, so we pass `undefined` to fetch the head
									this.viewingVersion === 'latest'
										? undefined
										: this.viewingVersion
								);

								fetch.onProjectHeadLoaded(
									(projectState, _branch) => {
										// console.log(
										// 	'Project head loaded: ',
										// 	projectState
										// );
										this.logic = projectState;

										// If we set the branch head here, we overwrite the actual brach head with whatever the current version that we fetched was
										// this.branchHead = branch;
										this.initialVersion =
											this.logic.version;
										this.onProjectHeadLoadedCallback?.(
											this.logic
										);
										resolve(projectState);
									}
								);

								fetch.onChunkAdded(async (chunk) => {
									// console.log('Chunk added: ', chunk);
									const newInstances = Object.values(
										chunk.record
									);

									// newInstances.forEach((ent) => {
									// 	if (!(ent as ChildEntityState).parent) {
									// 		console.log('Problem: ', ent);
									// 	} else if (
									// 		!((ent as ChildEntityState).parent as ChildEntityState)
									// 			.parent
									// 	) {
									// 		console.log('Here 1: ', ent);
									// 		console.log('Here 2: ', (ent as ChildEntityState).parent);
									// 	}
									// });

									const uniqueCanvasEntities =
										entitiesToUniqueCanvasEntities(
											newInstances
											// Filter out entities that belong to the body of a collapsed entry-point entity type (function-declaration, global-event)
										).filter((entity) => {
											// Recursively, while the parent of the scope owner isn't the project state
											// we should keep checking if the parent is collapsed
											// This is because the current entity could be nested inside of two entry-point entities
											// The inmediate parent, for example the body of the loop, could be un-collapsed, while the entire root scope owner is collapsed
											let topScopeOwner = getScopeOwner(
												entity,
												fetch.projectState
											) as
												| EntityWithLogicScopeState
												| ProjectState;

											if (!topScopeOwner) {
												return;
											}

											if (
												ENTRY_POINT_TYPES.includes(
													topScopeOwner.type
												) &&
												(
													topScopeOwner as EntryPointEntityState
												).collapsed &&
												(
													topScopeOwner as EntryPointEntityState
												).id !== entity.id
											) {
												return false;
											}

											while (
												!!(
													topScopeOwner as EntityWithLogicScopeState
												).parent &&
												(
													topScopeOwner as EntityWithLogicScopeState
												).parent !== fetch.projectState
											) {
												topScopeOwner = (
													topScopeOwner as EntityWithLogicScopeState
												)
													.parent as EntityWithLogicScopeState;

												if (
													ENTRY_POINT_TYPES.includes(
														topScopeOwner.type
													) &&
													(
														topScopeOwner as EntryPointEntityState
													).collapsed &&
													(
														topScopeOwner as EntryPointEntityState
													).id !== entity.id
												) {
													return false;
												}
											}

											return true;
										});

									this.render(uniqueCanvasEntities);
								});

								fetch.onError((error) => {
									console.error(
										'Project fetch error: ',
										error
									);
									this.onProjectSetupErrorCallback?.(error);
									reject(error);
								});

								fetch.sessionId = this.sessionId;

								while (!this.sessionId) {
									// console.warn(
									// 	'Session not ready, waiting before starting project fetch'
									// );
									// Wait for 200 ms before retrying
									await new Promise((resolve) =>
										setTimeout(resolve, 200)
									);
									fetch.sessionId = this.sessionId;
								}

								const result = await fetch.fetch();

								logicLoadingPromiseResolve(null);
								this.onLogicLoadingCompleteCallback?.(result);
								// Actual v
								resolve(result);

								return result;
							}
						},
						this
					);

					this.logic = projectState;

					Logger.debug('Project fetch result: ', this.logic);

					// Actual v
					logicLoadingPromiseResolve(null);
					this.onLogicLoadingCompleteCallback?.(this.logic);

					resolve(this.logic);

					return this.logic;
				} catch (error) {
					Logger.error('Failed to fetch project: ', error);
					reject(error);
				}
			});
		} else {
			this.logic = options.mockLogic;
			this.hasLoadedLogic = true;
			this.onProjectHeadLoadedCallback?.(this.logic);
			logicLoadingPromiseResolve(null);
			this.onLogicLoadingCompleteCallback?.(this.logic);

			return this.logic;
		}
	}

	async getLogicThenProcessExternalChangeSetsQueue(
		options: { mockLogic?: ProjectState } = {}
	) {
		await this.getLogic(options);

		// Sort by emittedAt to process in order
		this._externalChangeSetsQueue.sort((a, b) => {
			const aTime = dayjs(a.emittedAt);
			const bTime = dayjs(b.emittedAt);
			if (aTime.isBefore(bTime)) return -1;
			if (aTime.isAfter(bTime)) return 1;
			return 0;
		});

		// Process any queued external change-sets that arrived before logic was ready
		for (const msg of this._externalChangeSetsQueue) {
			await this.handlePersistChangeSetMessage(msg);
		}
		this._externalChangeSetsQueue = [];
	}

	setupUndoRedo() {
		Logger.log('Setting up undo/redo at editor level: ', this.projectId);
		// We apend the detector element to the body instead of the canvas,
		// so we don't need to worry about the canvas being moved or unmounted
		// Because the state of this element needs to be preserved by the browser
		addUndoEventListener(this, this.projectId, document.body);
	}

	teardownUndoRedo() {
		removeUndoEventListener(this.projectId);
	}

	/*
		We must take the 'logic' tree state to how it was before the last change-set
		The currently active change-set is the one with one index higher than the given 'newActiveIndex'
		For this, we must generate a temporary change-set instance for the reverting changes
		The change-set is the difference between the current active change-set and the change-set at the given index
		This change-set is then used to render the changes to the canvas

		For example:
			If the last change set added some entities, and we revert to the previous change set,
			we must remove those entities from the canvas.
			So in the temporary change-set, those entities will be present under 'removed' and 'added' will be empty
	*/
	async undo() {
		if (!this.branchHead?.branchId) {
			Logger.warn('No branch id found, cannot undo');
			return;
		}

		try {
			const reversalConfig: IProjectVersionTransitionConfig =
				this.logic.undo();

			this.renderAndCloseChangeSet(reversalConfig.transitionalChangeSet, {
				skipClosing: true
			});

			const body: ILiveMessageDTO = {
				action: DTOAction.MoveBranchHead,
				actionId: ProjectState.UUID.uuid(),
				userAuthor: ProjectState.sessionAuthor,
				agentAuthor: null,
				emittedAt: reversalConfig.transitionTime,
				channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
				sessionId: this.sessionId as string,
				authorization: null,
				refreshToken: null,
				type: LiveMessageEventType.Post,
				workspaceId: this.activeWorkspace?.id,
				event: null,
				message: null,
				payload: {
					id: ProjectState.UUID.uuid(),
					branch: this.branchHead?.branchId,
					userAuthor: ProjectState.sessionAuthor,
					versionId: this.logic.version,
					timestamp: reversalConfig.transitionTime,
					actionName: 'undo',
					selfId: this.projectId,
					selfType: EntityType.Project,
					selfVersion: this.logic?.version
				}
			};

			try {
				if (EditorService.SAVING_ENABLED && !this.READ_ONLY) {
					await axios.post(
						`${envConfig.API_BASE_URL}/editor-service/v1/move-branch-head`,
						body,
						{
							headers: {
								Authorization: `Bearer ${await this.getAccessToken()}`
							}
						}
					);

					this.branchHead = {
						...this.branchHead,
						headVersion: this.logic.version
					};
				}
			} catch (error) {
				Logger.error('Failed to save the undo: ', error);
			}
		} catch (e) {}
	}

	// The currently active change-set is the one with one index lower than the given 'newActiveIndex'
	async redo() {
		if (!this.branchHead?.branchId) {
			Logger.warn('No branch id found, cannot redo');
			return;
		}

		try {
			const reversalConfig: IProjectVersionTransitionConfig =
				this.logic.redo();

			this.renderAndCloseChangeSet(reversalConfig.transitionalChangeSet, {
				skipClosing: true
			});

			const body: ILiveMessageDTO = {
				action: DTOAction.MoveBranchHead,
				actionId: ProjectState.UUID.uuid(),
				userAuthor: ProjectState.sessionAuthor,
				agentAuthor: null,
				emittedAt: reversalConfig.transitionTime,
				channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
				sessionId: this.sessionId as string,
				authorization: null,
				refreshToken: null,
				type: LiveMessageEventType.Post,
				workspaceId: this.activeWorkspace?.id,
				event: null,
				message: null,
				payload: {
					id: ProjectState.UUID.uuid(),
					branch: this.branchHead.branchId,
					userAuthor: ProjectState.sessionAuthor,
					versionId: this.logic.version,
					timestamp: reversalConfig.transitionTime,
					actionName: 'redo',
					selfId: this.projectId,
					selfType: EntityType.Project,
					selfVersion: this.logic?.version
				}
			};

			try {
				if (EditorService.SAVING_ENABLED && !this.READ_ONLY) {
					await axios.post(
						`${envConfig.API_BASE_URL}/editor-service/v1/move-branch-head`,
						body,
						{
							headers: {
								Authorization: `Bearer ${await this.getAccessToken()}`
							}
						}
					);

					this.branchHead = {
						...this.branchHead,
						headVersion: this.logic.version
					};
				}
			} catch (error) {
				Logger.error('Failed to save the redo: ', error);
			}
		} catch (e) {}
	}

	async moveBranchHeadToVersion(
		versionId: EntityVersion,
		actionName: string,
		overrideReadOnly = false
	): Promise<IActiveBranchHeadResult> {
		if (!this.branchHead?.branchId) {
			Logger.warn('No branch id found, cannot move branch head');
			return;
		}

		try {
			const time = new Date().toISOString();
			const body: ILiveMessageDTO = {
				action: DTOAction.MoveBranchHead,
				actionId: ProjectState.UUID.uuid(),
				userAuthor: ProjectState.sessionAuthor,
				agentAuthor: null,
				emittedAt: time,
				channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
				sessionId: this.sessionId as string,
				authorization: null,
				refreshToken: null,
				type: LiveMessageEventType.Post,
				workspaceId: this.activeWorkspace?.id,
				event: null,
				message: null,
				payload: {
					id: ProjectState.UUID.uuid(),
					branch: this.branchHead.branchId,
					userAuthor: ProjectState.sessionAuthor,
					versionId: this.logic.version,
					timestamp: time,
					actionName: actionName,
					selfId: this.projectId,
					selfType: EntityType.Project,
					selfVersion: this.logic?.version
				}
			};

			try {
				if (
					EditorService.SAVING_ENABLED &&
					(!this.READ_ONLY || overrideReadOnly)
				) {
					await axios.post(
						`${envConfig.API_BASE_URL}/editor-service/v1/move-branch-head`,
						body,
						{
							headers: {
								Authorization: `Bearer ${await this.getAccessToken()}`
							}
						}
					);

					const newBranchHead = {
						...this.branchHead,
						headVersion: versionId
					};

					return newBranchHead;
				}
			} catch (error) {
				Logger.error('Failed to save the redo: ', error);
			}
		} catch (e) {}

		return null;
	}

	async registerNonDefaultLocalImplementationsOfModules() {
		this.extensionsRegistry.register(
			new SearchNodeImplementationModule(this.extensionsRegistry)
		);
		this.extensionsRegistry.register(
			new BuiltInFunctionImplementationDeletePersistedEntityModule(
				this.extensionsRegistry
			)
		);
		this.extensionsRegistry.register(
			new BuiltInFunctionImplementationCreatePersistedEntityModule(
				this.extensionsRegistry
			)
		);
		this.extensionsRegistry.register(
			new BuiltInFunctionImplementationUpdatePersistedEntityModule(
				this.extensionsRegistry
			)
		);
		this.extensionsRegistry.register(
			new SQLMigrationsGenerationModule(this.extensionsRegistry)
		);
		// this.extensionsRegistry.register(
		// 	new OperationsImplementationsGoogleSheetsAddBandingModule(
		// 		this.extensionsRegistry
		// 	)
		// );
		// this.extensionsRegistry.register(
		// 	new OperationsImplementationsGoogleSheetsUpdateBandingModule(
		// 		this.extensionsRegistry
		// 	)
		// );
		// this.extensionsRegistry.register(
		// 	new OperationsImplementationsGoogleSheetsDeleteBandingModule(
		// 		this.extensionsRegistry
		// 	)
		// );
		// this.extensionsRegistry.register(
		// 	new OperationsImplementationsGoogleSheetsCreatePivotTableModule(
		// 		this.extensionsRegistry
		// 	)
		// );
		// this.extensionsRegistry.register(
		// 	new OperationsImplementationsGoogleSheetsDeletePivotTableModule(
		// 		this.extensionsRegistry
		// 	)
		// );
	}

	handleProjectPublicationCompleted(_message: ILiveMessageDTO): void {
		if (this.publication && this.logic) {
			const existingIndex = this.livePublishedVersions.findIndex(
				(pub) =>
					pub.projectVersion ===
					this.lastPublishedProjectState?.version
			);

			if (existingIndex !== -1) {
				this.livePublishedVersions[existingIndex] = this.publication;
			} else {
				this.livePublishedVersions = [this.publication];
			}

			cloneProjectAsync(this.logic, {
				keepIds: true,
				shallowErrors: true
			})
				.then(({ project }) => {
					this.lastPublishedProjectState = project;
				})
				.catch((err) => {
					Logger.error(
						'Failed to clone logic for lastPublishedProjectState',
						err
					);
				});
		}

		// Add notification
		notifications.push(
			this.PROJECT_NOTIFICATIONS_CHANNEL,
			{
				types: [],
				severity: NotificationSeverity.Success,
				title: 'Publication completed',
				message: 'Your project has been published',
				action: {
					type: NotificationActionType.InternalNavigation,
					// Canvas object id to scroll to
					value: `${this.editorBasePath}/publication/publication-sequence/${this.publication?.id}`
				}
			},
			'publication-completed--' + this.publication?.id
		);

		this.loadLiveResources();
	}

	handleProjectPublicationError(message: ILiveMessageDTO): void {
		// Add notification
		notifications.push(
			this.PROJECT_NOTIFICATIONS_CHANNEL,
			{
				types: [],
				severity: NotificationSeverity.Error,
				title: 'Publication failed',
				message: !!message.event
					? getEventNameFromDefinition(
							// @ts-ignore
							message.event as ProjectPublicationEventName
						)
					: 'The publication of the project failed. Try again later.',
				action: {
					type: NotificationActionType.InternalNavigation,
					// Canvas object id to scroll to
					value: `${this.editorBasePath}/publication/publication-sequence/${this.publication?.id}`
				}
			},
			'publication-failed--' + this.publication?.id
		);

		this.loadLiveResources();
	}

	subscribeNotificationsToEvents() {
		this.on(
			'project-publication-completed',
			this.handleProjectPublicationCompleted
		);

		this.on(
			'project-publication-error',
			this.handleProjectPublicationError
		);
	}

	async validateProjectState(options: YieldOptions = {}) {
		if (!this.logic) {
			return;
		}
		const tracker = YieldTracker.from(options);

		await this.logic.validateAsync({ tracker });

		const errors = await this.logic.getErrorsAsync({ tracker });

		for (const error of errors) {
			const canvasEntity = getParentCanvasEntity(error.entity);

			if (!canvasEntity) {
				await tracker.tick();
				continue;
			}

			const objectId =
				getCanvasEntityDraggableContainerDOMId(canvasEntity);

			notifications.push(
				this.PROJECT_NOTIFICATIONS_CHANNEL,
				{
					types: [],
					severity: error.severity as any as NotificationSeverity,
					title: translateLogicErrorCodeShort(error),
					message: translateLogicErrorCodeWithEntityName(error),
					data: error,
					action:
						error.entity.type === EntityType.DataType
							? {
									type: NotificationActionType.InternalNavigation,
									value: (() => {
										let lastParent: DataTypeParentEntityState =
											(error.entity as DataTypeState)
												.parent as DataTypeParentEntityState;

										// @ts-ignore
										while (
											lastParent?.type ===
											EntityType.DataType
										) {
											lastParent =
												lastParent.parent as DataTypeParentEntityState;
										}

										return `${this.editorBasePath}/entity/${lastParent.type}/${lastParent.id}`;
									})()
								}
							: {
									type: NotificationActionType.CanvasNavigation,
									// Canvas object id to scroll to
									value: objectId
								}
				},
				error.id
			);

			await tracker.tick();
		}
	}

	onOfflineWindowEventHandler() {
		// Handle offline event
		this.emit('connection-status-changed', { online: false });
		this.emit('connection-status-lost', null);

		popupNotification({
			text: 'Internet connection lost'
		});
	}

	onOnlineWindowEventHandler() {
		// Handle online event
		this.emit('connection-status-changed', { online: true });
		this.emit('connection-status-restored', null);

		popupNotification({
			text: 'Internet connection restored'
		});
	}

	onChangeSetEventHandler(event: ChangeSetEvent) {
		if (this.renderedChangeSetEvents.get(event.parent?.id)?.has(event.id)) {
			Logger.log('Change set event (already shown): ', event);
			return;
		}

		Logger.log('Change set event: ', event);
		let assembledMessage = event.rootAction
			? 'Change could not be applied. '
			: '';

		const ownerName = resolveEntityName(event.owner, this.logic);

		assembledMessage += `For ${ownerName}, `;

		if (!event.rootAction) {
			assembledMessage += ' some changes were made or reverted because';
		}

		let errorReasonAsSentence = lowercaseFirstLetter(
			toSentenceCase(event.errorReason || '')
		);

		if (event.errorReason) {
			assembledMessage += ` ${errorReasonAsSentence}`;
		}

		this.renderedChangeSetEvents.set(
			event.parent?.id,
			this.renderedChangeSetEvents.get(event.parent?.id) || new Set()
		);
		this.renderedChangeSetEvents.get(event.parent?.id).add(event.id);

		popupNotification({
			text: assembledMessage,
			color: event.rootAction ? 'error' : 'warning'
		});
	}

	// Create a method that will be called once during `setup` and
	// will handle internet connection status
	// It will emit an event when the connection status is lost
	// And another when the connection is restored
	setupHandleConnectionStatus() {
		window.addEventListener('offline', this.onOfflineWindowEventHandler);
		window.addEventListener('online', this.onOnlineWindowEventHandler);
	}

	teardownHandleConnectionStatus() {
		window.removeEventListener('offline', this.onOfflineWindowEventHandler);
		window.removeEventListener('online', this.onOnlineWindowEventHandler);
	}

	async loadPublicationsThenLastPublishedProjectState() {
		await this.loadLivePublications();

		if (!!this.livePublishedVersions.length) {
			const lastLivePublication = this.livePublication;

			if (!!lastLivePublication?.projectVersion) {
				Logger.log(
					'Loading last published project version: ',
					lastLivePublication.projectVersion,
					'\nFrom: ',
					lastLivePublication.createdAt
				);
				Logger.log('Last publication: ', lastLivePublication?.id);
				await this.getLastPublishedVersionLogic({
					version: lastLivePublication.projectVersion,
					branchId: lastLivePublication.projectBranchId
				});
			}
		}
	}

	async initialLoads(options: { mockLogic?: ProjectState } = {}) {
		const promises: Promise<any>[] = [
			this.loadPublicationsThenLastPublishedProjectState(),
			this.loadPublications(),
			this.getProjectRoles()
		];

		this.branchHeadPromise = this.loadInitialBranchHead();

		promises.push(this.branchHeadPromise);

		if (!this.isNaiveSubpage) {
			promises.push(
				this.getLogicThenProcessExternalChangeSetsQueue(options)
			);
		} else {
			this.getLogicThenProcessExternalChangeSetsQueue(options);
		}

		await Promise.all(promises);
	}

	async subscribeToProjectNotificationsChannel() {
		const [accessToken, refreshToken] = await Promise.all([
			this.getAccessToken(),
			this.getRefreshToken()
		]);

		this.socket.send({
			action: DTOAction.SubscribeChannelsV1,
			actionId: ProjectState.UUID.uuid(),
			userAuthor: ProjectState.sessionAuthor,
			agentAuthor: null,
			emittedAt: new Date().toISOString(),
			channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
			sessionId: this.sessionId as string,
			authorization: 'Bearer ' + accessToken,
			refreshToken: refreshToken,
			type: LiveMessageEventType.Post,
			workspaceId: this.activeWorkspace?.id,
			event: null,
			message: null,
			payload: {
				channels: [this.PROJECT_NOTIFICATIONS_CHANNEL]
			}
		});
	}

	async splitCSInChunksAndSend(
		fullMessage: PersistChangeSetEntityActionRequestPayload
	) {
		const SAFE_CHUNK_SIZE = EditorService.SAFE_CHUNK_WS_CONTENT_SIZE; // e.g., 64KB

		// 1. Flatten all operations into a single linear queue for easier processing
		// Structure: { type: 'added' | 'updated' | 'removed', id: string, data: any }
		const allOperations: Array<{
			type: 'added' | 'updated' | 'removed';
			id: string;
			data: any;
		}> = [];

		(['added', 'updated', 'removed'] as const).forEach((type) => {
			const collection = fullMessage.payload[type];
			if (collection) {
				Object.entries(collection).forEach(([id, data]) => {
					allOperations.push({ type, id, data });
				});
			}
		});

		let processedOps = 0;

		// We don't know totalChunks yet because it depends on variable sizes.
		// But the backend usually needs to know "Is this the last one?".
		// Alternatively, if your backend REQUIRES `totalChunks` upfront,
		// you must do a dry-run or estimate conservatively.
		// Assuming we can't change the backend contract, we will ESTIMATE totalChunks
		// but update the 'totalChunks' in the final chunk if possible,
		// OR simply accept that the estimate is just an estimate.
		// BETTER APPROACH: Calculate chunks first, then send.

		const chunks: PersistChangeSetEntityActionPayload[] = [];

		let currentChunkPayload: PersistChangeSetEntityActionPayload = {
			...fullMessage.payload,
			added: {},
			updated: {},
			removed: {}
		};

		// Base overhead of the message wrapper (approximate)
		const baseOverhead = JSON.stringify({
			...fullMessage,
			payload: {}
		}).length;
		let currentChunkSize = baseOverhead;

		// 2. Greedy Chunk Builder
		for (const op of allOperations) {
			// Calculate size of this specific entity
			// +2 for quotes/colon approx
			const entitySize =
				JSON.stringify(op.data).length + op.id.length + 10;

			// If this single entity is larger than the whole chunk limit, we have a problem.
			// We must send it anyway (it will likely fail) or warn.
			if (entitySize > SAFE_CHUNK_SIZE) {
				Logger.error(
					`Entity ${op.id} is larger than the max chunk size!`
				);
			}

			// Check if adding this entity would overflow
			if (
				currentChunkSize + entitySize > SAFE_CHUNK_SIZE &&
				processedOps > 0
			) {
				// Push current chunk to list
				chunks.push(currentChunkPayload);

				// Reset for next chunk
				currentChunkPayload = {
					...fullMessage.payload,
					added: {},
					updated: {},
					removed: {}
				};
				currentChunkSize = baseOverhead;
			}

			// Add op to current chunk
			currentChunkPayload[op.type][op.id] = op.data;
			currentChunkSize += entitySize;
			processedOps++;
		}

		// Push the last partial chunk
		if (processedOps > 0) {
			chunks.push(currentChunkPayload);
		}

		const totalChunks = chunks.length;
		Logger.log(
			`Split change-set into ${totalChunks} chunks based on actual size.`
		);

		// 3. Send Chunks
		for (let i = 0; i < totalChunks; i++) {
			const chunkPayload = chunks[i];

			// Attach metadata expected by your backend
			// We use a type assertion or merge logic as per your DTO
			const chunkMessage = {
				...fullMessage,
				payload: {
					...chunkPayload,
					chunkIndex: i,
					totalChunks: totalChunks
				}
			};

			console.log(`Sending chunk ${i + 1} of ${totalChunks}.`);

			// Note: socket.send is usually synchronous/buffering.
			// If you need flow control (to prevent flooding), you'd need to wait here.
			// Since you requested "fire and forget" waiting for 1 ACK:
			this.socket.send(chunkMessage);

			// Small yield to prevent blocking the event loop if there are 100s of chunks
			if (i % 5 === 0) await new Promise((r) => setTimeout(r, 0));
		}
	}

	async afterLogicLoadedSetup() {
		await this.logicLoadingPromise;

		this.hasLoadedLogic = true;
		Logger.log('------------ Logic ------------\n', this.logic);

		if (!this.logic?.id && !this.isNaiveSubpage) {
			throw new Error('Failed to load project logic');
		}

		if (this.destroyed) {
			return;
		}

		this.extensionsRegistry.onResolveProjectLogicContext(() => {
			Logger.log('Resolving project logic context: ', this.logic);
			return toProjectLogicContext(
				this.extensionsRegistry,
				this.logic as ProjectState
			);
		});

		Logger.log('Setting up extensions registry context for logic');
		await this.extensionsRegistry.contextAvailable(
			ExtensionContextType.Logic
		);

		this.setupUndoRedo();

		this.logic.onAddChangeSet((changeSet, _undoableStackValueIndex) => {
			changeSet.on('change-set-event', this.onChangeSetEventHandler);
			Logger.log('New change set added: ', changeSet);
			this.canvas?.persistScroll();

			increaseIndexValueInInput(this.projectId);

			this.canvas?.restoreScroll();
		});

		this.logic.onDiscardChangeSet((_changeSet) => {
			Logger.log(
				'New undoable stack value index: ',
				this.logic.undoableStackValueIndex
			);
			setUndoableIndexValue(
				this.projectId,
				this.logic.undoableStackValueIndex
			);
		});

		let lastBranchHead: IActiveBranchHeadResult | null = null;

		this.logic.onPersistChangeSetInParallel(async (changeSet) => {
			try {
				lastBranchHead = {
					...(this.branchHead as IActiveBranchHeadResult)
				};

				this.branchHead = {
					...(this.branchHead as IActiveBranchHeadResult),
					headVersion: this.logic?.version as string
				};

				if (this.projectId === mockClientProject.id) {
					this.emit('change-set-submission-succeeded', changeSet);
					return { success: true };
				}

				if (!this.branchHead?.branchId) {
					throw new Error(
						'No active branch id available for WS submission.'
					);
				}

				// Prepare WS payload
				const actionId = changeSet.id;
				const changeSetTransfer = changeSet.toJSON();

				const [accessToken, refreshToken] = await Promise.all([
					this.getAccessToken(),
					this.getRefreshToken()
				]);

				const wsMessage: PersistChangeSetEntityActionRequestPayload = {
					action: DTOAction.PersistProjectChangeSet,
					actionId,
					userAuthor: changeSet.author,
					agentAuthor: null,
					emittedAt: changeSet.timestamp,
					channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
					sessionId: this.sessionId as string,
					authorization: 'Bearer ' + accessToken,
					refreshToken: refreshToken,
					type: LiveMessageEventType.Post,
					event: null,
					workspaceId: this.activeWorkspace?.id,
					message: null,
					payload: {
						...changeSetTransfer,
						isNewBranchHead: true,
						branch: this.branchHead?.branchId,
						actionName: changeSet.actionName
					}
				};

				// Fire WS message and await only the ACK (or an error) for this actionId
				const ACK_TIMEOUT_MS = 90000;

				const stringifiedFullMessage = JSON.stringify(wsMessage);
				const messageSizeInBytes = new TextEncoder().encode(
					stringifiedFullMessage
				).length;

				Logger.log(
					'Full WS persist change-set message size in bytes: ',
					messageSizeInBytes
				);

				await new Promise<void>((resolve, reject) => {
					let settled = false;

					const onMessage = (msg: ILiveMessageDTO) => {
						if (
							msg?.actionId !== actionId ||
							msg?.action !== DTOAction.PersistProjectChangeSet
						) {
							Logger.log(
								'Ignoring WS message for different actionId or action: ',
								msg
							);
							return;
						}

						Logger.log(
							'WS persist change-set response message: ',
							msg
						);

						if (msg.type === LiveMessageEventType.Acknowledgement) {
							settled = true;
							this.socket.off('message', onMessage);
							clearTimeout(timer);
							resolve();
						} else if (msg.type === LiveMessageEventType.Error) {
							settled = true;
							this.socket.off('message', onMessage);
							clearTimeout(timer);
							reject(
								new Error(
									'WS persist change-set error: ' +
										(msg.event || 'unknown-error')
								)
							);
						}
					};

					const timer = setTimeout(() => {
						if (settled) return;
						this.socket.off('message', onMessage);
						reject(
							new Error(
								'Timed out waiting for acknowledgement from server.'
							)
						);
					}, ACK_TIMEOUT_MS);

					this.socket.on('message', onMessage);

					Logger.log('this.socket: ', this.socket);

					if (
						messageSizeInBytes >
						EditorService.SAFE_CHUNK_WS_CONTENT_SIZE
					) {
						Logger.log(
							`WS message size (${messageSizeInBytes}) exceeds safe limit. Splitting...`
						);

						// Catch errors here because we are inside a Promise executor
						// calling an async function.
						this.splitCSInChunksAndSend(wsMessage).catch((err) =>
							reject(err)
						);
					} else {
						// Safe size
						Logger.log('Sending WS message: ', wsMessage);
						this.socket.send(wsMessage);
					}
				});

				// ACK received → mark success locally
				this.emit('change-set-submission-succeeded', wsMessage);

				return { success: true };
			} catch (error) {
				Logger.error(
					'Error persisting change set in parallel: ',
					error
				);
				this.branchHead = lastBranchHead;

				this.emit('change-set-submission-failed', changeSet);

				// Resolve a specific human readable message the best we can
				let errorMessage = '';

				if (error instanceof Error) {
					errorMessage = error.message;
				} else if (typeof error === 'string') {
					errorMessage = error;
				}

				popupNotification({
					text:
						'Failed while saving the recent changes. Please try again.' +
						(!!errorMessage ? ' (' + errorMessage + ')' : ''),
					color: 'error',
					delay: 5000
				});
				return { success: false };
			}
		});

		// Initialize the local databases
		this.localDatabaseStore = new LocalRelationalDatabasesStore(this);

		try {
			await this.localDatabaseStore.init();
		} catch (error) {
			console.error('Failed to initialize local databases: ', error);
		}

		// TODO: when a value store is initialized, it should hydrate its state,
		// That is: make sure the locally stored values are still compatible with the data-type of their owning entity
		this.localTestValues = new LocalBrowserValueStore(
			'project--' + this.projectId + '--test--value-store',
			this.logic
		);

		this.localTestValues.onWrite(async (owner, value) => {
			const tracker = YieldTracker.from({ yieldEvery: 100 });

			Logger.log('Local test value written: ', owner, value);
			await this.recalculateValidate({ tracker });

			await this.test?.validateLogicAsync({ tracker });
			this.test?.render();

			this.emitAsync('value-written', {
				owner,
				value
			});
		});
		this.localTestValues.onRemove(async (owner) => {
			const tracker = YieldTracker.from({ yieldEvery: 100 });

			Logger.log('Local test value removed: ', owner);
			await this.recalculateValidate({ tracker });

			await this.test?.validateLogicAsync({ tracker });
			this.test?.render();

			this.emitAsync('value-removed', {
				owner
			});
		});

		this.resolvedValues = new LocalBrowserValueStore(
			'project--' + this.projectId + '--default-cache--value-store',
			this.logic
		);

		this.resolvedValues.onWrite((owner, value) => {
			this.emitAsync('value-written', {
				owner,
				value
			});
		});
		this.resolvedValues.onRemove((owner) => {
			this.emitAsync('value-removed', {
				owner
			});
		});

		this.persistedExecutionResults = new LocalBrowserValueStore(
			'project--' +
				this.projectId +
				'--persisted-execution-results--value-store',
			this.logic
		);

		this.persistedExecutionResults.onWrite((owner, value) => {
			this.emitAsync('value-written', {
				owner,
				value
			});
		});
		this.persistedExecutionResults.onRemove((owner) => {
			this.emitAsync('value-removed', {
				owner
			});
		});

		this.emit('value-stores-initialized', {});

		await this.validateProjectState();

		const initialLoadChangeSet = this.logic?.addChangeSet(
			new ChangeSet(
				this.logic,
				ProjectState.sessionAuthor,
				new Date().toISOString(),
				this.logic,
				false,
				StateMutationAction.InitialLoadAutomaticCanvasRefresh
			)
		);

		initialLoadChangeSet.type = ChangeSetChangeCaptureType.Automatic;

		this.canvasLayout = await toCanvasFlatArray(
			this.logic,
			initialLoadChangeSet
		);

		if (!this.READ_ONLY) {
			this.enableCanvasGlobally();
		}

		if (!this.isNaiveSubpage) {
			await this.initialRender();
		}

		this.canvas?.onShouldResolveOwnInitialScroll(() => {
			if (this.canvasLayout.length) {
				this.canvas?.scrollToObjectByIdInstantly(
					getCanvasEntityDOMId(this.canvasLayout[0])
				);
			} else if (this.ready) {
				this.canvas?.center();
			} else {
				this.shouldResolveOwnInitialScroll = true;
			}
		});

		if (
			initialLoadChangeSet.list.length === 1 &&
			initialLoadChangeSet.has(this.projectId)
		) {
			// Remove the project as it is a bad side-effect of the initialization process
			// when no other entities need to be repositioned in the canvas
			initialLoadChangeSet.remove(this.projectId);
			const oldestVersionInstance = Array.from(
				this.logic.knownVersions.values()
			).sort((a, b) => {
				return dayjs(a.createdAt).isBefore(dayjs(b.createdAt)) ? -1 : 1;
			})[0];
			this.logic.restoreVersion(oldestVersionInstance.version);
			Array.from(this.logic.knownVersions.keys()).forEach((version) => {
				if (version !== oldestVersionInstance.version) {
					this.logic.knownVersions.delete(version);
				}
			});
		}

		initialLoadChangeSet.close();

		console.log('Ready!');

		this.ready = true;
	}

	async setup(options: { mockLogic?: ProjectState } = {}) {
		try {
			// const test = await axios.get('https://api.ipify.org?format=json');
			// Logger.log('IP Address response: ', test);

			Logger.enable(true);
			Logger.setGlobalLevel('silent');
			Logger.includeModules(['auth:*']);
			Logger.setModuleRule('auth:*', {
				level: 'debug'
				// sample: { warn: 0.001 },
			});
			const authLogger = Logger.module('auth:*');

			this.events.yieldEvery = 75;

			this.setupHandleConnectionStatus();

			this.socket.off('message', this.handleIncommingWebsocketMessage);
			this.socket.off('reconnecting', this.handleReconnectingWebsocket);
			this.socket.off('closed', this.handleClosedWebsocket);

			this.socket.on('message', this.handleIncommingWebsocketMessage);
			this.socket.on('reconnecting', this.handleReconnectingWebsocket);
			this.socket.on('closed', this.handleClosedWebsocket);
			// this.socket.on('open', this.handleWebsocketOpen);

			this.setupShortcuts();

			const currentUserId = (await getCurrentUserOrLogoutRedirect())?.id;
			this.userSettings = new UserSettings(currentUserId);

			authLogger.log('Access token: ', await this.getAccessToken());
			authLogger.log('Refresh token: ', await this.getRefreshToken());
			authLogger.log('Current user: ', currentUserId);
			ProjectState.sessionAuthor = currentUserId;
			this.loadLiveResources();

			Logger.log(
				'Subscribing to project notifications channel: ',
				this.PROJECT_NOTIFICATIONS_CHANNEL
			);
			// Subscribe to websocket channels
			await this.subscribeToProjectNotificationsChannel();

			this.initCanvas();
			this.subscribeNotificationsToEvents();

			await this.initialLoads(options);

			if (!this.canEdit || this.isViewingNonHead) {
				this.READ_ONLY = true;
				this.disableCanvasGlobally();
			} else {
				this.READ_ONLY = false;
			}

			if (!this.READ_ONLY) {
				UploadManagerService.resumePendingUploadsForBucket(
					undefined,
					this.getAccessToken.bind(this),
					this.env
				).catch((err: any) => {
					Logger.error('Failed to resume pending uploads', err);
				});

				MoveManagerService.resumePendingMovesForBucket(
					undefined,
					this.getAccessToken.bind(this),
					this.env
				).catch((err: any) => {
					Logger.error('Failed to resume pending moves', err);
				});
			}

			if (this.isNaiveSubpage) {
				this.ready = true;
				this.afterLogicLoadedSetup();
				return;
			}

			await this.afterLogicLoadedSetup();
		} catch (error) {
			console.warn('Error setting up canvas service: ', error);
			if (!this.destroyed) {
				this.onProjectSetupErrorCallback?.(error);
			}
		}
	}

	initCanvas() {
		Logger.log('Initializing canvas');
		if (!!this.canvas) {
			return;
		}

		const canvasContainerElement = window.document.querySelector(
			'.editor-canvas-container'
		) as HTMLElement;

		const onConnectionClick = (connection: Connection) => {
			if (this.canvas?.disabled) {
				return;
			}
			this.showConnectionDeleteButtonElement(connection);
		};

		const connectionDefaults: IConnectionOptions = {
			size: 3,
			color: 'var(--color-light-grey)',
			complementaryColor: 'var(--color-lighter-grey)',
			hoverColor: 'var(--color-main-primary)',
			selectedColor: 'var(--color-main-primary)',
			onClick: onConnectionClick,
			onUnselect: () => {
				this.hideConnectionDeleteButtonElement();
			},
			onDisable: (connection: Connection) => {
				connection.element.classList.add('disabled');
			},
			onEnable: (connection: Connection) => {
				connection.element.classList.remove('disabled');
			}
		};

		const invertScrollDirection =
			localStorage.getItem(
				`canvas-invert-scroll-${this.userSettings?.userId}`
			) === 'true';

		this.canvas = new CanvasLib({
			containerElement: canvasContainerElement,
			id: 'main-editor-canvas--' + this.projectId,
			connectionDefaults,
			elementClasses: ['canvas'],
			enableUndoRedo: false,
			invertScrollDirection
		});

		this.disableCanvasGlobally();

		// @ts-ignore
		window.canvas = this.canvas;

		this.canvas?.onPan(async () => {
			await this.hideEntityCreationMenu();
		});

		this.canvas?.onScaleChange((scale) => {
			this.emit('canvas-scale-changed', { scale });
		});

		this.canvas?.onBeforeScrollToThis(async (objectId) => {
			const entityId = getEntityIdFromCanvasId(objectId);
			const entity = this.logic.get(entityId);

			const preMiddleware = [];

			if (!entity) {
				return;
			}

			if (this.isCreateEntityMenuOpen) {
				preMiddleware.push(this.hideEntityCreationMenu());
			}

			if (this.deleteConnectionElement) {
				preMiddleware.push(this.hideConnectionDeleteButtonElement());
			}

			// Make sure the entry point owning this entity is not collapsed
			const parentCanvasEntity = getParentCanvasEntity(entity);

			if (
				[...PASS_THROUGH_CALLABLE_TYPES, ...TERMINATION_TYPES].includes(
					parentCanvasEntity.type
				)
			) {
				const entryPoint = getParentEntryPoint(parentCanvasEntity);

				if (entryPoint && entryPoint.collapsed) {
					let actionName = entryPoint.collapsed
						? StateMutationAction.ShowTriggerBody
						: StateMutationAction.HideTriggerBody;

					if (entryPoint.parent?.type === EntityType.Loop) {
						actionName = entryPoint.collapsed
							? StateMutationAction.ShowLoopBody
							: StateMutationAction.HideLoopBody;
					} else if (entity.type === EntityType.FunctionDeclaration) {
						actionName = entryPoint.collapsed
							? StateMutationAction.ShowFuncDeclBody
							: StateMutationAction.HideFuncDeclBody;
					} else if (entity.type === EntityType.GlobalEvent) {
						actionName = entryPoint.collapsed
							? StateMutationAction.ShowGlobalEventBody
							: StateMutationAction.HideGlobalEventBody;
					}

					const changeSet = this.logic.addChangeSet(
						new ChangeSet(
							this.logic,
							ProjectState.sessionAuthor,
							new Date().toISOString(),
							entryPoint,
							false,
							actionName
						)
					);
					changeSet.type = ChangeSetChangeCaptureType.Automatic;

					entryPoint.metaSync({ collapsed: false }, changeSet);
					preMiddleware.push(
						this.renderFromExisting(entryPoint, changeSet)
					);
					this.emit(entryPoint.id, {});

					this.renderAndCloseChangeSet(changeSet);
				}
			}

			await Promise.all(preMiddleware);
		});

		// On copy show a top down notification confirming the action
		this.canvas?.onCopy((event, canvasObjects) => {
			const recordOfEntitiesToCopy: Record<
				EntityId,
				UserManagedElementShallowTransfer
			> = {};

			canvasObjects.forEach((canvasObject) => {
				const canvasEntity = this.logic.get(
					getEntityIdFromCanvasId(canvasObject.id)
				) as CanvasEntityState;

				if (!!canvasEntity) {
					const recordOfEnts = flattenNodeAsRecord(
						canvasEntity,
						// @ts-ignore
						this.logic.instances,
						new Set<EntityId>(),
						{
							allBuiltInEntityIds:
								this.logic.diggestedBuiltInBaseEntitiesIds
						}
					);

					Object.values(recordOfEnts).forEach((entity) => {
						if (!!entity) {
							if (DRAGGABLE_ELEMENT_TYPES.includes(entity.type)) {
								const canvasParent = getParentCanvasEntity(
									entity as UserManagedEntityState
								);

								if (
									!canvasObjects.find((canvasObj) => {
										const canvasObjEntityId =
											getEntityIdFromCanvasId(
												canvasObj.id
											);
										return (
											canvasObjEntityId ===
											canvasParent.id
										);
									})
								) {
									// If the parent canvas entity is not part of the copied objects,
									// we skip copying this entity as it would be orphaned
									return;
								}
							}

							recordOfEntitiesToCopy[entity.id] = (
								entity as UserManagedEntityState
							).toShallowJSON();
						}
					});
				}
			});

			// JSON / object format
			event.clipboardData.setData(
				'application/json',
				JSON.stringify({
					elyx_entities: Object.values(recordOfEntitiesToCopy),
					project_id: this.projectId
				})
			);

			// Prevent the default copy action
			event.preventDefault();

			if (canvasObjects.length === 1) {
				popupNotification({ text: 'Node copied', delay: 1200 });
				return;
			} else if (canvasObjects.length > 1) {
				popupNotification({
					text: canvasObjects.length + ` nodes copied`,
					delay: 1200
				});
			}
		});

		this.canvas?.onPaste(async (clipboardData: any) => {
			const pastedData = clipboardData.getData('application/json');

			// Try to parse data as JSON to convert to an object
			try {
				const parsedData = JSON.parse(pastedData) as ICanvasCopyPayload;

				const tracker = YieldTracker.from({ yieldEvery: 100 });

				await this.canvas?.unselectAllAsync({ tracker });

				// We find the real business entities that the pasted entities are referencing
				// const entities = canvasObjects.map((canvasObject) => {
				// 	return this.logic.get(
				// 		getEntityIdFromCanvasId(canvasObject.id)
				// 	) as CanvasEntityState;
				// });

				/*
					Replace the code below with a new change set:
						- Instanciate a traverser, set all the entities and order them
						- Traverse the entities and clone each with a new x and y offset
						- Add them to the change set
						- Finally, render and close the changeset
				*/
				this.copyEntities(parsedData);
			} catch (error) {
				// If the data is not JSON, we can't do anything with it
				return;
			}
		});

		this.canvas?.onClick(async (coordinates) => {
			if (!this.ready || this.destroyed || this.canvas?.disabled) {
				if (!!this.createEntityMenu) {
					await this.hideEntityCreationMenu();
				}
				return;
			}

			if (!!this.test) {
				if (!!this.createEntityMenu) {
					await this.hideEntityCreationMenu();
				}
				return;
			}

			this.clearOnGoingConnectionState();

			await Promise.all([
				await this.hideEntityCreationMenu(),
				await this.hideConnectionDeleteButtonElement()
			]);
		});

		this.canvas?.onDoubleClick(async (coordinates, event) => {
			if (!this.ready || this.destroyed || this.canvas?.disabled) {
				if (!!this.createEntityMenu) {
					await this.hideEntityCreationMenu();
				}
				return;
			}

			if (!!this.test) {
				if (!!this.createEntityMenu) {
					await this.hideEntityCreationMenu();
				}
				return;
			}

			this.clearOnGoingConnectionState();

			await Promise.all([
				await this.toggleEntityCreationMenu(coordinates),
				await this.hideConnectionDeleteButtonElement()
			]);
		});

		this.canvas?.onRightClick(async (coordinates, event) => {
			event.preventDefault();

			if (!this.ready || this.destroyed || this.canvas?.disabled) {
				if (!!this.createEntityMenu) {
					await this.hideEntityCreationMenu();
				}
				return;
			}

			if (!!this.test) {
				if (!!this.createEntityMenu) {
					await this.hideEntityCreationMenu();
				}
				return;
			}

			this.clearOnGoingConnectionState();

			await Promise.all([
				await this.toggleEntityCreationMenu(coordinates),
				await this.hideConnectionDeleteButtonElement()
			]);
		});

		this.canvas?.onExit(async () => {
			await Promise.all([
				await this.hideEntityCreationMenu(),
				await this.hideConnectionDeleteButtonElement()
			]);
		});

		this.canvas?.onDragEnd(async (canvasObjects) => {
			const tracker = YieldTracker.from({ yieldEvery: 100 });

			let changeOwner: UserManagedEntityState = this.logic;
			let actionName = StateMutationAction.MoveNodes;

			if (canvasObjects.length === 1) {
				const canvasElement = this.getElement(
					getEntityIdFromCanvasId(canvasObjects[0].id)
				);

				if (!!canvasElement) {
					changeOwner = canvasElement.entity;
				}

				actionName = StateMutationAction.MoveNode;
			}

			const newChangeSet = this.logic.addChangeSet(
				new ChangeSet(
					this.logic,
					ProjectState.sessionAuthor,
					new Date().toISOString(),
					changeOwner,
					false,
					actionName
				)
			);

			for (const canvasObj of canvasObjects || []) {
				await tracker.tick();

				const canvasElement = this.getElement(
					getEntityIdFromCanvasId(canvasObj.id)
				);

				if (!canvasElement) {
					Logger.warn('Canvas element not found: ', canvasObj.id);
					return;
				}

				const entity = canvasElement.entity;

				// We manually add the entity because this event is triggered after the 'update' event
				// so the coordinates state will already be updated and the change won't be registered again here
				newChangeSet.add(entity, ChangeSetEntityChangeType.Updated);

				if (ENTRY_POINT_TYPES.includes(entity.type)) {
					const asEntryPoint = entity as EntryPointEntityState;

					if (asEntryPoint.collapsed) {
						const flatChildren = await flattenElementCallsAsync(
							asEntryPoint,
							{
								tracker
							}
						);

						// Filter out itself and any other elements already in the list of selected canvas objects
						const childrenToAdd = flatChildren.filter((child) => {
							return !!(canvasObjects || []).find((canvasObj) => {
								const childEntityId = getEntityIdFromCanvasId(
									canvasObj.id
								);

								if (childEntityId === entity.id) {
									return true;
								}

								if (childEntityId === child.id) {
									return true;
								}

								return false;
							});
						});

						childrenToAdd.forEach((child) => {
							newChangeSet.add(
								child,
								ChangeSetEntityChangeType.Updated
							);
						});
					}
				}
			}

			this.renderAndCloseChangeSet(newChangeSet);
		});

		this.canvas?.onDelete(async (canvasObjects) => {
			const tracker = YieldTracker.from({ yieldEvery: 100 });

			let changeOwner: UserManagedEntityState = this.logic;
			let actionName = StateMutationAction.RemoveNodes;

			if (canvasObjects.length === 1) {
				const canvasElement = this.getElement(
					getEntityIdFromCanvasId(canvasObjects[0].id)
				);

				if (!!canvasElement) {
					changeOwner = canvasElement.entity;
				}

				actionName = StateMutationAction.RemoveNode;
			}

			const newChangeSet = this.logic.addChangeSet(
				new ChangeSet(
					this.logic,
					ProjectState.sessionAuthor,
					new Date().toISOString(),
					changeOwner,
					false,
					actionName
				)
			);

			for (const canvasObj of canvasObjects || []) {
				await tracker.tick();

				const canvasElement = this.getElement(
					getEntityIdFromCanvasId(canvasObj.id)
				);

				if (!canvasElement) {
					// It has already been deleted
					return;
				}

				const entity = canvasElement.entity;

				entity.remove({ ignoreUpstream: false }, newChangeSet);

				canvasElement.remove({ quiet: true });

				delete this.elements[entity.id];

				// We manually add the entity because this event is triggered after the 'update' event
				// so the coordinates state will already be updated and the change won't be registered again here
				newChangeSet.add(entity, ChangeSetEntityChangeType.Updated);
			}

			this.renderAndCloseChangeSet(newChangeSet);
			// newChangeSet.close();
		});
	}

	async initialRender() {
		if (
			// (!this.ready ||
			this.destroyed ||
			this.hasRendered ||
			this.executingInitialRender
			// !force
		) {
			Logger.warn('EditorService: Initial render skipped');
			return;
		}

		this.executingInitialRender = true;

		// For testing purposes of the react migration only
		// We render only a simple card (global event for "project loaded")
		const reducedRender = [
			this.logic.get('a2d0ec83-72ce-4f54-b059-a39e018fa86c')
			// this.logic.get('project-loaded-event-id'),
			// this.logic.get('default-relational-database-entity-id'),
			// this.logic.get('f558fbf8-67de-4545-9804-6ae621e0b2d4'),
			// this.logic.get('company-dto-function-declaration-id'),
			// this.logic.get('company-dto-function-company-variable-id'),
			// this.logic.get('global-user-variable-id'),
			// this.logic.get('wait-for-random-amount-id'),
			// ...this.canvasLayout.filter((entity) => {
			// 	return [
			// 		EntityType.GlobalEvent,
			// 		EntityType.InstalledProject,
			// 		// EntityType.DefinitionEntity,
			// 		EntityType.FunctionDeclaration,
			// 		// EntityType.VariableDeclaration,
			// 		// EntityType.VariableInstance,
			// 		EntityType.Search,
			// 		// EntityType.Loop,
			// 		// EntityType.Condition,
			// 		// EntityType.Operation,
			// 		// EntityType.FunctionCall,
			// 		EntityType.ReturnStatement,
			// 		EntityType.BreakStatement,
			// 		EntityType.ContinueStatement,
			// 	].includes(entity.type);
			// }),
		] as CanvasEntityState[];
		// Logger.log('Reduced render: ', reducedRender);

		let hasCenteredCanvas: boolean = false;

		// await this.render(reducedRender);
		await this.render(this.canvasLayout, {
			onEachRendered: (canvasElement) => {
				if (
					!hasCenteredCanvas &&
					this.shouldResolveOwnInitialScroll &&
					!this.ready
				) {
					hasCenteredCanvas = true;
					this.canvas?.scrollToObjectById(
						getCanvasEntityDOMId(canvasElement.entity)
					);
				}
			}
		});

		// This is to make sure we don't re-center the canvas more than once
		if (
			!hasCenteredCanvas &&
			this.shouldResolveOwnInitialScroll &&
			!this.ready
		) {
			hasCenteredCanvas = true;
			this.canvas?.center();
		}

		this.hasRendered = true;
		this.executingInitialRender = false;

		this.onRenderedCallback?.();
	}

	async refresh() {
		if (!this.ready || this.destroyed) {
			return;
		}

		const canvasContainerElement = window.document.querySelector(
			'.editor-canvas-container'
		) as HTMLElement;

		if (!!this.canvas) {
			this.canvas.anchorElement = canvasContainerElement;
		}

		this.canvas?.refresh();

		await this.test?.render();
	}

	async destroy() {
		try {
			if (this.destroyed) {
				return;
			}

			this.ready = false;
			this.destroyed = true;

			this.teardownShortcuts();
			this.teardownUndoRedo();
			this.teardownHandleConnectionStatus();

			// We will keep the same server connection, so we remove the specific event listener
			this.socket.off('message', this.handleIncommingWebsocketMessage);
			this.socket.off('reconnecting', this.handleReconnectingWebsocket);
			this.socket.off('closed', this.handleClosedWebsocket);

			// These events we can remove all callbacks indiscriminately
			// Because a new project will set them up again
			this.off('canvas-connection-start');
			this.off('canvas-connection-end');
			this.off('test-exited');
			this.off('test-setup-started');
			this.off('execution-start');
			this.off('execution-end');
			this.off('escape-key-press');
			this.off('global-canvas-search');
			this.off('canvas-scale-changed');
			this.off('canvas-globally-enabled');
			this.off('canvas-globally-disabled');
			this.off('value-written');
			this.off('value-removed');
			this.off('json-editor-dialog-open');
			this.off('test-restart');
			this.off('test-paused');
			this.off('test-entity-removed');
			this.off('test-entity-added');
			this.off('local-databases-updated');
			this.off('connection-status-changed');
			this.off('connection-status-lost');
			this.off('connection-status-restored');
			this.off('change-set-closed');
			this.off('change-set-submission-succeeded');
			this.off('change-set-submission-failed');
			this.off('project-publication-completed');
			this.off('project-publication-error');

			Object.keys(CanvasPopup.globalCanvasPopups).forEach((key) => {
				const renderedPopup = CanvasPopup.globalCanvasPopups[key];

				if (renderedPopup) {
					renderedPopup.destroy();
				}

				delete CanvasPopup.globalCanvasPopups[key];
			});

			this.teardownAllEntityEvents();

			this.localTestValues?.teardown();
			this.resolvedValues?.teardown();
			this.persistedExecutionResults?.teardown();
			this.localTestValues = null;
			this.resolvedValues = null;
			this.persistedExecutionResults = null;

			await Promise.all([
				...Object.values(this.elements).map((element) =>
					element.remove()
				),
				this.createEntityMenu?.remove() || Promise.resolve()
			]);

			notifications.removeChannel(this.PROJECT_NOTIFICATIONS_CHANNEL);

			this.canvas?.destroy();
			this.canvas = null;

			this.canvasLayout = [];
			this.elements = {};
			this.defferedElementsToConnect = [];

			this.createEntityMenu = null;
			this.deleteConnectionElement = null;

			if (this.test) {
				await this.test.clear();
				this.test = null;
			}

			// Database
			await this.localDatabaseStore?.destroy();
			this.localDatabaseStore = null;

			this.logic.offAddChangeSet();
			this.logic.offDiscardChangeSet();
			this.logic.offPersistChangeSetInParallel();
			this.logic.offPersistChangeSetSequentially();

			this.logic = null;
		} catch (error) {
			Logger.warn('Error destroying canvas service: ', error);
		}
	}

	teardownEntityEvents(entities: EntityState[]) {
		entities.forEach((entity) => {
			this.off(entity.id);
			this.off('canvas-connection-start--' + entity.id);
		});
	}

	teardownAllEntityEvents() {
		const allEntities = !!this.logic
			? [
					...Object.values(this.logic.instances),
					...Object.values(this.logic.deletedInstances)
				]
			: [];

		this.teardownEntityEvents(allEntities);
	}

	getTestValue(entityId: string) {
		return this.localTestValues.values[entityId];
	}

	getTestValueOwnerIdsForEntity(entity: EntityState): string[] {
		const ids: string[] = [];

		if (!entity) return ids;

		const processEntity = (ent: any) => {
			if (!ent || !ent.id) return;
			ids.push(ent.id);

			if (
				'ownDeclaredProperties' in ent &&
				Array.isArray(ent.ownDeclaredProperties)
			) {
				ent.ownDeclaredProperties.forEach((prop: any) => {
					if (prop?.id) ids.push(prop.id);
				});
			}
			if (
				'extendedProperties' in ent &&
				Array.isArray(ent.extendedProperties)
			) {
				ent.extendedProperties.forEach((prop: any) => {
					if (prop?.id) ids.push(prop.id);
				});
			}

			if ('inputs' in ent && Array.isArray(ent.inputs)) {
				ent.inputs.forEach((input: any) => {
					if (input?.id) ids.push(input.id);
					if (input?.declaration?.id) ids.push(input.declaration.id);
				});
			}

			if ('outputs' in ent && Array.isArray(ent.outputs)) {
				ent.outputs.forEach((output: any) => {
					if (output?.id) ids.push(output.id);
					if (output?.declaration?.id)
						ids.push(output.declaration.id);
				});
			}

			if (ent.andChildrenGroup && Array.isArray(ent.andChildrenGroup)) {
				ent.andChildrenGroup.forEach(processEntity);
			}
			if (ent.orChildrenGroup && Array.isArray(ent.orChildrenGroup)) {
				ent.orChildrenGroup.forEach(processEntity);
			}
		};

		processEntity(entity);

		return Array.from(new Set(ids));
	}

	hasTestValuesForEntity(entity: EntityState): boolean {
		if (!entity || !this.localTestValues) return false;
		const ids = this.getTestValueOwnerIdsForEntity(entity);
		return ids.some((id) => !!this.localTestValues.readValue(id));
	}

	async clearEntityTestValues(entity: EntityState): Promise<void> {
		if (!entity || !this.localTestValues) return;
		const ids = this.getTestValueOwnerIdsForEntity(entity);
		ids.forEach((id) => {
			this.localTestValues.removeValue(id);
		});

		await this.emitAsync(entity.id, {});
		await this.emitAsync('local-test-values-updated', {});
		if (this.test) {
			await this.test.validateLogicAsync();
			this.test.render();
		}
	}

	async initTest(
		entryPoint: TestableEntityState,
		options: YieldOptions & { autoExecute?: boolean } = {}
	): Promise<Test> {
		this.hideEntityCreationMenu();

		this.canvas?.disableSelection();

		this.test = new Test(this, entryPoint);
		await this.test.init(options);

		return this.test;
	}

	async removeTest(
		options: YieldOptions & { skipValidate?: boolean } = {}
	): Promise<Test> {
		const tracker = YieldTracker.from(options);

		const oldTest = this.test;
		this.test = null;

		this.canvas?.enableSelection();

		if (!options.skipValidate) {
			await this.recalculateValidate({ tracker });
		}

		return oldTest;
	}

	// Some elements copy their children too, others don't
	async copyEntities(
		payload: ICanvasCopyPayload,
		options: YieldOptions = {}
	): Promise<ChangeSet> {
		const tracker = YieldTracker.from(options);

		const seenEntityMapsOldKeyNewValue = new Map<EntityId, EntityId>();
		const seenEntityMapsNewKeyOldValue = new Map<EntityId, EntityId>();

		const addedToRecord = new Set<EntityId>(
			this.logic.diggestedBuiltInBaseEntitiesIds
		);

		const allEntitiesAndNestedChildren: Record<
			EntityId,
			UserManagedEntityState
		> = {};

		const enrichmentTraverser = new Traverser(undefined, {
			allBuiltInEntityIds: this.logic.diggestedBuiltInBaseEntitiesIds
		});

		const entities =
			payload.elyx_entities as UserManagedElementShallowTransfer[];

		enrichmentTraverser.flatRecord = {};
		enrichmentTraverser.order = entities.map((e) => e.id);

		const commonTime = new Date().toISOString();

		let changeOwner: UserManagedEntityState = this.logic;
		let actionName = StateMutationAction.CloneNodes;

		if (entities.length === 1) {
			if (entities[0]?.id) {
				const ent = this.logic.get(
					entities[0].id
				) as UserManagedEntityState;

				if (ent) {
					changeOwner = ent;

					try {
						const readableEntityType =
							READABLE_ENTITY_TYPES[changeOwner.type]
								?.shortSingular || 'node';

						actionName =
							`clone-${toKebabCase(readableEntityType)}` as StateMutationAction;
					} catch (error) {
						// Do nothing
					}
				}
			}

			actionName = StateMutationAction.CloneNode;
		}

		const changeSet: ChangeSet = this.logic.addChangeSet(
			new ChangeSet(
				this.logic,
				ProjectState.sessionAuthor,
				commonTime,
				this.logic,
				false,
				actionName
			)
		);

		const isFromExternalSource = payload.elyx_project_id !== this.projectId;

		for (const entity of entities) {
			const copiedEntityData = { ...entity };

			if (
				(copiedEntityData as IDefinitionEntityShallowTransfer).parent
					?.entityType === EntityType.Project &&
				getReferenceEntityId(
					(copiedEntityData as IDefinitionEntityShallowTransfer)
						.parent
				) !== this.projectId
			) {
				(copiedEntityData as IDefinitionEntityShallowTransfer).parent =
					{
						entityType: EntityType.Project,
						entityId: this.projectId,
						id: (
							copiedEntityData as IDefinitionEntityShallowTransfer
						).parent.id,
						type: EntityType.GenericReference
					} as IProjectReference;
			}

			copiedEntityData.previousVersion = null;
			copiedEntityData.createdAt = commonTime;
			copiedEntityData.version = ProjectState.UUID.uuid();
			copiedEntityData.author = ProjectState.sessionAuthor;

			enrichmentTraverser.flatRecord[copiedEntityData.id] =
				copiedEntityData;
		}

		if (isFromExternalSource) {
			await enrichmentTraverser.orderEntitiesAsync({ yieldEvery: 100 });

			/*
        TODO:
        Improve the instanciation and hydration by replacing missing parent's with the project so entities from nested scope can be hydrated as globals
        Or if a caller or value writer was left out, it should be ignored and hydrate with what is possible.
      */
			await enrichmentTraverser.visitAsync(
				async (ent) => {
					const entityTransfer =
						ent as UserManagedElementShallowTransfer;
					if (addedToRecord.has(entityTransfer.id)) {
						return;
					}

					const entity = createStateFromTypeAndSubscribe(
						entityTransfer as any as ElementTransfer,
						this.logic as ProjectState
					) as UserManagedEntityState;

					try {
						entity.hydrateAncestors();
						entity.addSelfToProject(null);

						changeSet?.add(entity, ChangeSetEntityChangeType.Added);

						const referencesShallow =
							getReferencedIds(entityTransfer);

						// Any new entity, should check if it has any dependencies that are already loaded
						// and if so, re-hydrate them
						Object.keys(referencesShallow.downstream).forEach(
							(downstreamId) => {
								const downstreamEntity = this.logic?.get(
									downstreamId
								) as UserManagedEntityState;

								if (!!downstreamEntity) {
									downstreamEntity.hydrateAncestors();
								}
							}
						);

						const newId = ProjectState.UUID.uuid();
						seenEntityMapsOldKeyNewValue.set(entity.id, newId);
						seenEntityMapsNewKeyOldValue.set(newId, entity.id);

						allEntitiesAndNestedChildren[entity.id] = entity;
						addedToRecord.add(entity.id);
					} catch (e) {
						console.error(
							'HERE ERROR: Entity id',
							entityTransfer.id
						);
						console.error(
							'HERE ERROR: Error hydrating ancestors',
							e
						);
						console.error(
							'HERE ERROR: Entity transfer',
							entityTransfer
						);
					}
				},
				{ tracker }
			);
		} else {
			await enrichmentTraverser.visitAsync(
				async (ent) => {
					const entityTransfer =
						ent as UserManagedElementShallowTransfer;

					if (addedToRecord.has(entityTransfer.id)) {
						return;
					}

					const entity = this.logic.get(
						entityTransfer.id
					) as UserManagedEntityState;

					const newId = ProjectState.UUID.uuid();
					seenEntityMapsOldKeyNewValue.set(entity.id, newId);
					seenEntityMapsNewKeyOldValue.set(newId, entity.id);

					allEntitiesAndNestedChildren[entity.id] = entity;
					addedToRecord.add(entity.id);
				},
				{ tracker }
			);
		}

		const traverser = new Traverser(undefined, {
			allBuiltInEntityIds: this.logic.diggestedBuiltInBaseEntitiesIds
		});

		traverser.flatRecord = allEntitiesAndNestedChildren;
		traverser.order = Object.keys(allEntitiesAndNestedChildren);

		await traverser.orderEntitiesAsync({ yieldEvery: 100 });

		const reversedRecord = mapRecord(
			traverser.flatRecord,
			seenEntityMapsOldKeyNewValue
		);

		await traverser.visitAsync(
			(entity) => {
				// console.log(
				// 	'------ Next ------',
				// 	entity.type,
				// 	entity.id,
				// 	safeResolveEntityName(entity as any, this.project)
				// );
				const copiedEntityData = (
					entity as Element as EntityState
				).toShallowJSON({
					seenEntityMaps: seenEntityMapsOldKeyNewValue
				}) as any as ElementTransfer;

				copiedEntityData.previousVersion = null;
				copiedEntityData.createdAt = commonTime;
				copiedEntityData.version = ProjectState.UUID.uuid();
				copiedEntityData.author = ProjectState.sessionAuthor;

				if (
					ENTITY_WITH_NAMES_TYPES.includes(entity.type) &&
					// Properties don't need unique names with the source entity because they only need to be unique in the parent def
					entity.type !== EntityType.Property &&
					!isFromExternalSource
				) {
					(copiedEntityData as IDefinitionEntityTransfer).name =
						(entity as IDefinitionEntityTransfer).name + ' copy';
				}

				// TODO: Fix to paste where the current position of the viewport is
				if (
					DRAGGABLE_ELEMENT_TYPES.includes(entity.type) &&
					!isFromExternalSource
				) {
					(copiedEntityData as DraggableElementTransfer).x =
						(entity as DraggableElementTransfer).x + 100;
					(copiedEntityData as DraggableElementTransfer).y =
						(entity as DraggableElementTransfer).y + 200;
				}

				const updatedRefs = getReferencedIds(
					copiedEntityData,
					reversedRecord
				);

				let shouldSkip = false;

				// Check if during the initialization of another entity, the parent has been deleted
				// Sometimes this happens because some entities calculate their state and discard other entities that they reference
				Object.keys(updatedRefs.upstream).forEach((refId) => {
					const oldRefId = seenEntityMapsNewKeyOldValue.get(refId);

					if (shouldSkip) {
						return;
					}

					if (!this.logic.get(refId) && !this.logic.get(oldRefId)) {
						shouldSkip = true;
						return;
					}
				});

				if (shouldSkip) {
					return;
				}

				try {
					const entityInstance = createStateFromTypeAndSubscribe(
						copiedEntityData,
						this.logic
					) as UserManagedEntityState;

					entityInstance.hydrateAncestors();
					entityInstance.addSelfToProject(changeSet);

					changeSet?.add(
						entityInstance,
						ChangeSetEntityChangeType.Added
					);

					Object.keys(updatedRefs.downstream).forEach(
						(downstreamId) => {
							const downstreamEntity = this.logic?.get(
								downstreamId
							) as UserManagedEntityState;

							if (!!downstreamEntity) {
								downstreamEntity.hydrateAncestors();
							}
						}
					);
				} catch (error) {
					console.error('Error pasting entity to project: ', error);
				}
			},
			{ tracker }
		);

		await traverser.visitAsync(
			(entity) => {
				if (entity.id === this.logic.id) {
					return;
				}

				const instance = this.logic.get(
					seenEntityMapsOldKeyNewValue.get(entity.id) as EntityId
				) as UserManagedEntityState;

				if (instance) {
					try {
						instance.afterAllChildrenInitialized(changeSet);
					} catch (error) {
						console.error(
							'Error in afterAllChildrenInitialized: ',
							error
						);
					}
				}
			},
			{ tracker }
		);

		if (isFromExternalSource) {
			// We remove the originals, because they have been mapped to new entities in this project with new ids.
			// This is only needed because the current workaround for pasting from external projects is to instanciate them with their existing ids
			// Then use the rich-instances to clone them into new instances with new ids
			// So we end up with both the original instances and the new ones in the project logic
			// This can be removed once we have a util that can map shallow-transfers directly into new instances with new ids
			await enrichmentTraverser.reverseVisitAsync(
				(ent) => {
					const entityTransfer =
						ent as UserManagedElementShallowTransfer;

					const entity = this.logic.get(
						entityTransfer.id
					) as UserManagedEntityState;

					if (entity) {
						entity.remove({ ignoreUpstream: false }, changeSet);
					}
					delete changeSet.affected[entityTransfer.id];
					delete changeSet.updated[entityTransfer.id];
					delete changeSet.added[entityTransfer.id];
					delete changeSet.removed[entityTransfer.id];
				},
				{ tracker }
			);
		}

		this.logic.afterAllChildrenInitialized(changeSet);

		let hasNavigatedToNewEntities = false;

		this.renderAndCloseChangeSet(changeSet, {
			onEachRendered: (element) => {
				if (changeSet.hasAdded(element.entity.id)) {
					// Select in the canvas
					this.canvas?.select(element.draggableObject);

					// Navigate to the first added entity
					if (!hasNavigatedToNewEntities) {
						hasNavigatedToNewEntities = true;
						this.canvas?.scrollToObjectById(
							getCanvasEntityDOMId(element.entity)
						);
					}
				}
			}
		});

		return changeSet;
	}

	// Finds the draggable object counterpart in the canvas state and returns both
	getElement(entityId: string): CanvasEntityElement {
		const canvasElement = this.elements[entityId];

		return canvasElement;
	}

	animateDraggableMovement(
		canvasEntity: CanvasEntityConfig,
		from: ICoordinates,
		to: ICoordinates,
		animationClass:
			| 'animate-draggable-card-spawn'
			| 'animate-draggable-card-hide' = 'animate-draggable-card-spawn',
		onEnd: () => void
	) {
		// Temporarily set the parent X and Y as the initial X and Y of the draggable object
		const element = canvasEntity.draggableObject.element;
		element.style.opacity =
			animationClass === 'animate-draggable-card-spawn' ? '0' : '1';
		element.style.left = from.x + 'px';
		element.style.top = from.y + 'px';

		// Force repaint and add animation class
		requestAnimationFrame(() => {
			element.style.opacity =
				animationClass === 'animate-draggable-card-spawn' ? '1' : '0';
			element.classList.add(animationClass);

			// Using another requestAnimationFrame to ensure the class is applied
			// before setting the final position
			requestAnimationFrame(() => {
				// Set the final position
				canvasEntity.draggableObject.update({
					coordinates: {
						x: to.x,
						y: to.y
					}
				});
			});
		});

		const handleTransitionEnd = (event: TransitionEvent) => {
			element.classList.remove(animationClass);
			element.removeEventListener('transitionend', handleTransitionEnd);

			onEnd();
		};

		// Remove the class after the animation ends
		element.addEventListener('transitionend', handleTransitionEnd);
	}

	animateDraggableMovementAsync(
		canvasEntity: CanvasEntityConfig,
		from: ICoordinates,
		to: ICoordinates,
		animationClass:
			| 'animate-draggable-card-spawn'
			| 'animate-draggable-card-hide' = 'animate-draggable-card-spawn'
	): Promise<void> {
		return new Promise<void>((resolve) => {
			// Temporarily set the parent X and Y as the initial X and Y of the draggable object
			const element = canvasEntity.draggableObject.element;
			element.style.opacity =
				animationClass === 'animate-draggable-card-spawn' ? '0' : '1';
			element.style.left = from.x + 'px';
			element.style.top = from.y + 'px';

			// Force repaint and add animation class
			requestAnimationFrame(() => {
				element.style.opacity =
					animationClass === 'animate-draggable-card-spawn'
						? '1'
						: '0';
				element.classList.add(animationClass);

				// Using another requestAnimationFrame to ensure the class is applied
				// before setting the final position
				requestAnimationFrame(() => {
					// Set the final position
					canvasEntity.draggableObject.update(
						{
							coordinates: {
								x: to.x,
								y: to.y
							}
						},
						{ skipOverlapCheck: true, quiet: true }
					);
				});
			});

			const handleTransitionEnd = (event: TransitionEvent) => {
				element.classList.remove(animationClass);
				element.removeEventListener(
					'transitionend',
					handleTransitionEnd
				);
				resolve();
			};

			// Resolve the promise once the animation ends
			element.addEventListener('transitionend', handleTransitionEnd, {
				once: true
			}); // Use the { once: true } option to automatically remove the listener after it fires
		});
	}

	resolveInitialChildrenPositions(
		parent: CanvasEntityState | null,
		children: CanvasEntityState[],
		changeSet: ChangeSet | null
	): CanvasEntityState[] {
		if (children.length === 0) {
			return [];
		}

		let lastEntityWithCoordinates: CanvasEntityState = parent;
		let allEntitiesHaveCoordinates = true;

		// Remove already rendered entities from the children
		const childrenToRender = children.filter(
			(child) => !this.getElement(child.id)
		);

		// Find an existing entity with coordinates to be the anchor for the new entities
		for (let i = 0; i < childrenToRender.length; i++) {
			const childEntity = childrenToRender[i];

			if (childEntity.x && childEntity.y) {
				lastEntityWithCoordinates = childEntity;
			}

			if (!childEntity.x || !childEntity.y) {
				allEntitiesHaveCoordinates = false;
				continue;
			}
		}

		if (!allEntitiesHaveCoordinates) {
			return Area.autoGenerateLayout(
				lastEntityWithCoordinates || this.logic,
				changeSet,
				childrenToRender
			);
		}

		return childrenToRender;
	}

	async renderFromExisting(
		entity: CanvasEntityState,
		changeSet: ChangeSet,
		onEnd?: () => void
	) {
		// const canvasParent = DRAGGABLE_ELEMENT_TYPES.includes(entity.type) ? entity : getParentCanvasEntity(entity);
		const canvasParent = getParentCanvasEntity(entity);
		const layout = this.resolveInitialChildrenPositions(
			canvasParent,
			flattenRelatedCanvasElementsOnTheRight(entity),
			changeSet
		);

		this.canvasLayout.push(...layout);

		const canvasElement = this.getElement(canvasParent.id);

		// Add itself to deffered elements to connect, so once the children are rendered, it can be connected to them
		this.deferConnections(canvasElement);

		const newCanvasEntities = await this.render(layout, {
			skipConnections: true
		});

		// Animate the elements of the draggable objects from the x and y position of its parent to its final position
		await Promise.all(
			newCanvasEntities.map((canvasEntity) => {
				const finalX = canvasEntity.entity.x;
				const finalY = canvasEntity.entity.y;

				return this.animateDraggableMovementAsync(
					canvasEntity,
					{ x: canvasParent.x, y: canvasParent.y },
					{ x: finalX, y: finalY }
				);
			})
		);

		this.connectDefferedEntities();

		onEnd?.();
	}

	// This function removes the elements from the screen, but it doesn't delete them from the project state
	// It doesn't remove the given entity, only its children entities
	async removeFromExisting(entity: CanvasEntityState, onEnd?: () => void) {
		const childrenEntitiesOnTheRight =
			flattenRelatedCanvasElementsOnTheRight(entity);

		const canvasEntities = childrenEntitiesOnTheRight.map((ent) =>
			this.getElement(ent.id)
		);

		await Promise.all(
			canvasEntities.map((canvasEntity) => {
				// We hide them, until they get removed,
				// so they don't look bad during the animation of the cards retreating
				canvasEntity.draggableObject.connections.forEach(
					(connection) => {
						connection.element.style.visibility = 'hidden';

						if (connection.complementaryLineElement) {
							connection.complementaryLineElement.style.visibility =
								'hidden';
						}
					}
				);

				// Animate the removal of the draggable objects from its original position to the parent position
				return this.animateDraggableMovementAsync(
					canvasEntity,
					{ x: canvasEntity.entity.x, y: canvasEntity.entity.y },
					{ x: entity.x, y: entity.y },
					'animate-draggable-card-hide'
				);
			})
		);

		// Map the original coordinates into the entity states
		await Promise.all(
			canvasEntities.map((canvasEntity, index) => {
				return this.removeCanvasEntityElement(canvasEntity, {
					quiet: true
				});
				// canvasEntity.entity.metaSync(originalCoordinates[index], null);
			})
		);

		const canvasParent = getParentCanvasEntity(entity);
		const canvasElement = this.getElement(canvasParent.id);

		canvasElement.draggableObject.updateConnections();

		onEnd?.();
	}

	async removeCanvasEntityElement(
		canvasElement: CanvasEntityElement,
		removeOptions: { quiet: boolean } = { quiet: false }
	) {
		await canvasElement.remove(removeOptions);

		delete this.elements[canvasElement.entity.id];

		this.canvasLayout = this.canvasLayout.filter((canvasEntity) => {
			return canvasEntity.id !== canvasElement.entity.id;
		});
	}

	disableAllConnections(canvasObject: DraggableObject | CanvasObject) {
		// Disable all the connections if the object is already marked as disabled for another reason
		canvasObject.connections.forEach((connection) => {
			if (!connection.disabled) {
				connection.disable();
				connection.element.classList.add('disabled');

				if (connection.complementaryLineElement) {
					connection.complementaryLineElement.classList.add(
						'disabled'
					);
				}
			}
		});
	}

	enableAllConnections(canvasObject: DraggableObject | CanvasObject) {
		// Enable all the connections if the object is already marked as disabled for another reason
		canvasObject.connections.forEach((connection) => {
			if (connection.disabled) {
				connection.enable();
				connection.element.classList.remove('disabled');

				if (connection.complementaryLineElement) {
					connection.complementaryLineElement.classList.remove(
						'disabled'
					);
				}
			}
		});
	}

	async enrichPersistedValueFromPrimaryKey(
		primaryKeyValue: string | number,
		persistedEntity: DefinitionEntityState
	): Promise<{ [key: string]: any } | null> {
		try {
			if (
				!primaryKeyValue ||
				!persistedEntity ||
				!checkHasBaseEntity(
					persistedEntity,
					BaseEntityNames.PERSISTED_ENTITY
				)
			) {
				return null;
			}

			const databaseClient =
				this.localDatabaseStore?.getDatabaseForPersistedEntity(
					persistedEntity
				);

			if (!databaseClient) {
				return null;
			}

			const persistedEntityDbTableName = toPascalCase(
				resolveEntityName(persistedEntity, this.logic)
			);

			const primaryKeyProperty: PropertyState =
				resolvePrimaryKeyProperty(persistedEntity);

			const primaryKeyColumnName =
				primaryKeyProperty.codeName ||
				toCamelCase(resolveEntityName(primaryKeyProperty, this.logic));

			const rows = await databaseClient.select({
				from: persistedEntityDbTableName,
				where: {
					[primaryKeyColumnName]: primaryKeyValue
				}
			});

			return rows[0] || null;
		} catch (error) {
			return null;
		}
	}

	async publish() {
		// Check if there is already a running publication for the project, if so, we don't allow to publish again until it's finished
		if (
			this.publication &&
			this.publication.status === PublicationStatus.Running
		) {
			popupNotification({
				text: 'Your project is already being published. Please wait until the current publication is finished before starting a new one.'
			});

			// Redirect to existing publication
			EditorService.navigate(
				`${this.editorBasePath}/publication/publication-sequence/${this.publication.id}`
			);

			return;
		}

		const [accessToken, refreshToken] = await Promise.all([
			this.getAccessToken(),
			this.getRefreshToken()
		]);

		Logger.log('Sending publish message to server');
		this.socket.send({
			action: DTOAction.PublishProjectV1,
			actionId: null, // Will be set by the server
			userAuthor: ProjectState.sessionAuthor,
			agentAuthor: null,
			emittedAt: new Date().toISOString(),
			channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
			sessionId: this.sessionId as string,
			authorization: 'Bearer ' + accessToken,
			refreshToken: refreshToken,
			type: LiveMessageEventType.Post,
			workspaceId: this.activeWorkspace?.id,
			event: null,
			message: null,
			payload: {
				projectId: this.projectId,
				version: this.logic?.version,
				envIdentifier: this.branchHead?.identifier || 'main'
			}
		});
	}

	async loadGivenPublication(publicationId: string): Promise<PublicationRun> {
		const response = await axios.get(
			`${envConfig.API_BASE_URL}/publishing-service/v1/${this.projectId}/publications/${publicationId}`,
			{
				headers: {
					Authorization: 'Bearer ' + (await this.getAccessToken())
				}
			}
		);

		const pub = this.enrichPublication(response.data as IPublication);

		this.publication = pub;

		this.emit('specific-publication-loaded', pub);

		return pub;
	}

	enrichPublication(publication: IPublication): PublicationRun {
		const publicationRun = new PublicationRun(publication, this);

		publicationRun.setSteps(
			// @ts-ignore
			publication.steps || [],
			publication.updatedAt || new Date().toISOString()
		);

		publicationRun.steps.sort((a, b) => {
			// Sort by 'index' ascending
			return a.index - b.index;
		});

		return publicationRun;
	}

	enrichPublications(publications: IPublication[]): PublicationRun[] {
		// Order by updatedAt desc
		const safePublications = [...publications].sort((a, b) => {
			return dayjs(b.updatedAt).diff(dayjs(a.updatedAt));
		});

		return safePublications.map((pub) => {
			return this.enrichPublication(pub);
		});
	}

	async loadPublications(options: { offset?: number } = {}) {
		const offset = options?.offset ?? this.publications.length;

		const { data } = await axios.get<{
			items: IPublication[];
		}>(
			`${envConfig.API_BASE_URL}/publishing-service/v1/publications/${this.projectId}?limit=15&offset=${offset}`,
			{
				headers: {
					Authorization: `Bearer ${await this.getAccessToken()}`
				}
			}
		);

		const allPublications = data.items as IPublicationRunContext[];

		Logger.log('Fetched publications: ', allPublications);

		// Order by updatedAt desc
		allPublications.sort((a, b) => {
			return dayjs(b.updatedAt).diff(dayjs(a.updatedAt));
		});

		this.publications = this.enrichPublications(allPublications);

		const runningPublication = this.publications.find((pub) => {
			return pub.status === PublicationStatus.Running;
		});

		if (runningPublication) {
			this.loadGivenPublication(runningPublication.id);

			// Add notification
			notifications.push(
				this.PROJECT_NOTIFICATIONS_CHANNEL,
				{
					types: [],
					severity: NotificationSeverity.Info,
					title: 'Publication started',
					message: 'Your project is being published',
					action: {
						type: NotificationActionType.InternalNavigation,
						// Canvas object id to scroll to
						value: `${this.editorBasePath}/publication/publication-sequence/${runningPublication.id}`
					}
				},
				'publication-started--' + runningPublication.id
			);
		}

		Logger.log('All publications: ', this.publications);
		Logger.log('Running publication: ', runningPublication);
	}

	// Fetch the list of all publications currently live for the project
	async loadLivePublications() {
		const { data } = await axios.get<{
			items: IPublication[];
		}>(
			`${envConfig.API_BASE_URL}/publishing-service/v1/live-versions/${this.projectId}?limit=15&offset=0`,
			{
				headers: {
					Authorization: `Bearer ${await this.getAccessToken()}`
				}
			}
		);

		Logger.log('Live publications response: ', data);

		const allPublications = data.items as IPublication[];
		this.livePublishedVersions = this.enrichPublications(allPublications);
	}

	async loadLiveResources() {
		try {
			const { data } = await axios.get<{
				data: { resources: InfrastructureResource[] };
			}>(
				`${envConfig.API_BASE_URL}/publishing-service/v1/resources/${this.projectId}`,
				{
					headers: {
						Authorization: `Bearer ${await this.getAccessToken()}`
					}
				}
			);

			const allResources = data.data
				.resources as InfrastructureResource[];

			this.liveResources = allResources;

			Logger.log('Live resources: ', allResources);
			this.emit('live-resources-loaded', {
				liveResources: allResources
			});
		} catch (error: any) {
			popupNotification({
				text:
					'Error loading live resources: ' +
					((error?.message as string) || 'unknown'),
				color: 'error'
			});
			Logger.error('Error loading live resources: ', error);
			this.liveResources = [];
			this.emit('live-resources-loaded', {
				liveResources: []
			});
		}
	}

	requestExtension<T = any>(moduleId: string): IRegisteredExtension<T> {
		return this.extensionsRegistry.requestExtension<T>(
			moduleId
		) as IRegisteredExtension<T>;
	}

	requestActiveDynamicValue(
		valueOwner: EntityWithValueState,
		onlyDefault = false
	): IDynamicValue | null {
		if (this.destroyed) {
			return null;
		}
		return (
			resolveValue(valueOwner, this?.test || this, onlyDefault) || null
		);
	}

	async initRegistry(): Promise<ExtensionsRegistry<EditorService>> {
		this.extensionsRegistry = new ExtensionsRegistry<EditorService>(
			this.events
		);
		await this.extensionsRegistry.setup();
		await this.registerNonDefaultLocalImplementationsOfModules();

		this.extensionsRegistry.onResolveEditorContext(() => {
			return this;
		});

		this.editorUIContext = new EditorUIContext(
			this.extensionsRegistry,
			this
		);

		this.extensionsRegistry.onResolveGUIContext(() => {
			return this.editorUIContext;
		});

		await this.extensionsRegistry.contextAvailable(
			ExtensionContextType.Editor
		);

		return this.extensionsRegistry;
	}

	async deleteProjectCache({
		onBeforeReload,
		skipReload
	}: { onBeforeReload?: () => void; skipReload?: boolean } = {}) {
		await axios.delete(
			`${envConfig.API_BASE_URL}/editor-service/v1/remove-project-cache/${this.projectId}`,
			{
				headers: {
					Authorization: 'Bearer ' + (await getAccessToken())
				}
			}
		);

		onBeforeReload?.();

		if (skipReload) {
			return;
		}

		window.location.reload();
	}

	getValueTypePreference(
		valueOwnerId: EntityId
	): DynamicValueTypes.DefaultValue | DynamicValueTypes.Testing | null {
		// Check local storage for preference
		const storedPreference = window.localStorage.getItem(
			'dynamic-value-type-preference--' + valueOwnerId
		);

		return (
			(storedPreference as
				| DynamicValueTypes.DefaultValue
				| DynamicValueTypes.Testing) || null
		);
	}

	setValueTypePreference(
		valueOwnerId: EntityId,
		valueTypePreference:
			| DynamicValueTypes.DefaultValue
			| DynamicValueTypes.Testing
			| null
	) {
		// Store preference in local storage
		window.localStorage.setItem(
			'dynamic-value-type-preference--' + valueOwnerId,
			valueTypePreference?.toString() || ''
		);

		// Emit event
		this.emit(valueOwnerId, {});
	}

	async downloadCode(
		options: {
			version: string | 'latest' | 'live';
			onAck?: () => void;
			onPresignedUrl?: (url: string) => Promise<void> | void;
			onProcessError?: (error: Error) => void;
			onDownloadError?: (error: Error) => void;
		} = { version: 'latest' }
	) {
		const [accessToken, refreshToken] = await Promise.all([
			this.getAccessToken(),
			this.getRefreshToken()
		]);

		// Prepare WS payload
		const actionId = ProjectState.UUID.uuid();

		const wsMessage: ILiveMessageDTO<
			'download-code-v1',
			null,
			{
				projectId: string;
				version: string;
			}
		> = {
			action: 'download-code-v1',
			actionId,
			userAuthor: ProjectState.sessionAuthor,
			agentAuthor: null,
			emittedAt: new Date().toISOString(),
			channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
			sessionId: this.sessionId as string,
			authorization: 'Bearer ' + accessToken,
			refreshToken: refreshToken,
			workspaceId: this.activeWorkspace?.id,
			type: LiveMessageEventType.Get,
			event: null,
			message: null,
			payload: {
				// Here payload goes
				projectId: this.projectId,
				version: options.version
			}
		};

		// Fire WS message and await only the ACK (or an error) for this actionId
		// const ACK_TIMEOUT_MS = 15000;

		const stringifiedFullMessage = JSON.stringify(wsMessage);
		const messageSizeInBytes = new TextEncoder().encode(
			stringifiedFullMessage
		).length;

		Logger.log(
			'Full WS persist change-set message size in bytes: ',
			messageSizeInBytes
		);

		return await new Promise<void>((resolve, reject) => {
			let settled = false;

			const onMessage = (msg: ILiveMessageDTO) => {
				if (
					msg?.actionId !== actionId ||
					msg?.action !== 'download-code-v1'
				) {
					return;
				}

				if (msg.type === LiveMessageEventType.Acknowledgement) {
					options.onAck?.();
				} else if (msg.type === LiveMessageEventType.Error) {
					settled = true;
					this.socket.off('message', onMessage);
					// clearTimeout(timer);
					popupNotification({
						text:
							'Error preparing code download: ' +
							(msg.event || 'unknown'),
						color: 'error'
					});
					reject(
						new Error(
							'WS persist change-set error: ' +
								(msg.event || 'unknown-error')
						)
					);
				} else if (msg.type === LiveMessageEventType.Complete) {
					settled = true;
					this.socket.off('message', onMessage);

					if (options.onPresignedUrl) {
						const res = options.onPresignedUrl(
							msg.payload.presignedUrl
						);

						if (res instanceof Promise) {
							res.then(() => {
								resolve();
							}).catch(() => {});
						} else {
							resolve();
						}
					} else {
						download(
							msg.payload.presignedUrl
							// `version_${msg.payload?.version || options.version}.zip`,
						)
							.then(() => {
								resolve();
							})
							.catch((error) => {
								popupNotification({
									text:
										'Error downloading code: ' +
										(error.message || 'unknown'),
									color: 'error'
								});
								reject(
									new Error(
										'Error downloading code zip: ' +
											error.message
									)
								);
							});
					}
				}
			};

			this.socket.on('message', onMessage);

			// Safe size
			this.socket.send(wsMessage);
		});
	}

	/**
	 * A websocket action, which implements a given feature (group of logic) into the current project
	 * It will initialize a backend process which will communicate back to this client through change-sets
	 * So the processing of the response is automatic, no custom logic needed.
	 *
	 * @param featureId
	 */
	async implementFeature(
		featureId: string
	): Promise<PersistChangeSetEntityActionRequestPayload> {
		Logger.log('Sending implement feature message to server: ', featureId);
		const actionId = ProjectState.UUID.uuid();

		popupNotification({
			text: 'Started implementing feature.'
		});

		const [accessToken, refreshToken] = await Promise.all([
			this.getAccessToken(),
			this.getRefreshToken()
		]);

		this.socket.send({
			action: DTOAction.ImplementFeatureV1,
			actionId: actionId,
			userAuthor: ProjectState.sessionAuthor,
			agentAuthor: null,
			emittedAt: new Date().toISOString(),
			channel: this.PROJECT_NOTIFICATIONS_CHANNEL,
			sessionId: this.sessionId as string,
			authorization: 'Bearer ' + accessToken,
			refreshToken: refreshToken,
			type: LiveMessageEventType.Post,
			event: null,
			workspaceId: this.activeWorkspace?.id,
			message: null,
			payload: {
				projectId: this.projectId,
				featureId,
				branch: this.branchHead?.branchId
			}
		});

		// Wait for the change-set event confirming or rejecting the feature implementation
		const changeSetTransfer =
			new Promise<PersistChangeSetEntityActionRequestPayload>(
				(resolve, reject) => {
					this.on(
						'applied-external-change-set',
						(
							message: PersistChangeSetEntityActionRequestPayload
						) => {
							if (message.actionId === actionId) {
								resolve(message);
							}
						}
					);

					this.on(
						'applied-external-change-set-failed',
						(
							message: PersistChangeSetEntityActionRequestPayload
						) => {
							if (message.actionId === actionId) {
								reject(
									new Error('Feature implementation failed.')
								);
							}
						}
					);
				}
			);

		popupNotification({
			text: 'Feature implemented successfully.',
			color: 'success'
		});

		return changeSetTransfer;
	}

	enableCanvasGlobally() {
		if (!this.destroyed) {
			if (!!this.canvas) {
				this.canvas.disabled = false;
				this.canvas.canvasElement?.classList.remove(
					'globally-disabled'
				);
				this.canvas?.enableAllConnections();
			}
			this.emit('canvas-globally-enabled', {});
		}
	}

	disableCanvasGlobally() {
		if (!this.destroyed) {
			if (!!this.canvas) {
				this.canvas.disabled = true;
				this.canvas.canvasElement?.classList.add('globally-disabled');
				this.canvas?.disableAllConnections();
			}
			this.emit('canvas-globally-disabled', {});
		}
	}

	async loadInitialBranchHead(): Promise<IActiveBranchHeadResult | null> {
		try {
			const response = await axios.get(
				`${this.env.API_BASE_URL}/editor-service/v1/project/${this.projectId}/branch-head?identifier=${this.viewingBranch}`,
				{
					headers: {
						Authorization: 'Bearer ' + (await this.getAccessToken())
					}
				}
			);

			this.branchHead = response.data?.data as IActiveBranchHeadResult;
			return this.branchHead;
		} catch (error) {
			Logger.error('Error loading initial branch head: ', error);
			this.branchHead = null;
		}

		return null;
	}

	async getProjectRoles({
		accessToken
	}: {
		accessToken?: string;
	} = {}): Promise<IRichProjectRoleDTO[]> {
		const token = accessToken || (await this.getAccessToken());

		try {
			const response = await axios.get(
				`${envConfig.API_BASE_URL}/editor-service/v1/project/${this.projectId}/roles`,
				{
					headers: { Authorization: 'Bearer ' + token }
				}
			);

			const roles = response.data.items as IRichProjectRoleDTO[];
			this.roles = roles;

			return this.roles;
		} catch (error) {
			Logger.log("Error getting the project's roles: ", error);
		}

		return [];
	}
}
